export * from '@mui/material/Container';
export * from '@mui/material/Grid';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { generateUtilityClasses, styled, Breadcrumbs as Breadcrumbs$1, alpha, Link, Typography, Button as Button$1, CircularProgress, ButtonGroup as ButtonGroup$1, Chip as Chip$1, Box, Stack, IconButton, useTheme, TextField as TextField$1, Dialog as Dialog$1, DialogContent, Divider as Divider$1, DialogActions, useMediaQuery, LinearProgress, Grid as Grid$1, Card, CardMedia, Container as Container$1, SvgIcon, Backdrop, keyframes, Skeleton, CardContent, Accordion as Accordion$1, AccordionSummary as AccordionSummary$1, AccordionDetails as AccordionDetails$1, Drawer as Drawer$1, MenuItem, FormControl, InputLabel, Select as Select$1, Checkbox, Tabs, TabScrollButton, Collapse, Tab, Avatar, Popover } from '@mui/material';
import classNames from 'classnames';
import * as React from 'react';
import React__default, { forwardRef, useState, useCallback, createContext, useContext, useRef, cloneElement, createRef, useEffect, isValidElement, Children } from 'react';
import { faXmark, faEyeSlash, faPhone, faEnvelope, faCalendarDay, faChevronLeft, faChevronRight, faCaretDown, faCircleCheck, faLocationDot, faGaugeSimple, faCalendar, faAngleDown, faAngleRight, faPaperPlane, faCircleInfo, faCircleExclamation, faCircleXmark, faCaretLeft, faCaretRight, faInfo, faEye } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { styled as styled$1, alpha as alpha$1 } from '@mui/material/styles';
import { DatePicker as DatePicker$1, LocalizationProvider as LocalizationProvider$1 } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import theme from '@grimme/theme';
import lottie from 'lottie-web';
import Image from 'next/image';
import { useSnackbar, SnackbarProvider } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { createEntityAdapter, createSlice, createSelector } from '@reduxjs/toolkit';
import Link$1 from 'next/link';
import styled$2 from '@emotion/styled';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const classes$M = generateUtilityClasses('GC-Breadcrumbs', ['root', 'light', 'dark', 'breadcrumb', 'item', 'active']);
const StyledBreadcrumbs = styled(Breadcrumbs$1)(({
  theme
}) => ({
  [`&.${classes$M.root}`]: {
    a: {
      textDecoration: 'none'
    }
  },
  [`& .${classes$M.breadcrumb}`]: {
    textDecoration: 'none'
  },
  [`& .${classes$M.item}`]: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    svg: {
      display: 'block',
      margin: 'auto',
      height: 15,
      width: 15
    }
  },
  [`&.${classes$M.light}`]: {
    [`& .${classes$M.item}`]: {
      color: alpha(theme.palette.common.black, 0.5),
      '&:hover': {
        color: theme.palette.common.black
      }
    },
    [`& .${classes$M.active}`]: {
      color: theme.palette.common.black
    }
  },
  [`&.${classes$M.dark}`]: {
    [` .${classes$M.item}`]: {
      color: alpha(theme.palette.common.white, 0.5),
      '&:hover': {
        color: theme.palette.common.white
      }
    },
    [`& .${classes$M.active}`]: {
      color: theme.palette.common.white
    }
  }
}));
const Breadcrumb = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      active,
      children
    } = props,
    rest = __rest(props, ["active", "children"]);
  return jsx(Link, Object.assign({
    className: classes$M.breadcrumb,
    ref: ref
  }, active ? {
    'aria-current': 'page'
  } : {}, rest, {
    children: jsx(Typography, Object.assign({
      variant: "overline",
      className: classNames(classes$M.item, {
        [classes$M.active]: active
      })
    }, {
      children: children
    }))
  }));
});
const Breadcrumbs = props => {
  const {
      children,
      className,
      variant = 'light'
    } = props,
    rest = __rest(props, ["children", "className", "variant"]);
  return jsx(StyledBreadcrumbs, Object.assign({
    "aria-label": "breadcrumb",
    className: classNames(classes$M.root, classes$M[variant], className),
    separator: jsx(Typography, Object.assign({
      color: variant === 'dark' ? 'common.white' : 'common.black',
      variant: "overline"
    }, {
      children: "|"
    }))
  }, rest, {
    children: children
  }));
};

const classes$L = generateUtilityClasses('GC-Button', ['loading', 'small']);
const StyledButton = styled(Button$1)(({
  theme
}) => ({
  [`&.${classes$L.small}`]: Object.assign({}, theme.typography.button2),
  // Loading State
  [`&.${classes$L.loading}`]: {
    color: alpha(theme.palette.common.white, 0),
    pointerEvents: 'none',
    '.MuiCircularProgress-root': {
      color: theme.palette.common.white
    },
    '.MuiButton-endIcon, .MuiButton-startIcon': {
      color: alpha(theme.palette.common.white, 0)
    }
  },
  // Loading State for Primary Button
  [`&.MuiButton-primary.${classes$L.loading}`]: {
    '&:hover, &:focus': {
      '.MuiCircularProgress-root': {
        color: theme.palette.primary.main
      }
    }
  },
  // Loading State for Secondary Button with dark modifier
  [`&.MuiButton-secondary.${classes$L.loading}`]: {
    '.MuiCircularProgress-root': {
      color: theme.palette.common.black
    },
    '&:hover, &:focus': {
      '.MuiCircularProgress-root': {
        color: theme.palette.common.white
      }
    }
  },
  [`&.MuiButton-secondary[modifier=dark].${classes$L.loading}`]: {
    '.MuiCircularProgress-root': {
      color: theme.palette.common.white
    },
    '&:hover, &:focus': {
      '.MuiCircularProgress-root': {
        color: theme.palette.common.black
      }
    }
  },
  // Loading State for Text Button
  [`&.MuiButton-text.${classes$L.loading}`]: {
    '.MuiCircularProgress-root': {
      color: theme.palette.grey[400]
    }
  },
  // Loading State for Disabled Button
  [`&[disabled].${classes$L.loading}`]: {
    '.MuiCircularProgress-root': {
      color: theme.palette.grey[400]
    }
  }
}));

const Button = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      children,
      className,
      small = false,
      loading
    } = props,
    rest = __rest(props, ["children", "className", "small", "loading"]);
  return jsxs(StyledButton, Object.assign({
    className: classNames({
      [classes$L.small]: small,
      [classes$L.loading]: loading
    }, className),
    focusRipple: true,
    ref: ref
  }, rest, {
    children: [children, loading && jsx(CircularProgress, {
      size: 24,
      sx: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-12px',
        marginLeft: '-12px'
      }
    })]
  }));
});

const classes$K = generateUtilityClasses('GC-ButtonGroup', ['root', 'button', 'dark', 'light', 'selected', 'smallFont', 'stretch']);
const StyledButtonGroup = styled(ButtonGroup$1)(({
  theme
}) => ({
  [`& .${classes$K.button}`]: Object.assign(Object.assign({
    padding: theme.spacing(1.5, 2)
  }, theme.typography.button1), {
    [`&.${classes$K.smallFont}`]: Object.assign({}, theme.typography.button2),
    [`&.${classes$K.dark}`]: {
      color: theme.palette.grey[300],
      borderColor: theme.palette.grey[400],
      '&:hover': {
        color: theme.palette.common.white,
        background: 'rgba(255, 255, 255, 0.1) '
      }
    },
    [`&.${classes$K.light}`]: {
      borderColor: theme.palette.grey[200],
      color: theme.palette.grey[400],
      '&:hover': {
        color: theme.palette.common.black,
        background: 'rgba(0, 0, 0, 0.1) '
      }
    },
    [`&.${classes$K.selected}`]: {
      [`&.${classes$K.light}`]: {
        color: theme.palette.common.black,
        borderColor: theme.palette.common.black
      },
      [`&.${classes$K.dark}`]: {
        color: theme.palette.common.white,
        borderColor: theme.palette.common.white
      },
      '& + button': {
        [`&.${classes$K.dark}`]: {
          borderLeftColor: theme.palette.common.white
        },
        [`&.${classes$K.light}`]: {
          borderLeftColor: theme.palette.common.black
        }
      }
    }
  }),
  [`& .${classes$K.stretch}`]: {
    flexGrow: 1
  }
}));
const ButtonGroup = props => {
  const {
    onClick,
    selected,
    fullWidth,
    modifier = 'light',
    smallFont = false,
    values
  } = props;
  return jsx(StyledButtonGroup, Object.assign({
    color: "inherit",
    "aria-label": "medium secondary button group",
    size: "small",
    className: classes$K.root,
    sx: {
      width: '100%',
      display: 'flex'
    }
  }, {
    children: values.map((value, index) => jsx(Button$1, Object.assign({
      className: classNames(classes$K.button, {
        [classes$K.selected]: value.toLowerCase() === selected.toLowerCase(),
        [classes$K[modifier]]: modifier,
        [classes$K.stretch]: fullWidth,
        [classes$K.smallFont]: smallFont
      }),
      onClick: e => {
        onClick(e, value);
      }
    }, {
      children: value
    }), value))
  }));
};

const classes$J = generateUtilityClasses('GC-Chip', ['dark', 'deleteIcon', 'label', 'light', 'selected']);
const StyledMuiChip = styled(Chip$1)(({
  theme
}) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '30px',
  height: '30px',
  padding: theme.spacing(0.5, 2),
  textTransform: 'uppercase',
  width: 'fit-content',
  span: {
    padding: 0
  },
  '&:hover': {
    border: `1px solid ${theme.palette.primary.main}`
  },
  [`& .${classes$J.deleteIcon}`]: {
    fontSize: '18px',
    marginLeft: theme.spacing(2),
    marginRight: 0
  },
  [`&.${classes$J.dark}`]: {
    backgroundColor: alpha(theme.palette.common.white, 0.1),
    '&:hover': {
      [`& .${classes$J.label}`]: {
        color: theme.palette.common.white
      }
    },
    [`& .${classes$J.label}`]: {
      color: theme.palette.grey[200]
    },
    [`&.${classes$J.selected}`]: {
      [`& .${classes$J.deleteIcon}`]: {
        color: theme.palette.common.white
      },
      [`& .${classes$J.label}`]: {
        color: theme.palette.common.white
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.1)
      }
    }
  },
  [`&.${classes$J.light}`]: {
    backgroundColor: alpha(theme.palette.grey[300], 0.1),
    '&:hover': {
      [`& .${classes$J.label}`]: {
        color: theme.palette.primary.main
      }
    },
    [`& .${classes$J.label}`]: {
      color: theme.palette.grey[400]
    },
    [`&.${classes$J.selected}`]: {
      [`& .${classes$J.deleteIcon}`]: {
        color: theme.palette.primary.main
      },
      [`& .${classes$J.label}`]: {
        color: theme.palette.primary.main
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.grey[300], 0.1)
      }
    }
  },
  [`&.${classes$J.selected}`]: {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    border: `1px solid ${theme.palette.primary.main}`
  }
}));

const Chip = props => {
  const {
      className,
      label,
      modifier = 'light',
      onDelete,
      selected = false
    } = props,
    rest = __rest(props, ["className", "label", "modifier", "onDelete", "selected"]);
  return jsx(StyledMuiChip, Object.assign({
    className: classNames({
      [classes$J.selected]: selected || onDelete,
      [classes$J[modifier]]: modifier
    }, className),
    deleteIcon: jsx(FontAwesomeIcon, {
      className: classes$J.deleteIcon,
      icon: faXmark
    }),
    label: jsx(Typography, Object.assign({
      className: classes$J.label,
      variant: "overline"
    }, {
      children: label
    })),
    onDelete: onDelete
  }, rest));
};

const avatarSizeForMobile = '48px';
const avatarSizeForDesktop = '64px';
const chipsSizeForMobile = '40px';
const chipsSizeForDesktop = '48px';

const classes$I = generateUtilityClasses('GC-ContactAssistantIntroduction', ['root', 'open', 'visible', 'avatar', 'avatarIcon', 'detailsContent', 'shrink']);
const Root$e = styled$1('div')(({
  theme
}) => ({
  [`& .${classes$I.root}`]: {
    alignItems: 'center',
    background: theme.palette.background.paper,
    borderRadius: '40px',
    bottom: 0,
    boxShadow: theme.ourShadows.dialog,
    display: 'flex',
    flexDirection: 'row',
    height: '10px',
    minWidth: 0,
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    right: 0,
    transition: [theme.transitions.create('all', {
      duration: '0.3s',
      delay: '0.3s'
    }), theme.transitions.create('opacity', {
      duration: '0.3s'
    })].join(', '),
    width: '10px',
    [theme.breakpoints.up('md')]: {
      height: '10px',
      width: '10px'
    }
  },
  [`& .${classes$I.open}`]: {
    minWidth: 'max-content',
    paddingRight: avatarSizeForMobile,
    transition: theme.transitions.create('all', {
      duration: '0.3s'
    }),
    [theme.breakpoints.up('md')]: {
      minWidth: 312,
      paddingRight: avatarSizeForDesktop
    },
    [`& .${classes$I.detailsContent}`]: {
      opacity: 1,
      minWidth: 'fill-available',
      transition: theme.transitions.create('opacity', {
        duration: '0.3s',
        delay: '0.3s'
      })
    }
  },
  [`& .${classes$I.visible}`]: {
    opacity: 1,
    height: avatarSizeForMobile,
    width: avatarSizeForMobile,
    [theme.breakpoints.up('md')]: {
      height: avatarSizeForDesktop,
      width: avatarSizeForDesktop
    }
  },
  [`& .${classes$I.avatar}`]: {
    bottom: 0,
    boxShadow: theme.ourShadows.dialog,
    padding: theme.spacing(0),
    position: 'absolute',
    right: 0
  },
  [`& .${classes$I.avatarIcon}`]: {
    borderRadius: '50%',
    height: avatarSizeForMobile,
    transition: theme.transitions.create(['all'], {
      duration: '0.3s'
    }),
    width: avatarSizeForMobile,
    [theme.breakpoints.up('md')]: {
      height: avatarSizeForDesktop,
      width: avatarSizeForDesktop
    }
  },
  [`& .${classes$I.detailsContent}`]: {
    margin: theme.spacing(1, 2.5),
    opacity: 0,
    p: {
      lineHeight: 1.2
    },
    transition: theme.transitions.create('opacity', {
      duration: '0.2s',
      delay: '0.2s'
    }),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2, 3)
    }
  },
  [`& .${classes$I.shrink}`]: {
    height: '10px',
    width: '10px',
    [theme.breakpoints.up('md')]: {
      height: '20px',
      width: '20px'
    }
  }
}));

const ContactAssistantIntroduction = props => {
  const {
      details,
      iconAltText,
      onAvatarClick,
      open = false,
      visible = false
    } = props,
    rest = __rest(props, ["details", "iconAltText", "onAvatarClick", "open", "visible"]);
  return jsxs(Root$e, Object.assign({}, rest, {
    children: [jsx(Box, Object.assign({
      className: classNames(classes$I.root, {
        [classes$I.open]: open,
        [classes$I.visible]: visible
      })
    }, {
      children: jsxs(Stack, Object.assign({
        "data-testid": "ca-text",
        className: classes$I.detailsContent
      }, {
        children: [jsx(Typography, Object.assign({
          component: "p",
          variant: "body2",
          color: "common.black"
        }, {
          children: jsx("strong", {
            children: details.name
          })
        })), jsx(Typography, Object.assign({
          component: "p",
          variant: "caption",
          color: "grey.400"
        }, {
          children: details.description
        }))]
      }))
    })), jsx(IconButton, Object.assign({
      className: classes$I.avatar,
      "data-testid": "ca-picture",
      onClick: onAvatarClick
    }, {
      children: jsx("img", {
        alt: iconAltText !== null && iconAltText !== void 0 ? iconAltText : 'Open/Close',
        className: classNames(classes$I.avatarIcon, {
          [classes$I.shrink]: !visible
        }),
        src: details.avatar
      })
    }))]
  }));
};

const classes$H = generateUtilityClasses('GC-ContactAssistant', ['avatar', 'checkboxWrapper', 'confirmButton', 'contactAssistantWrapper', 'contactIcons', 'details', 'indented', 'link', 'links', 'linkSuffixIcon', 'linkTitle', 'open', 'paddedContactAssistantWrapper', 'root', 'visibility', 'visible']);
const Root$d = styled$1('div')(({
  theme
}) => ({
  [`&.${classes$H.root}`]: {
    height: avatarSizeForMobile,
    opacity: 0,
    position: 'fixed',
    right: theme.spacing(2.5),
    top: theme.spacing(2.5),
    transition: theme.transitions.create(['all'], {
      duration: '0.5s'
    }),
    width: avatarSizeForMobile,
    zIndex: 9,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: avatarSizeForDesktop,
      width: avatarSizeForDesktop
    }
  },
  [`&.${classes$H.indented}`]: {
    right: theme.spacing(9)
  },
  [`&.${classes$H.open}`]: Object.assign({
    [`& .${classes$H.links}`]: {
      maxHeight: 999,
      transition: theme.transitions.create('max-height', {
        delay: '0.2s',
        duration: '0.2s'
      })
    },
    [`& .${classes$H.linkTitle}`]: {
      margin: theme.spacing('auto', 1.5, 'auto', 3),
      maxWidth: 300,
      opacity: 1,
      [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        margin: theme.spacing('auto', 1.5, 'auto', 3),
        maxWidth: 300
      }
    }
  }, new Array(3).fill(0).map((_, i) => i + 1).reduce((acc, curr) => Object.assign(Object.assign({}, acc), {
    [`& .${classes$H.link}:nth-of-type(${curr}) .${classes$H.linkTitle}`]: {
      transition: [theme.transitions.create(['margin', 'max-width'], {
        duration: '0.2s',
        delay: `${curr * 0.1}s`
      }), theme.transitions.create('opacity', {
        duration: '0.2s',
        delay: `${curr * 0.1 + 0.2}s`
      })].join(', ')
    }
  }), {})),
  [`&.${classes$H.visible}`]: {
    bottom: theme.spacing(2),
    opacity: 1,
    right: theme.spacing(2),
    top: `calc(100% - ${theme.spacing(2)} - ${avatarSizeForMobile})`,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      top: `calc(100% - ${theme.spacing(2)} - ${avatarSizeForDesktop})`
    }
  },
  [`&.${classes$H.visible}.${classes$H.open}`]: {
    [`& ${classes$H.details}`]: {},
    [`& .${classes$H.links}`]: {},
    [`& .${classes$H.link}`]: {}
  },
  [`& .${classes$H.links}`]: {
    alignItems: 'flex-end',
    bottom: `calc(${avatarSizeForMobile} - 16px)`,
    display: 'flex',
    flexDirection: 'column-reverse',
    maxHeight: 0,
    minWidth: chipsSizeForMobile,
    overflow: 'hidden',
    paddingLeft: theme.spacing(3),
    position: 'absolute',
    right: -12,
    transition: theme.transitions.create('max-height', {
      delay: '0.2s',
      duration: '0.2s'
    }),
    button: {
      '&:first-of-type': {
        marginBottom: theme.spacing(3)
      }
    },
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      bottom: `calc(${avatarSizeForDesktop} - 8px)`,
      minWidth: chipsSizeForDesktop
    }
  },
  [`& .${classes$H.visibility}`]: {
    background: theme.palette.common.white,
    borderRadius: '50%',
    boxShadow: theme.ourShadows.dialog,
    color: theme.palette.common.black,
    height: chipsSizeForMobile,
    margin: theme.spacing(0.5, 2.125, 0.5, 0),
    width: chipsSizeForMobile,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: chipsSizeForDesktop,
      margin: theme.spacing(1, 2.375, 1, 0),
      width: chipsSizeForDesktop
    },
    '&:hover': {
      background: theme.palette.grey[200]
    }
  },
  [`& .${classes$H.link}`]: {
    background: theme.palette.background.paper,
    border: 'none',
    borderRadius: '50px',
    boxShadow: theme.ourShadows.dialog,
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(0.5, 2.125, 0.5, 0),
    minWidth: 'fill-available',
    padding: theme.spacing(0),
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      borderRadius: '48px',
      margin: theme.spacing(1, 2.375, 1, 0),
      '&:hover': {
        cursor: 'pointer'
      }
    }
  },
  [`& .${classes$H.contactIcons}`]: {
    borderRadius: '50%',
    display: 'flex',
    height: chipsSizeForMobile,
    justifyContent: 'center',
    width: chipsSizeForMobile,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      boxShadow: theme.shadows[0],
      height: chipsSizeForDesktop,
      width: chipsSizeForDesktop
    }
  },
  [`& .${classes$H.linkTitle}`]: {
    alignItems: 'flex-start',
    display: 'flex',
    margin: theme.spacing('auto', 0),
    maxHeight: 32,
    maxWidth: 0,
    opacity: 0,
    overflow: 'hidden',
    transition: theme.transitions.create('all', {
      duration: '0.2s'
    }),
    p: {
      lineHeight: 1.2
    }
  },
  [`& .${classes$H.linkSuffixIcon}`]: {
    color: theme.palette.common.black,
    height: `calc(${chipsSizeForMobile}/2)`,
    margin: 'auto',
    width: `calc(${chipsSizeForMobile}/2)`,
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
      height: `calc(${chipsSizeForDesktop}/2)`,
      width: `calc(${chipsSizeForDesktop}/2)`
    }
  }
}));

const ContactAssistant = props => {
  const {
    className,
    details,
    iconAltText,
    indented,
    links,
    onVisibilityChange,
    visible
  } = props;
  const [open, setOpen] = useState(false);
  const onClickVisibility = useCallback(e => {
    setOpen(false);
    onVisibilityChange(e);
  }, [onVisibilityChange]);
  const icons = [faPhone, faEnvelope, faWhatsapp];
  return jsxs(Root$d, Object.assign({
    "data-testid": "ca-wrapper",
    className: classNames(classes$H.root, {
      [classes$H.visible]: visible,
      [classes$H.open]: open,
      [classes$H.indented]: indented,
      [classes$H.contactAssistantWrapper]: !visible && !open,
      [classes$H.paddedContactAssistantWrapper]: !visible && open
    }, className)
  }, {
    children: [jsxs(Box, Object.assign({
      className: classes$H.links
    }, {
      children: [links.map((element, index) => jsxs(Box, Object.assign({
        className: classes$H.link,
        component: "button",
        onClick: element.onClick
      }, {
        children: [jsx(Stack, Object.assign({
          className: classes$H.linkTitle
        }, {
          children: jsx(Typography, Object.assign({
            component: "p",
            variant: "body1"
          }, {
            children: element.description
          }))
        })), jsx(Box, Object.assign({
          className: classes$H.contactIcons
        }, {
          children: jsx(FontAwesomeIcon, {
            className: classes$H.linkSuffixIcon,
            icon: icons[index]
          })
        }))]
      }), index)), jsx(Box, Object.assign({
        className: classes$H.visibility,
        component: IconButton,
        "data-testid": "visibility-icon",
        onClick: onClickVisibility
      }, {
        children: jsx(FontAwesomeIcon, {
          className: classes$H.linkSuffixIcon,
          icon: faEyeSlash
        })
      }))]
    })), jsx(ContactAssistantIntroduction, {
      className: classes$H.details,
      details: details,
      iconAltText: iconAltText,
      onAvatarClick: () => setOpen(!open),
      open: open,
      visible: visible
    })]
  }));
};

const classes$G = generateUtilityClasses('GC-TitleDivider', ['center', 'left', 'right', 'root']);
const StyledHorizontalRule = styled('hr')(({
  theme
}) => ({
  [`&.${classes$G.root}`]: {
    border: 0,
    height: theme.spacing(0.75),
    marginLeft: 0,
    marginRight: 0,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2)
    },
    '&::after': {
      border: `solid ${theme.palette.primary.main} ${theme.spacing(0.25)}`,
      background: theme.palette.primary.main,
      borderRadius: theme.shape.borderRadius,
      content: '""',
      display: 'block',
      width: theme.spacing(5)
    }
  },
  [`&.${classes$G.left}`]: {
    '&::after': {
      marginLeft: 0,
      marginRight: 'auto'
    }
  },
  [`&.${classes$G.center}`]: {
    '&::after': {
      margin: 'auto'
    }
  },
  [`&.${classes$G.right}`]: {
    '&::after': {
      marginLeft: 'auto',
      marginRight: 0
    }
  }
}));
const TitleDivider = props => {
  const {
    className,
    variant = 'left'
  } = props;
  return jsx(StyledHorizontalRule, {
    "data-testid": "divider",
    className: classNames(classes$G.root, classes$G[variant], className)
  });
};

const classes$F = generateUtilityClasses('GC-CTA-Section', ['wrapper', 'blurred', 'content']);
const Root$c = styled$1('section')(({
  theme
}) => ({
  [`&.${classes$F.wrapper}`]: {
    backgroundColor: 'black',
    padding: theme.spacing(10, 3),
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    '&::before': {
      content: '""',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      zIndex: 0
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(15, 3)
    }
  },
  [`&.${classes$F.blurred}`]: {
    '&::before': {
      backdropFilter: 'blur(2px)'
    }
  },
  [`& .${classes$F.content}`]: {
    position: 'relative',
    zIndex: 1,
    maxWidth: 800,
    marginLeft: 'auto',
    marginRight: 'auto',
    h2: {
      marginBottom: theme.spacing(2)
    },
    p: {
      marginBottom: theme.spacing(4)
    },
    [theme.breakpoints.up('lg')]: {
      p: {
        marginBottom: theme.spacing(2)
      }
    }
  }
}));
const CtasWrapper = styled$1('div')(({
  theme
}) => ({
  [`&.${classes$F.wrapper}`]: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    [theme.breakpoints.up('lg')]: {
      gap: theme.spacing(2)
    }
  }
}));

const CtasSection = props => {
  const {
    title,
    description,
    backgroundImageUrl,
    blurredBg = false,
    buttons = []
  } = props;
  const buttonsParsedMaxFour = [...buttons].splice(0, 4);
  const {
    palette
  } = useTheme();
  return jsx(Root$c, Object.assign({
    className: classNames(classes$F.wrapper, {
      [classes$F.blurred]: blurredBg
    }),
    sx: {
      backgroundImage: `url(${backgroundImageUrl})`
    },
    "data-testid": "cta-section"
  }, {
    children: jsxs("div", Object.assign({
      className: classes$F.content
    }, {
      children: [jsx(Typography, Object.assign({
        align: "center",
        color: palette.common.white,
        variant: "h2"
      }, {
        children: title
      })), jsx(Typography, Object.assign({
        align: "center",
        color: palette.common.white,
        component: "p",
        variant: "subtitle1"
      }, {
        children: description
      })), buttons.length === 0 && jsx(TitleDivider, {
        variant: "center"
      }), buttons.length > 0 && jsx(CtasWrapper, Object.assign({
        className: classes$F.wrapper
      }, {
        children: buttonsParsedMaxFour.map(button => jsx(Button, Object.assign({}, button.props, {
          children: button.label
        }), button.id))
      }))]
    }))
  }));
};

const ComponentsConfigContext = /*#__PURE__*/createContext(null);
function ComponentsConfigProvider(props) {
  const {
    t,
    language = 'de',
    children
  } = props;
  return jsx(ComponentsConfigContext.Provider, Object.assign({
    value: {
      t,
      language
    }
  }, {
    children: children
  }));
}
function useComponentsConfig() {
  return useContext(ComponentsConfigContext);
}

const classes$E = generateUtilityClasses('GC-TextField', ['fixOutline']);
const StyledTextField = styled$1(TextField$1)(({
  theme
}) => ({
  [`&.${classes$E.fixOutline}`]: {
    legend: {
      span: {
        display: 'none'
      }
    }
  },
  //TODO: Recheck the textfield component this is a temporarily fix
  '.MuiFormLabel-root': {
    paddingRight: theme.spacing(5)
  },
  '.MuiInputBase-inputAdornedEnd': {
    paddingRight: 0
  },
  '.MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
    marginLeft: 0,
    button: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.75),
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
      }
    }
  }
}));

const TextField = props => {
  const {
      className,
      label,
      modifier = 'light'
    } = props,
    rest = __rest(props, ["className", "label", "modifier"]);
  return jsx(StyledTextField, Object.assign({
    className: classNames({
      [classes$E.fixOutline]: !label
    }, className),
    label: label,
    modifier: modifier,
    size: "small",
    variant: "outlined"
  }, rest));
};

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;
const StyledCustomOpenPickerIcon = styled(FontAwesomeIcon)(_t || (_t = _`
  padding: 0 3px 0 5px;
`));
const CustomOpenPickerIcon = () => jsx(StyledCustomOpenPickerIcon, {
  icon: faCalendarDay,
  size: "xs"
});
const StyledCustomLeftArrowIcon = styled(FontAwesomeIcon)(_t2 || (_t2 = _`
  padding: 2px 4px 1px 3px;
`));
const CustomLeftArrowIcon = () => jsx(StyledCustomLeftArrowIcon, {
  icon: faChevronLeft,
  size: "sm"
});
const StyledCustomRightArrowIcon = styled(FontAwesomeIcon)(_t3 || (_t3 = _`
  padding: 2px 3px 1px 3px;
`));
const CustomRightArrowIcon = () => jsx(StyledCustomRightArrowIcon, {
  icon: faChevronRight,
  size: "sm"
});
const StyledCustomSwitchViewIcon = styled(FontAwesomeIcon)(_t4 || (_t4 = _`
  padding: 1px 4px;
`));
const CustomSwitchViewIcon = () => jsx(StyledCustomSwitchViewIcon, {
  icon: faCaretDown,
  size: "sm"
});

function DatePicker(props) {
  const {
    modifier = 'light'
  } = props;
  return jsx(DatePicker$1, Object.assign({
    components: {
      LeftArrowIcon: CustomLeftArrowIcon,
      OpenPickerIcon: CustomOpenPickerIcon,
      RightArrowIcon: CustomRightArrowIcon,
      SwitchViewIcon: CustomSwitchViewIcon
    },
    label: props.label || 'Pick a Date',
    PopperProps: {
      placement: 'bottom-end'
    },
    renderInput: params => jsx(TextField, Object.assign({
      modifier: modifier
    }, params)),
    modifier: modifier
  }, props));
}

const LocalizationProvider = (
// eslint-disable-next-line @typescript-eslint/ban-types
props) => {
  const {
    children
  } = props;
  return jsx(LocalizationProvider$1, Object.assign({
    dateAdapter: AdapterMoment
  }, {
    children: children
  }));
};

const classes$D = generateUtilityClasses('GC-Dialog', ['extraPadding', 'extraPaddingTop', 'paper', 'progress', 'rightAlign', 'subtitle', 'successful']);
const halfIconHeight = '20px';
const StyledDialog = styled(Dialog$1)(({
  theme
}) => ({
  '&.MuiDialog-root': {
    touchAction: 'none'
  },
  [`& .${classes$D.paper}`]: {
    borderRadius: theme.shape.dialog.borderRadius,
    boxShadow: theme.ourShadows.dialog,
    margin: theme.spacing(3),
    overflow: 'visible',
    padding: theme.spacing(3),
    position: 'relative',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(5)
    }
  },
  [`& .${classes$D.extraPaddingTop}`]: {
    paddingTop: `calc(${theme.spacing(3)} + ${halfIconHeight})`,
    [`&.${classes$D.extraPadding}`]: {
      paddingTop: `calc(${theme.spacing(5)} + ${halfIconHeight})`
    }
  },
  [`& .${classes$D.extraPadding}`]: {
    padding: theme.spacing(5)
  }
}));
const Icon = styled('div')(({
  theme
}) => ({
  alignItems: 'center',
  borderRadius: '50%',
  color: theme.palette.common.white,
  display: 'flex',
  height: 40,
  justifyContent: 'center',
  left: `calc(50% - ${halfIconHeight})`,
  position: 'absolute',
  top: `-${halfIconHeight}`,
  width: 40,
  '& > svg': {
    fill: theme.palette.common.white
  },
  [`&.${classes$D.successful}`]: {
    backgroundColor: theme.palette.common.white,
    '& > svg': {
      color: theme.palette.success.main,
      height: 'inherit',
      width: 'inherit'
    }
  }
}));
const Content = styled(DialogContent)(({
  theme
}) => ({
  marginLeft: theme.spacing(-1.5),
  marginRight: theme.spacing(-1.5),
  padding: theme.spacing(0, 1.5),
  scrollbarWidth: 'none',
  '& ::-webkit-scrollbar': {
    display: 'none'
  },
  [theme.breakpoints.up('md')]: {
    scrollbarWidth: 'auto',
    '& ::-webkit-scrollbar': {
      display: 'auto'
    }
  }
}));
const Divider = styled(Divider$1)(({
  theme
}) => ({
  paddingTop: theme.spacing(3)
}));
const Actions$1 = styled(DialogActions)(({
  theme
}) => ({
  alignContent: 'center',
  flexDirection: 'column-reverse',
  padding: `${theme.spacing(2)} 0 0`,
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  [`&.${classes$D.rightAlign}`]: {
    justifyContent: 'flex-end'
  }
}));
const ConfirmButton = styled(Button)(({
  theme
}) => ({
  '&:not(:first-of-type)': {
    marginLeft: 0
  },
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'unset'
  }
}));
const CloseIconButton = styled(IconButton)(({
  theme
}) => ({
  color: theme.palette.common.black,
  height: theme.spacing(6),
  position: 'absolute',
  right: 0,
  top: 0,
  width: theme.spacing(6)
}));
const StyledProgressStack = styled(Stack)(({
  theme
}) => ({
  alignItems: 'center',
  padding: theme.spacing(2, 0),
  [`& .${classes$D.progress}`]: {
    flexGrow: 1,
    height: 5,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[200],
    marginBottom: 1
  }
}));
const TitleStack = styled(Stack)(({
  theme
}) => ({
  paddingBottom: theme.spacing(2),
  [`& .${classes$D.subtitle}`]: {
    paddingBottom: theme.spacing(1)
  }
}));

function Dialog(props) {
  const {
      cancelButtonProps,
      children,
      className,
      confirmButtonProps,
      currentStep,
      dismissable = true,
      dialog,
      hasCloseIcon = false,
      icon,
      iconColor,
      labelCancel,
      labelConfirm,
      onCancel,
      onClose,
      onConfirm,
      open,
      size = 'sm',
      subtitle,
      successful = false,
      title,
      totalSteps
    } = props,
    rest = __rest(props, ["cancelButtonProps", "children", "className", "confirmButtonProps", "currentStep", "dismissable", "dialog", "hasCloseIcon", "icon", "iconColor", "labelCancel", "labelConfirm", "onCancel", "onClose", "onConfirm", "open", "size", "subtitle", "successful", "title", "totalSteps"]);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), {
    noSsr: true
  });
  const hasButtonLabel = labelCancel || labelConfirm;
  const hasIcon = Boolean(icon);
  const hasExtraPaddingTop = hasIcon || successful;
  const hasSteps = currentStep && totalSteps;
  const iconBGColor = iconColor ? iconColor : theme.palette.common.black;
  const iconElement = typeof icon === 'string' ? jsx("img", {
    alt: "",
    src: icon
  }) : icon;
  const isMDSizeAndNotMobile = size === 'md' && !isMobile;
  const linearValue = totalSteps && currentStep / totalSteps * 100;
  const rightAlignButton = Boolean(!labelCancel || !labelConfirm);
  const subtitleVariant = isMDSizeAndNotMobile ? 'body1' : 'body2';
  const titleVariant = isMDSizeAndNotMobile ? 'h3' : 'h4';
  return jsxs(StyledDialog, Object.assign({
    "aria-labelledby": "dialog-title",
    "aria-describedby": "dialog-description",
    open: open,
    onClose: (event, reason) => {
      if (!dismissable && reason === 'backdropClick') {
        return;
      }
      onClose(event, reason);
    },
    disableEscapeKeyDown: !dismissable,
    PaperProps: {
      className: classNames(classes$D.paper, {
        [classes$D.extraPaddingTop]: hasExtraPaddingTop,
        [classes$D.extraPadding]: isMDSizeAndNotMobile
      })
    },
    maxWidth: size,
    scroll: "body"
  }, rest, {
    children: [hasIcon && jsx(Icon, Object.assign({
      sx: {
        backgroundColor: iconBGColor
      }
    }, {
      children: iconElement
    })), successful && jsx(Icon, Object.assign({
      className: classes$D.successful
    }, {
      children: jsx(FontAwesomeIcon, {
        icon: faCircleCheck
      })
    })), title && jsxs(TitleStack, {
      children: [jsx(Typography, Object.assign({
        variant: titleVariant,
        className: classNames({
          [classes$D.subtitle]: subtitle
        })
      }, {
        children: title
      })), subtitle && jsx(Typography, Object.assign({
        variant: subtitleVariant
      }, {
        children: subtitle
      }))]
    }), hasSteps && jsxs(StyledProgressStack, Object.assign({
      direction: "row",
      spacing: 4
    }, {
      children: [jsx(LinearProgress, {
        className: classes$D.progress,
        value: linearValue,
        variant: "determinate"
      }), jsxs(Typography, {
        children: [currentStep, " / ", totalSteps]
      })]
    })), jsx(Content, {
      children: children
    }), hasButtonLabel && jsxs(Fragment, {
      children: [jsx(Divider, {}), jsxs(Actions$1, Object.assign({
        className: classNames({
          [classes$D.rightAlign]: rightAlignButton
        })
      }, {
        children: [labelCancel && jsx(Button, Object.assign({
          "data-testid": dialog ? dialog + '-cancel-button' : '',
          onClick: onCancel,
          variant: "text"
        }, cancelButtonProps, {
          children: labelCancel
        })), labelConfirm && jsx(ConfirmButton, Object.assign({
          "data-testid": dialog ? dialog + '-confirm-button' : '',
          onClick: onConfirm,
          variant: "primary"
        }, confirmButtonProps, {
          children: labelConfirm
        }))]
      }))]
    }), hasCloseIcon && jsx(CloseIconButton, Object.assign({
      onClick: e => onClose(e, 'closeButton')
    }, {
      children: jsx(FontAwesomeIcon, {
        icon: faXmark,
        size: "sm"
      })
    }))]
  }));
}

const Dropdown = props => {
  const [open, setOpen] = useState(false);
  const {
      placeholder
    } = props,
    rest = __rest(props, ["placeholder"]);
  return jsx(TextField, Object.assign({
    SelectProps: {
      displayEmpty: true,
      open: open,
      onClose: () => setOpen(false),
      onOpen: () => setOpen(true),
      renderValue: value => {
        if (placeholder && value === '' && open) {
          return jsx("span", Object.assign({
            id: "select-placeholder"
          }, {
            children: placeholder
          }));
        }
        return value;
      }
    },
    select: true
  }, rest));
};

const classes$C = generateUtilityClasses('ErrorPage', ['background', 'bar', 'buttons', 'cancel', 'card', 'confirm', 'content', 'header', 'margin', 'media', 'titles']);
const StyledGrid$2 = styled$1(Grid$1)(({
  theme
}) => ({
  [`&.${classes$C.background}`]: {
    backgroundAttachment: 'fixed',
    backgroundPosition: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    minHeight: '100vh'
  },
  [`& .${classes$C.bar}`]: {
    borderColor: alpha(theme.palette.common.black, 0.1)
  },
  [`& .${classes$C.buttons}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(1),
    margin: '0 auto',
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      flexDirection: 'column-reverse'
    }
  },
  [`& .${classes$C.card}`]: {
    borderRadius: theme.shape.dialog.borderRadius,
    boxShadow: theme.ourShadows.overlay.darkBG,
    padding: theme.spacing(3),
    margin: theme.spacing(1),
    width: 360,
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      maxWidth: `calc(100vw - ${theme.spacing(2)})`
    }
  },
  [`& .${classes$C.cancel}`]: {
    marginRight: 'auto',
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      width: '100%'
    }
  },
  [`& .${classes$C.confirm}`]: {
    marginLeft: 'auto',
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      width: '100%'
    }
  },
  [`& .${classes$C.content}`]: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
    width: '100%'
  },
  [`& .${classes$C.header}`]: {
    margin: theme.spacing(2, 0),
    textAlign: 'left'
  },
  [`& .${classes$C.margin}`]: {
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      marginTop: theme.spacing(1)
    }
  },
  [`& .${classes$C.media}`]: {
    margin: '0 auto',
    width: 200,
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      width: 160
    }
  },
  [`& .${classes$C.titles}`]: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(2)
  }
}));
const ErrorPage = props => {
  const {
    backgroundImage,
    cancelButtonText,
    confirmButtonText,
    onCancel,
    onConfirm,
    paragraph,
    title
  } = props;
  const image = '/images/vehicle-404.svg';
  const defaultBackgroundImage = `/images/background-404.jpg`;
  const background = backgroundImage || defaultBackgroundImage;
  const cancelButtonClasses = classNames(classes$C.cancel, {
    [classes$C.margin]: confirmButtonText
  });
  return jsx(StyledGrid$2, Object.assign({
    className: classes$C.background,
    sx: {
      backgroundImage: `url(${background})`
    }
  }, {
    children: jsx(Grid$1, Object.assign({
      className: classes$C.content
    }, {
      children: jsxs(Card, Object.assign({
        className: classes$C.card
      }, {
        children: [jsxs(Grid$1, Object.assign({
          className: classes$C.titles
        }, {
          children: [jsx(CardMedia, {
            component: "img",
            className: classes$C.media,
            image: image,
            title: title,
            alt: title
          }), jsx(Typography, Object.assign({
            variant: "h4",
            className: classes$C.header
          }, {
            children: title
          })), jsx(Typography, Object.assign({
            variant: "body1"
          }, {
            children: paragraph
          }))]
        })), jsx("hr", {
          className: classes$C.bar
        }), jsxs(Grid$1, Object.assign({
          className: classes$C.buttons
        }, {
          children: [cancelButtonText && jsx(Button, Object.assign({
            className: cancelButtonClasses,
            modifier: "light",
            onClick: onCancel,
            small: true,
            variant: "text"
          }, {
            children: cancelButtonText
          })), confirmButtonText && jsx(Button, Object.assign({
            className: classes$C.confirm,
            modifier: "light",
            onClick: onConfirm,
            small: true,
            variant: "primary"
          }, {
            children: confirmButtonText
          }))]
        }))]
      }))
    }))
  }));
};

const classes$B = generateUtilityClasses('GC-FeaturedSection', ['forImage', 'fullColumnWidth']);
const StyledWrapper$1 = styled('section')(({
  theme
}) => ({
  [`${theme.breakpoints.up('md')}`]: {
    display: 'flex'
  }
}));
const StyledContainer$1 = styled(Container$1)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(0, 3),
  [`${theme.breakpoints.up('md')}`]: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2)
  }
}));
const StyledColumn = styled('div')(({
  theme
}) => ({
  flex: 1,
  position: 'relative',
  [`${theme.breakpoints.up('md')}`]: {
    padding: theme.spacing(10, 0)
  },
  [`&.${classes$B.forImage}`]: {
    minHeight: 200,
    paddingBottom: '100%',
    position: 'relative',
    [`& > *`]: {
      borderRadius: 6,
      height: '100%',
      objectFit: 'cover',
      position: 'absolute',
      width: '100%'
    },
    [`${theme.breakpoints.up('sm')}`]: {
      minHeight: 300
    },
    [`${theme.breakpoints.up('md')}`]: {
      left: 0,
      minHeight: 400,
      padding: 0,
      width: 'auto'
    }
  },
  [`&.${classes$B.fullColumnWidth}`]: {
    [`${theme.breakpoints.up('md')}`]: {
      [`& > *`]: {
        right: '0',
        width: `calc(50vw - ${theme.spacing(3.5)})`
      }
    }
  },
  [`&.${classes$B.fullColumnWidth}:last-of-type`]: {
    [`${theme.breakpoints.up('md')}`]: {
      [`& > *`]: {
        left: '0',
        right: 'initial'
      }
    }
  }
}));

const FeaturedSectionColumn = props => {
  const {
    forImage = false,
    children,
    fullColumnWidth = false
  } = props;
  return jsx(StyledColumn, Object.assign({
    className: classNames({
      [classes$B.forImage]: forImage,
      [classes$B.fullColumnWidth]: fullColumnWidth
    })
  }, {
    children: children
  }));
};

const FeaturedSection = props => {
  const {
    children
  } = props;
  return jsx(StyledWrapper$1, {
    children: jsx(StyledContainer$1, {
      children: children
    })
  });
};
FeaturedSection.Column = FeaturedSectionColumn;

const classes$A = generateUtilityClasses('GC-Footer-CompanyInformation', ['root', 'address']);
const StyledStack$2 = styled(Stack)(({
  theme
}) => ({
  [`&.${classes$A.root}`]: {
    width: '100%'
  },
  [`& .${classes$A.address}`]: {
    fontStyle: 'normal',
    padding: theme.spacing(3, 0)
  }
}));
const CompanyInformation = props => {
  const {
    data
  } = props;
  const {
    company_name,
    street_address,
    postal_code,
    city,
    phone,
    email,
    website
  } = data;
  const {
    t
  } = useComponentsConfig();
  const contactDetails = [{
    href: `tel: ${phone}`,
    translatedCaption: t('myGRIMME_phone', 'Telefon') + ': ',
    contactMethodData: phone
  }, {
    href: `mailto: ${email}`,
    translatedCaption: t('myGRIMME_email', 'Email') + ': ',
    contactMethodData: email
  }, {
    href: `https://${website}`,
    contactMethodData: website
  }];
  return jsxs(StyledStack$2, Object.assign({
    className: classes$A.root,
    "data-testid": "company-information"
  }, {
    children: [jsx(Typography, Object.assign({
      variant: "body1"
    }, {
      children: company_name
    })), jsxs(Typography, Object.assign({
      className: classes$A.address,
      component: "address",
      variant: "body2"
    }, {
      children: [street_address, jsx("br", {}), postal_code, " ", city]
    })), contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.map(({
      href,
      translatedCaption,
      contactMethodData
    }) => jsxs(Link, Object.assign({
      variant: "body2",
      href: href,
      target: "_blank",
      rel: "noreferrer"
    }, {
      children: [translatedCaption, contactMethodData]
    }), contactMethodData))]
  }));
};

const classes$z = generateUtilityClasses('GC-Footer-LegalInformation', ['root', 'links', 'copyrights']);
const StyledStack$1 = styled(Stack)(({
  theme
}) => ({
  [`&.${classes$z.root}`]: {
    flexDirection: 'column',
    rowGap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      columnGap: theme.spacing(2)
    },
    [theme.breakpoints.up('lg')]: {
      columnGap: theme.spacing(3)
    }
  },
  [`& .${classes$z.links}`]: {
    columnGap: theme.spacing(3),
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: theme.spacing(2),
    width: '100%'
  },
  [`& .${classes$z.copyrights}`]: {
    width: '100%'
  }
}));
const LegalInformation = props => {
  const {
    data: links,
    companyName
  } = props;
  const currentYear = new Date().getFullYear();
  const copyrights = `© ${companyName} ${currentYear}`;
  return jsxs(StyledStack$1, Object.assign({
    className: classes$z.root
  }, {
    children: [jsx(Stack, Object.assign({
      className: classes$z.links,
      component: "nav"
    }, {
      children: links === null || links === void 0 ? void 0 : links.map(element => {
        return jsx(Link, Object.assign({
          href: element.url,
          variant: "caption"
        }, {
          children: element.label
        }), element.label);
      })
    })), jsx(Typography, Object.assign({
      className: classes$z.copyrights,
      component: "p",
      variant: "caption"
    }, {
      children: copyrights
    }))]
  }));
};

var Visibility;
(function (Visibility) {
  Visibility["BOTH"] = "both";
  Visibility["AUTH"] = "authenticated";
  Visibility["UNAUTH"] = "unauthenticated";
})(Visibility || (Visibility = {}));

const classes$y = generateUtilityClasses('GC-Footer-Sitemap', ['root', 'linksColumn']);
const StyledStack = styled(Stack)(({
  theme
}) => ({
  [`&.${classes$y.root}`]: {
    columnGap: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      columnGap: theme.spacing(2)
    },
    [theme.breakpoints.up('lg')]: {
      columnGap: theme.spacing(3)
    }
  },
  [`& .${classes$y.linksColumn}`]: {
    flexDirection: 'column',
    rowGap: theme.spacing(2),
    width: '100%',
    p: {
      paddingBottom: theme.spacing(1)
    }
  }
}));
const Sitemap = props => {
  const {
    data,
    isAuthenticated
  } = props;
  const visibilityFilter = useCallback(l => l.visibility === Visibility.BOTH || l.visibility === (isAuthenticated ? Visibility.AUTH : Visibility.UNAUTH), [isAuthenticated]);
  return jsx(StyledStack, Object.assign({
    className: classes$y.root,
    as: "nav"
  }, {
    children: data === null || data === void 0 ? void 0 : data.map(({
      caption,
      links
    }) => {
      var _a;
      return jsxs(Stack, Object.assign({
        className: classes$y.linksColumn
      }, {
        children: [jsx(Typography, Object.assign({
          variant: "overline",
          component: "p"
        }, {
          children: caption
        })), (_a = links === null || links === void 0 ? void 0 : links.filter(link => {
          if (link.visibility) {
            return visibilityFilter;
          }
          return link;
        })) === null || _a === void 0 ? void 0 : _a.map(link => jsx(Link, Object.assign({
          variant: "body2",
          href: link.url
        }, {
          children: link.label
        }), `${link.label}-${link.url}`))]
      }), caption);
    })
  }));
};

const classes$x = generateUtilityClasses('GC-Footer', ['root', 'colouredBGWrapper', 'blackBG', 'greyBG', 'container', 'companyInfoAndSitemapWrapper']);
const Root$b = styled('footer')(({
  theme
}) => ({
  [`&.${classes$x.root}`]: {
    color: theme.palette.common.white,
    a: {
      color: 'inherit',
      textDecoration: 'none',
      transition: theme.transitions.create('color', {
        duration: theme.transitions.duration.standard
      })
    }
  },
  [`& .${classes$x.colouredBGWrapper}`]: {
    padding: theme.spacing(0, 3),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 5)
    }
  },
  [`& .${classes$x.blackBG}`]: {
    backgroundColor: theme.palette.common.black,
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing(7),
      paddingTop: theme.spacing(7)
    },
    a: {
      '&:hover': {
        color: theme.palette.primary.main
      }
    }
  },
  [`& .${classes$x.greyBG}`]: {
    backgroundColor: theme.palette.grey[400],
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    a: {
      '&:hover': {
        color: theme.palette.common.black
      }
    }
  },
  [`& .${classes$x.companyInfoAndSitemapWrapper}`]: {
    flexDirection: 'column',
    rowGap: theme.spacing(5),
    padding: theme.spacing(3, 0, 5),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      columnGap: theme.spacing(2),
      padding: theme.spacing(4, 0, 5)
    },
    [theme.breakpoints.up('lg')]: {
      columnGap: theme.spacing(3)
    }
  }
}));
const SocialMediaIconButton = styled(IconButton)(({
  theme
}) => ({
  padding: 0,
  marginRight: theme.spacing(2.5)
}));

const Footer = props => {
  const {
    className,
    data,
    isAuthenticated,
    socialLinks,
    sitemap
  } = props;
  const {
    company_information,
    legal_information_links,
    title
  } = data;
  return jsxs(Root$b, Object.assign({
    className: classNames(classes$x.root, className)
  }, {
    children: [jsx("div", Object.assign({
      className: classNames(classes$x.colouredBGWrapper, classes$x.blackBG)
    }, {
      children: jsxs(Container$1, Object.assign({
        disableGutters: true
      }, {
        children: [jsx(Typography, Object.assign({
          component: "h2",
          variant: "h3"
        }, {
          children: title
        })), jsx(TitleDivider, {}), jsxs(Stack, Object.assign({
          className: classes$x.companyInfoAndSitemapWrapper
        }, {
          children: [jsx(CompanyInformation, {
            data: company_information === null || company_information === void 0 ? void 0 : company_information[0]
          }), jsx(Sitemap, {
            data: sitemap,
            isAuthenticated: isAuthenticated
          })]
        })), jsx("nav", {
          children: socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.map(item => {
            var _a, _b;
            return jsx(SocialMediaIconButton, Object.assign({
              component: "a",
              title: item === null || item === void 0 ? void 0 : item.name,
              href: item === null || item === void 0 ? void 0 : item.url,
              target: "_blank",
              size: "large"
            }, {
              children: jsx(FontAwesomeIcon, {
                icon: [(_a = item === null || item === void 0 ? void 0 : item.icon) === null || _a === void 0 ? void 0 : _a.prefix, (_b = item === null || item === void 0 ? void 0 : item.icon) === null || _b === void 0 ? void 0 : _b.iconName]
              })
            }), item === null || item === void 0 ? void 0 : item.url);
          })
        })]
      }))
    })), jsx("div", Object.assign({
      className: classNames(classes$x.colouredBGWrapper, classes$x.greyBG)
    }, {
      children: jsx(Container$1, Object.assign({
        disableGutters: true
      }, {
        children: jsx(LegalInformation, {
          data: legal_information_links,
          companyName: company_information === null || company_information === void 0 ? void 0 : company_information[0].company_name
        })
      }))
    }))]
  }));
};

const StyledBreadCrumbWrapper = styled(Box)(() => ({
  left: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
  zIndex: 11
}));
const StyledBreadCrumbContainer = styled(Container$1)(({
  theme
}) => ({
  paddingTop: theme.spacing(10),
  [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
    paddingTop: theme.spacing(12)
  }
}));
const StyledWrapper = styled(Box)(({
  theme
}) => ({
  bottom: 0,
  left: 0,
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: 10,
  '&::after': {
    background: 'linear-gradient(180deg, rgba(0,0,0,0.5984987745098039) 0%, rgba(255,255,255,0) 26%, rgba(255,255,255,0) 74%, rgba(17,17,17,0.590095413165266) 100%)',
    bottom: 0,
    content: "''",
    left: 0,
    position: 'absolute',
    pointerEvents: 'none',
    right: 0,
    top: 0,
    zIndex: 10
  }
}));
const StyledSlider$1 = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  overflowX: 'scroll',
  scrollSnapType: 'x mandatory',
  width: '100%',
  height: '100%',
  background: theme.palette.common.white,
  msOverflowStyle: 'none',
  alignItems: 'center',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    height: 0,
    width: 0
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent'
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  }
}));
const styledSlideClasses$1 = generateUtilityClasses('GC-Gallery-Slide', ['image']);
const StyledSlide$1 = styled(Box)(({
  theme
}) => ({
  cursor: 'pointer',
  height: '100%',
  marginRight: theme.spacing(0.25),
  minWidth: '40vw',
  scrollSnapAlign: 'end',
  position: 'relative',
  zIndex: 2,
  overflowY: 'hidden',
  [theme.breakpoints.down('sm')]: {
    minWidth: '80vw'
  },
  [`& .${styledSlideClasses$1.image}`]: {
    height: '100%',
    objectFit: 'cover',
    objectPosition: '50% 50%',
    position: 'absolute',
    width: '100%'
  }
}));
const StyledNavigation$1 = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  position: 'absolute',
  right: '10.7vw',
  width: '7vw',
  bottom: 40,
  zIndex: 11,
  [theme.breakpoints.down('lg')]: {
    width: '14vw'
  },
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  }
}));
const StyledNavigationIcon = styled(IconButton)(({
  theme
}) => ({
  background: 'rgba(22, 24, 25, 0.7)',
  backdropFilter: 'blur(4px)',
  '&:hover': {
    background: 'rgba(22, 24, 25, 1)'
  },
  height: 48,
  width: 48
}));

const GallerySlider = props => {
  const {
    breadcrumbs,
    ImageComponent,
    slides
  } = props;
  const Image = ImageComponent || 'img';
  const [currentScrollPosition, setCurrentScrollPosition] = useState(0);
  const scrollContainer = useRef(null);
  const cardRef = useRef(null);
  const paddingValue = 2;
  const handleScroll = event => {
    setCurrentScrollPosition(event.currentTarget.scrollLeft);
  };
  const handleNavigationClick = direction => {
    var _a;
    const scrollDirectionCondition = direction === 'prev' ? -cardRef.current.clientWidth - paddingValue : cardRef.current.clientWidth + paddingValue;
    (_a = scrollContainer.current) === null || _a === void 0 ? void 0 : _a.scrollBy({
      left: scrollDirectionCondition,
      top: 0,
      behavior: 'smooth'
    });
  };
  return jsxs(StyledWrapper, {
    children: [jsx(Navigation, {
      currentScrollPosition: currentScrollPosition,
      handleNavigationClick: handleNavigationClick,
      scrollContainer: scrollContainer
    }), breadcrumbs && jsx(StyledBreadCrumbWrapper, {
      children: jsx(StyledBreadCrumbContainer, {
        children: breadcrumbs
      })
    }), jsx(StyledSlider$1, Object.assign({
      onScroll: handleScroll,
      ref: scrollContainer
    }, {
      children: slides.map((slide, index) => {
        return jsx(StyledSlide$1, Object.assign({
          ref: cardRef,
          onClick: _ => {
            slide.onClick(slide.id);
          }
        }, {
          children: jsx(Image, {
            alt: slide.imageAlt,
            className: styledSlideClasses$1.image,
            showPlaceholder: true,
            src: slide.imageUrl,
            layout: "fill",
            optimized: "true"
          })
        }), index);
      })
    }))]
  });
};

var Direction;
(function (Direction) {
  Direction["PREVIOUS"] = "prev";
  Direction["NEXT"] = "next";
})(Direction || (Direction = {}));

const Navigation = props => {
  var _a, _b;
  const {
    currentScrollPosition,
    handleNavigationClick,
    scrollContainer
  } = props;
  const paddingValue = 2;
  const isEndOfScroll = currentScrollPosition >= ((_a = scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) - ((_b = scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.current) === null || _b === void 0 ? void 0 : _b.clientWidth) - paddingValue;
  const startingScrollPosition = 0;
  const isStartOfScroll = currentScrollPosition === startingScrollPosition;
  const navigationButtons = [{
    direction: Direction.PREVIOUS,
    icon: faChevronLeft,
    disabled: isStartOfScroll
  }, {
    direction: Direction.NEXT,
    disabled: isEndOfScroll,
    icon: faChevronRight
  }];
  return jsx(StyledNavigation$1, {
    children: navigationButtons.map(({
      direction,
      disabled,
      icon
    }, index) => jsx(StyledNavigationIcon, Object.assign({
      title: direction,
      onClick: () => {
        handleNavigationClick(direction);
      },
      disabled: disabled
    }, {
      children: jsx(FontAwesomeIcon, {
        color: disabled ? theme.palette.grey[300] : theme.palette.common.white,
        icon: icon
      })
    }), index))
  });
};

const PREFIX$9 = 'GC-GrimmeLogo';
const classes$w = {
  grimme: `${PREFIX$9}-grimme`,
  bright: `${PREFIX$9}-bright`,
  dark: `${PREFIX$9}-dark`,
  noisy: `${PREFIX$9}-noisy`
};
const StyledSvgIcon$1 = styled$1(SvgIcon)(({
  theme
}) => ({
  [`& .${classes$w.grimme}`]: {
    [`&.${classes$w.bright}, &.${classes$w.noisy}`]: {
      color: theme.palette.primary.main
    },
    [`&.${classes$w.dark}`]: {
      color: theme.palette.common.white
    }
  }
}));
const GrimmeLogo = props => {
  const {
      modifier
    } = props,
    rest = __rest(props, ["modifier"]);
  return jsxs(StyledSvgIcon$1, Object.assign({
    viewBox: "0 0 164.48 35",
    "aria-labelledby": "myGrimme-logo"
  }, rest, {
    children: [jsx("title", Object.assign({
      id: "Grimme-logo"
    }, {
      children: "GRIMME"
    })), jsx("path", {
      className: classNames(classes$w.grimme, classes$w[modifier]),
      d: "M58.58 5.96a5.96 5.96 0 115.97 5.97 5.96 5.96 0 01-5.97-5.97zm13.32-3.5a7.66 7.66 0 01.02 6.85h90.86l1.63-6.55.07-.29zm-14.7 0H6.15l-.02.08-1.6 6.65-.04.12h52.69a7.83 7.83 0 01.02-6.84zm9.99 11.2h-8.75L53 34.7h8.9l5.3-21.04zm57.26 0L118.2 24.6l-.07-.07-.51-10.87h-11.58l-.02.07-5.37 20.97h8.66l2.82-10.62.04.05 1.07 10.57h4.92l6.1-9.6.47-.6v.07l-2.35 9.22-.23.91h8.78l5.59-21.04zm-34.52 0L83.7 24.6l-.08-.07-.5-10.87H71.52l-.02.07-5.37 20.97h8.66l2.81-10.62.05.05 1.07 10.57h4.92l6.1-9.6.46-.6v.07l-2.34 9.22-.23.91h8.77l5.6-21.04zm45.44 21.04h20.98l1.3-5.37h-12.02l.57-2.2 11.99.01 1.13-4.25.09-.3h-12.02l.02-.12c.15-.67.35-1.32.52-1.98h11.94c.66-2.22 1.18-4.44 1.8-6.71l.02-.13h-20.97c-.05.04-5.35 21.05-5.35 21.05zm-82-16.18a12.34 12.34 0 01-1.09 4.32 5.72 5.72 0 01-4.77 3.2l-2.17.16c1.8 2.87 3.85 5.63 5.68 8.5H40.87c-1.48-2.32-2.84-4.64-4.35-6.96l-1.93 6.96h-8.94L31 13.68l9.92.03 7.63.02c1.76.08 3.6.57 4.37 2.35a5.54 5.54 0 01.45 2.07zm-9.64 1.21a10.4 10.4 0 00-2.82-.25c-.79 0-1.6.05-2.34.05-.42 1.46-.87 2.92-1.14 4.38 1.14 0 2.32.07 3.49.05.71-.03 3.2-.1 3.43-2.4.08-.73.03-1.46-.62-1.83zm-30.46.67a60.8 60.8 0 0112.2.3l1.63-5.63.1-.38-.04-.02a59.52 59.52 0 00-5.12-.89c-5.11-.42-11.04-.98-15.62.92C3 16.13 1.82 19.74.94 22.85c-.6 3.21-2.13 7.73.77 10.32 2.05 1.59 4.71 1.68 7.38 1.83a60.77 60.77 0 0012.68-1.1l.2-.07 2.91-10.48h-10.4l-1.09 4.1 2.73.02c-.2.74-.43 1.65-.67 2.37 0 0-4.55.6-5.86-.5-1.3-1.63-.27-3.9.15-5.65a4.68 4.68 0 013.53-3.29z"
    })]
  }));
};

const classes$v = generateUtilityClasses('GC-PageTitle', ['caption', 'children', 'dark', 'grid', 'light', 'subtitle', 'title']);
const StyledGrid$1 = styled(Grid$1)(({
  theme
}) => ({
  [`& .${classes$v.grid}`]: {},
  [`& .${classes$v.caption}`]: {
    marginBottom: theme.spacing(3)
  },
  [`& .${classes$v.children}`]: {
    marginBottom: theme.spacing(5)
  },
  [`& .${classes$v.dark}`]: {
    color: theme.palette.common.black
  },
  [`& .${classes$v.light}`]: {
    color: theme.palette.common.white
  },
  [`& .${classes$v.subtitle}`]: {
    marginBottom: theme.spacing(3),
    whiteSpace: 'pre-line'
  },
  [`& .${classes$v.title}`]: {
    marginBottom: theme.spacing(2),
    textIndent: theme.spacing(-0.5)
  }
}));
const PageTitle = props => {
  const {
      caption,
      captionProps,
      children,
      colorVariant,
      disableDivider,
      subtitle,
      subtitleProps,
      title,
      titleProps
    } = props,
    rest = __rest(props, ["caption", "captionProps", "children", "colorVariant", "disableDivider", "subtitle", "subtitleProps", "title", "titleProps"]);
  const showDivider = !disableDivider && !children;
  return jsxs(StyledGrid$1, Object.assign({}, rest, {
    children: [jsxs(Grid$1, Object.assign({
      className: classes$v.grid,
      item: true
    }, {
      children: [caption && jsx(Typography, Object.assign({
        variant: "h6",
        className: classNames(classes$v.caption, {
          [classes$v[colorVariant]]: colorVariant
        })
      }, captionProps, {
        children: caption
      })), jsx(Typography, Object.assign({
        className: classNames(classes$v.title, {
          [classes$v[colorVariant]]: colorVariant
        }),
        variant: "h1"
      }, titleProps, {
        children: title
      })), subtitle && jsx(Typography, Object.assign({
        className: classNames(classes$v.subtitle, {
          [classes$v[colorVariant]]: colorVariant
        }),
        variant: "h5"
      }, subtitleProps, {
        children: subtitle
      })), showDivider && jsx(TitleDivider, {})]
    })), children && jsx(Grid$1, Object.assign({
      className: classes$v.children
    }, {
      children: children
    }))]
  }));
};

const classes$u = generateUtilityClasses('GC-Hero', ['root', 'actions', 'bgImage', 'breadcrumbs', 'container', 'containerBottomCta', 'content', 'cta', 'mainSection', 'pageTitle', 'root', 'tag', 'withBottomBar']);
const Root$a = styled$1('section')(({
  theme
}) => ({
  [`&.${classes$u.root}`]: {
    backgroundColor: theme.palette.common.black,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 420,
    [theme.breakpoints.up('sm')]: {
      minHeight: 520
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 720
    }
  },
  [`& .${classes$u.mainSection}`]: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    '&::before': {
      background: 'transparent linear-gradient(90deg, #000000 0%, #80808000 100%) 0% 0% no-repeat padding-box',
      content: '""',
      height: '100%',
      left: 0,
      opacity: 0.9,
      position: 'absolute',
      top: 0,
      width: '100%',
      zIndex: 1
    }
  },
  [`& .${classes$u.bgImage}`]: {
    height: '100%',
    left: 0,
    objectFit: 'cover',
    position: 'absolute',
    top: 0,
    width: '100%'
  },
  [`& .${classes$u.container}`]: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(10),
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row'
    },
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(6)
    },
    [`& .${classes$u.content}`]: {
      alignItems: 'flex-start',
      color: theme.palette.common.white,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      [`& .${classes$u.tag}`]: {
        marginBottom: theme.spacing(3)
      },
      [`& .${classes$u.breadcrumbs}`]: {
        paddingTop: theme.spacing(2)
      },
      [`& .${classes$u.pageTitle}`]: {
        paddingTop: theme.spacing(5)
      }
    }
  },
  [`& .${classes$u.cta}`]: {
    alignItems: 'flex-end',
    display: 'flex',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(4),
      marginTop: 0
    }
  },
  [`& .${classes$u.actions}`]: {
    zIndex: 2
  },
  [`& .${classes$u.containerBottomCta}`]: {
    paddingBottom: theme.spacing(4),
    position: 'relative',
    zIndex: 2
  },
  [`&.${classes$u.withBottomBar}`]: {
    minHeight: '100vh'
  }
}));

const Hero = props => {
  const {
    background,
    bottomBar,
    breadcrumbs,
    className,
    cta,
    ctaPosition = 'right',
    pageTitleProps,
    subtitle,
    tag,
    title
  } = props;
  const imageComponent = /*#__PURE__*/cloneElement(background, {
    className: classes$u.bgImage,
    'data-testid': 'background'
  });
  return jsxs(Root$a, Object.assign({
    className: classNames(classes$u.root, {
      [classes$u.withBottomBar]: !!bottomBar
    }, className)
  }, {
    children: [jsxs("div", Object.assign({
      className: classes$u.mainSection
    }, {
      children: [imageComponent, jsxs(Container$1, Object.assign({
        className: classes$u.container
      }, {
        children: [jsxs(Grid$1, Object.assign({
          container: true,
          item: true,
          className: classes$u.content,
          md: 8
        }, {
          children: [breadcrumbs && jsx(Grid$1, Object.assign({
            item: true,
            className: classes$u.breadcrumbs
          }, {
            children: breadcrumbs
          })), jsxs(Grid$1, Object.assign({
            item: true,
            className: classes$u.pageTitle
          }, {
            children: [tag && jsx(Typography, Object.assign({
              className: classes$u.tag,
              variant: "h6"
            }, {
              children: tag
            })), jsx(PageTitle, Object.assign({
              colorVariant: "light",
              subtitle: subtitle,
              title: title
            }, pageTitleProps))]
          }))]
        })), cta && ctaPosition === 'right' && jsx(Grid$1, Object.assign({
          item: true,
          className: classes$u.cta,
          md: 4
        }, {
          children: cta
        }))]
      })), cta && ctaPosition === 'bottom' && jsx(Container$1, Object.assign({
        className: classes$u.containerBottomCta
      }, {
        children: cta
      }))]
    })), bottomBar && jsx("div", {
      children: bottomBar
    })]
  }));
};

const CloseIcon = styled(IconButton)(({
  theme
}) => ({
  height: 48,
  position: 'absolute',
  right: 40,
  top: 40,
  width: 48,
  [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
    right: '2.5vw',
    top: '2.5vw'
  }
}));
const StyledLightBoxWrapper = styled(Box)(({
  theme
}) => ({
  bottom: 0,
  height: '100vh',
  left: 0,
  position: 'fixed',
  right: 0,
  top: 0,
  width: '100vw',
  zIndex: 1202
}));
const StyledBackdrop$2 = styled(Backdrop)(({
  theme
}) => ({
  backgroundColor: 'rgba(22, 24, 25, 0.8)',
  backdropFilter: 'blur(6px)',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  height: '100%',
  justifyContent: 'center'
}));
const StyledSlider = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  overflowX: 'scroll',
  scrollSnapType: 'x mandatory',
  width: '70vw',
  marginTop: theme.spacing(5),
  minHeight: '70vh',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    width: 0,
    height: 0,
    scrollbarWidth: 'none'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent'
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  },
  [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
    minHeight: '40vh',
    width: '90vw'
  }
}));
const styledSlideClasses = generateUtilityClasses('GC-Light-Box-Slide', ['image']);
const StyledSlide = styled(Box)(({
  theme
}) => ({
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  minWidth: '100%',
  outline: 'none',
  position: 'relative',
  scrollSnapAlign: 'end',
  [`& .${styledSlideClasses.image}`]: {
    height: '100%',
    left: 0,
    objectFit: 'contain',
    objectPosition: '50% 50%',
    position: 'absolute',
    right: 0,
    width: '100%'
  }
}));
const StyledNavigation = styled(Box)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-around',
  marginTop: theme.spacing(5),
  width: '25vw',
  [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
    justifyContent: 'space-between',
    width: '90vw'
  }
}));

var NavigationDirection;
(function (NavigationDirection) {
  NavigationDirection["NEXT"] = "next";
  NavigationDirection["PREVIOUS"] = "prev";
})(NavigationDirection || (NavigationDirection = {}));
const LightBox = props => {
  const {
    currentSlide = 0,
    ImageComponent,
    onClose,
    open = false,
    setCurrentSlide,
    slides
  } = props;
  const Image = ImageComponent || 'img';
  const sliderContainerRef = useRef(null);
  const slidesRef = slides.map(() => /*#__PURE__*/createRef());
  const handleScroll = useCallback(event => {
    var _a, _b;
    const currentTarget = event === null || event === void 0 ? void 0 : event.currentTarget;
    if (currentTarget) {
      const currentScrollPosition = (_a = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.scrollLeft) !== null && _a !== void 0 ? _a : 0;
      const currentSlide = Math.round(currentScrollPosition / ((_b = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.offsetWidth) !== null && _b !== void 0 ? _b : 1));
      setCurrentSlide === null || setCurrentSlide === void 0 ? void 0 : setCurrentSlide(currentSlide);
    }
  }, [setCurrentSlide]);
  const handleNavigationClick = direction => {
    var _a, _b;
    const currentSliderContainerRef = sliderContainerRef === null || sliderContainerRef === void 0 ? void 0 : sliderContainerRef.current;
    if (currentSliderContainerRef) {
      const scrollLeft = (_a = currentSliderContainerRef === null || currentSliderContainerRef === void 0 ? void 0 : currentSliderContainerRef.scrollLeft) !== null && _a !== void 0 ? _a : 0;
      const offsetWidth = (_b = currentSliderContainerRef === null || currentSliderContainerRef === void 0 ? void 0 : currentSliderContainerRef.offsetWidth) !== null && _b !== void 0 ? _b : 0;
      const scrollPositionToReplace = direction === NavigationDirection.NEXT ? scrollLeft + offsetWidth : scrollLeft - offsetWidth;
      currentSliderContainerRef === null || currentSliderContainerRef === void 0 ? void 0 : currentSliderContainerRef.scroll({
        behavior: 'smooth',
        left: scrollPositionToReplace,
        top: 0
      });
    }
  };
  useEffect(() => {
    var _a, _b;
    if (open && (slidesRef === null || slidesRef === void 0 ? void 0 : slidesRef.length)) (_b = (_a = slidesRef[currentSlide]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
  }, [currentSlide, open, slidesRef]);
  useEffect(() => {
    var _a, _b;
    if (slidesRef === null || slidesRef === void 0 ? void 0 : slidesRef.length) (_b = (_a = slidesRef[currentSlide]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slidesRef]);
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    if (open) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);
  return jsx(StyledLightBoxWrapper, Object.assign({
    sx: {
      display: open ? 'block' : 'none'
    }
  }, {
    children: jsxs(StyledBackdrop$2, Object.assign({
      open: open
    }, {
      children: [jsx(CloseIcon, Object.assign({
        onClick: onClose,
        title: "close-icon"
      }, {
        children: jsx(FontAwesomeIcon, {
          color: "white",
          icon: faXmark
        })
      })), jsx(StyledSlider, Object.assign({
        onScroll: handleScroll,
        ref: sliderContainerRef
      }, {
        children: slides.map((slide, index) => jsx(StyledSlide, Object.assign({
          "data-testid": slide.url,
          ref: slidesRef === null || slidesRef === void 0 ? void 0 : slidesRef[index],
          tabIndex: -1
        }, {
          children: jsx(Image, {
            alt: slide.imageAlt,
            className: styledSlideClasses.image,
            layout: "fill",
            optimized: "true",
            src: slide.url
          })
        }), index))
      })), jsxs(StyledNavigation, {
        children: [jsx(IconButton, Object.assign({
          title: "prev",
          onClick: () => handleNavigationClick(NavigationDirection.PREVIOUS),
          sx: {
            height: 48,
            visibility: currentSlide === 0 ? 'hidden' : 'visible',
            width: 48
          }
        }, {
          children: jsx(FontAwesomeIcon, {
            color: theme.palette.common.white,
            icon: faChevronLeft
          })
        })), jsxs(Typography, Object.assign({
          color: theme.palette.common.white,
          variant: "h6"
        }, {
          children: [currentSlide + 1, "/", slides.length]
        })), jsx(IconButton, Object.assign({
          title: "next",
          onClick: () => handleNavigationClick(NavigationDirection.NEXT),
          sx: {
            height: 48,
            visibility: currentSlide + 1 < slides.length ? 'visible' : 'hidden',
            width: 48
          }
        }, {
          children: jsx(FontAwesomeIcon, {
            color: theme.palette.common.white,
            icon: faChevronRight
          })
        }))]
      })]
    }))
  }));
};

const mobileSizeWidth = '324px';
const mobileSizeHeight = '344px';
const desktopSizeWidth = '562px';
const desktopSizeHeight = '412px';
const classes$t = generateUtilityClasses('GC-SlideBlog', ['figure', 'fullWidth', 'header', 'root', 'title', 'type']);
const Root$9 = styled$1('a')(({
  theme
}) => ({
  [`&.${classes$t.root}`]: {
    borderRadius: theme.shape.card.borderRadius,
    boxShadow: theme.ourShadows.card,
    display: 'flex',
    maxHeight: mobileSizeHeight,
    maxWidth: mobileSizeWidth,
    minHeight: '90vw',
    minWidth: '85vw',
    overflow: 'hidden',
    position: 'relative',
    scrollSnapAlign: 'start',
    scrollSnapStop: 'always',
    textDecoration: 'none',
    transition: theme.transitions.create(['all'], {
      duration: '0.2s'
    }),
    [theme.breakpoints.up(374)]: {
      minWidth: mobileSizeWidth,
      minHeight: mobileSizeHeight
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: desktopSizeWidth,
      maxWidth: desktopSizeWidth,
      minHeight: desktopSizeHeight,
      maxHeight: desktopSizeHeight
    }
  },
  [`&.${classes$t.fullWidth}`]: {
    maxWidth: '100%',
    [theme.breakpoints.up('lg')]: {
      maxWidth: '100%'
    }
  },
  [`& .${classes$t.header}`]: {
    alignSelf: 'flex-end',
    backdropFilter: 'blur(2px)',
    backgroundColor: `${alpha(theme.palette.common.black, 0.5)}`,
    borderRadius: `0 0 ${theme.shape.card.borderRadius}px ${theme.shape.card.borderRadius}px`,
    color: theme.palette.common.white,
    display: 'inline-block',
    padding: theme.spacing(2.5),
    position: 'relative',
    width: '100%',
    zIndex: 2,
    [theme.breakpoints.up(374)]: {
      padding: theme.spacing(3)
    }
  },
  [`& .${classes$t.type}`]: {
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2)
  },
  [`& .${classes$t.title}`]: {
    marginBottom: theme.spacing(1)
  },
  [`& .${classes$t.figure}`]: {
    height: '100%',
    left: 0,
    margin: 0,
    position: 'absolute',
    top: 0,
    transition: theme.transitions.create(['all'], {
      duration: '0.3s'
    }),
    width: '100%',
    zIndex: 1,
    img: {
      height: '100%',
      objectFit: 'cover',
      position: 'absolute',
      width: '100%'
    }
  },
  '@media (hover: hover)': {
    [`&.${classes$t.root}:hover`]: {
      transform: 'translateY(-10px)',
      [`& .${classes$t.figure}`]: {
        transform: 'scale(1.03)'
      }
    }
  }
}));

const BlogCard = props => {
  const {
    data,
    fullWidth
  } = props;
  return jsxs(Root$9, Object.assign({
    className: classNames(classes$t.root, {
      [classes$t.fullWidth]: fullWidth
    }),
    href: data.href
  }, {
    children: [jsx("figure", Object.assign({
      className: classes$t.figure
    }, {
      children: jsx("img", {
        src: data.image,
        alt: "product"
      })
    })), jsxs("header", Object.assign({
      className: classes$t.header
    }, {
      children: [jsx(Typography, Object.assign({
        className: classes$t.type,
        variant: "overline"
      }, {
        children: data.type
      })), jsx(Typography, Object.assign({
        className: classes$t.title,
        variant: "h4"
      }, {
        children: data.title
      })), jsx(Typography, Object.assign({
        variant: "body2"
      }, {
        children: data.description
      }))]
    }))]
  }));
};

const footerHeightMobileSize$1 = '102px';
const footerHeightDesktopSize$1 = '106px';
const mobileSize = '326px';
const desktopSize = '364px';
const classes$s = generateUtilityClasses('GC-Link-Card-Feature', ['root', 'dark', 'description', 'imageWrapper', 'footer', 'footerBox', 'title', 'titleWrapper', 'active']);
const Root$8 = styled$1('section')(({
  theme
}) => ({
  [`&.${classes$s.root}`]: {
    '--text-color': theme.palette.common.black,
    backgroundColor: theme.palette.common.black,
    position: 'relative',
    width: '100%',
    minWidth: '85vw',
    minHeight: '85vw',
    maxWidth: mobileSize,
    maxHeight: mobileSize,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: theme.shape.card.borderRadius,
    boxShadow: theme.ourShadows.card,
    scrollSnapAlign: 'start',
    scrollSnapStop: 'always',
    [theme.breakpoints.up(374)]: {
      minWidth: mobileSize,
      minHeight: mobileSize
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: desktopSize,
      minWidth: desktopSize
    }
  },
  [`& .${classes$s.imageWrapper}`]: {
    position: 'relative',
    flex: 1,
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > img': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  },
  [`& .${classes$s.footer}`]: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2),
    position: 'absolute',
    bottom: '0',
    left: '0',
    height: `${footerHeightMobileSize$1}`,
    width: '100%',
    cursor: 'pointer',
    transition: theme.transitions.create(['all'], {
      duration: '0.2s'
    }),
    [theme.breakpoints.up(374)]: {
      padding: theme.spacing(3)
    },
    [theme.breakpoints.up('lg')]: {
      height: `${footerHeightDesktopSize$1}`
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '40px',
      height: '24px',
      bottom: '100%',
      left: `calc(50% - ${theme.spacing(2.5)})`,
      borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
      backgroundColor: `${alpha(theme.palette.common.white, 0.7)}`,
      backdropFilter: 'blur(3px)',
      opacity: 1,
      transition: theme.transitions.create(['all'], {
        duration: '0.35s'
      })
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      borderLeft: `5px solid ${theme.palette.common.transparent}`,
      borderRight: `5px solid ${theme.palette.common.transparent}`,
      borderBottom: `6px solid ${theme.palette.common.black}`,
      bottom: 'calc(100% + 9px)',
      left: 'calc(50% - 5px)',
      transition: theme.transitions.create(['all'], {
        duration: '0.2s'
      })
    },
    [`& .${classes$s.titleWrapper}`]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: `calc(${footerHeightMobileSize$1} - ${theme.spacing(6)})`,
      [theme.breakpoints.up('lg')]: {
        minHeight: `calc(${footerHeightDesktopSize$1} - ${theme.spacing(6)})`
      }
    },
    [`& .${classes$s.title}`]: {
      color: 'var(--text-color)',
      display: '-webkit-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      wordWrap: 'break-word'
    },
    [`& .${classes$s.description}`]: {
      color: 'var(--text-color)',
      lineHeight: '1.4',
      opacity: 0,
      transition: theme.transitions.create(['all'], {
        duration: '0.2s'
      }),
      marginTop: theme.spacing(2)
    },
    '&:hover': {
      '&::before': {
        height: '26px'
      },
      '&::after': {
        bottom: 'calc(100% + 11px)'
      }
    },
    [`&.${classes$s.active}`]: {
      height: '85vw',
      backgroundColor: `${alpha(theme.palette.common.white, 0.8)}`,
      backdropFilter: 'blur(2px)',
      borderRadius: theme.shape.card.borderRadius,
      paddingTop: theme.spacing(6),
      [theme.breakpoints.up(374)]: {
        height: mobileSize
      },
      [theme.breakpoints.up('lg')]: {
        height: desktopSize
      },
      [`& .${classes$s.description}`]: {
        opacity: 1
      },
      [`& .${classes$s.footerBox}`]: {
        height: `calc(${mobileSize} - ${theme.spacing(9)})`,
        marginRight: theme.spacing(-1),
        overflowY: 'auto',
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('lg')]: {
          height: `calc(${desktopSize} - ${theme.spacing(9)})`
        }
      },
      '&::before': {
        opacity: 0
      },
      '&::after': {
        bottom: `calc(100% - ${theme.spacing(3)})`,
        transform: 'rotate(180deg)'
      },
      '&:hover': {
        '&::after': {
          bottom: `calc(100% - ${theme.spacing(3.25)})`
        }
      },
      [`& .${classes$s.titleWrapper}`]: {
        display: 'unset',
        minHeight: 'initial',
        [theme.breakpoints.up('lg')]: {
          minHeight: 'auto'
        }
      },
      [`& .${classes$s.title}`]: {
        overflow: 'visible',
        textOverflow: 'initial',
        WebkitLineClamp: 'initial',
        wordWrap: 'normal'
      }
    }
  },
  [`&.${classes$s['dark']}`]: {
    '--text-color': theme.palette.common.white,
    [`& .${classes$s.footer}`]: {
      backgroundColor: theme.palette.grey[500],
      '&::before': {
        backgroundColor: `${alpha(theme.palette.common.black, 0.4)}`
      },
      '&::after': {
        borderBottomColor: theme.palette.common.white
      },
      [`&.${classes$s.active}`]: {
        backgroundColor: `${alpha(theme.palette.common.black, 0.8)}`
      }
    }
  }
}));

const FeatureCard = props => {
  const {
    data,
    modifier,
    onCollapseClick,
    onExpandClick
  } = props;
  const {
    id,
    image,
    title,
    description
  } = data;
  const [isActive, setIsActive] = useState(false);
  return jsxs(Root$8, Object.assign({
    className: classNames(classes$s.root, {
      [classes$s.dark]: modifier === 'dark'
    })
  }, {
    children: [jsx("figure", Object.assign({
      className: classes$s.imageWrapper
    }, {
      children: jsx("img", {
        src: image,
        alt: ""
      })
    })), jsx("footer", Object.assign({
      className: classNames(classes$s.footer, {
        [classes$s.active]: isActive
      }),
      onClick: () => {
        // two functions below give the possibility to pass additional function as a prop
        // if expandable part of the component is closed or open; for example we can pass
        // tracking events like that;
        if (!isActive) onExpandClick === null || onExpandClick === void 0 ? void 0 : onExpandClick();
        if (isActive) onCollapseClick === null || onCollapseClick === void 0 ? void 0 : onCollapseClick();
        setIsActive(!isActive);
      },
      "data-testid": `slider-item-footer-${id}`
    }, {
      children: jsxs(Box, Object.assign({
        className: classes$s.footerBox
      }, {
        children: [jsx("div", Object.assign({
          className: classes$s.titleWrapper
        }, {
          children: jsx(Typography, Object.assign({
            className: classes$s.title,
            variant: "h4"
          }, {
            children: title
          }))
        })), jsx(Typography, Object.assign({
          className: classes$s.description,
          variant: "body1"
        }, {
          children: description
        }))]
      }))
    }))]
  }));
};

const footerHeightMobileSize = '94px';
const footerHeightDesktopSize = '103px';
const itemMobileSize$2 = '326px';
const itemDesktopSize$2 = '364px';
const classes$r = generateUtilityClasses('GC-Link-Card-Product', ['root', 'figure', 'footer', 'type', 'name', 'features']);
const Root$7 = styled$1('a')(({
  theme
}) => ({
  [`&.${classes$r.root}`]: {
    backgroundColor: theme.palette.common.white,
    minWidth: '85vw',
    minHeight: '85vw',
    maxWidth: itemMobileSize$2,
    maxHeight: itemMobileSize$2,
    padding: theme.spacing(3),
    borderRadius: theme.shape.card.borderRadius,
    boxShadow: theme.ourShadows.card,
    scrollSnapAlign: 'start',
    scrollSnapStop: 'always',
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    transition: theme.transitions.create(['all'], {
      duration: '0.2s'
    }),
    [theme.breakpoints.up(374)]: {
      minWidth: itemMobileSize$2,
      minHeight: itemMobileSize$2
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: itemDesktopSize$2,
      minWidth: itemDesktopSize$2
    }
  },
  [`& .${classes$r.figure}`]: {
    position: 'relative',
    flex: 1,
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: theme.transitions.create(['all'], {
      duration: '0.3s'
    }),
    img: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  },
  [`& .${classes$r.footer}`]: {
    backgroundColor: theme.palette.common.white,
    paddingTop: theme.spacing(1),
    minHeight: `${footerHeightMobileSize}`,
    [theme.breakpoints.up('lg')]: {
      minHeight: `${footerHeightDesktopSize}`
    }
  },
  [`& .${classes$r.type}`]: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1)
  },
  [`& .${classes$r.name}`]: {
    color: theme.palette.common.black,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingBottom: theme.spacing(1)
  },
  [`& .${classes$r.features}`]: {
    color: theme.palette.grey[400],
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    wordWrap: 'break-word'
  },
  '@media (hover: hover)': {
    [`&.${classes$r.root}:hover`]: {
      transform: 'translateY(-10px)',
      [`& .${classes$r.figure}`]: {
        transform: 'scale(1.03)'
      }
    }
  }
}));

const ProductCard = props => {
  const {
    data
  } = props;
  return jsxs(Root$7, Object.assign({
    className: classes$r.root,
    href: data.href
  }, {
    children: [jsx("figure", Object.assign({
      className: classes$r.figure
    }, {
      children: jsx("img", {
        src: data.image,
        alt: "product"
      })
    })), jsxs("footer", Object.assign({
      className: classes$r.footer
    }, {
      children: [jsx(Typography, Object.assign({
        className: classes$r.type,
        variant: "overline"
      }, {
        children: data.type
      })), jsx(Typography, Object.assign({
        className: classes$r.name,
        variant: "h4",
        mt: 1
      }, {
        children: data.name
      })), jsx(Typography, Object.assign({
        className: classes$r.features,
        variant: "body2"
      }, {
        children: data.features
      }))]
    }))]
  }));
};

const itemMobileSize$1 = '326px';
const itemDesktopSize$1 = '364px';
const GOLDEN_COLOR = '#D5B367';
const classes$q = generateUtilityClasses('GC-Link-Card-Used-Machine', ['root', 'content', 'croppedText', 'figure', 'icon', 'image', 'name', 'price', 'exclusiveBorder', 'exclusiveTag', 'rentalPrice']);
const StyledLink = styled$1('a')(({
  theme
}) => ({
  boxShadow: theme.ourShadows.card,
  borderRadius: theme.shape.card.borderRadius,
  display: 'flex',
  flexDirection: 'column',
  minHeight: 400,
  maxWidth: itemMobileSize$1,
  minWidth: '100%',
  overflow: 'hidden',
  scrollSnapAlign: 'start',
  scrollSnapStop: 'always',
  transition: theme.transitions.create(['all'], {
    duration: '0.2s'
  }),
  [`&[href]`]: {
    color: theme.palette.common.black,
    textDecoration: 'none'
  },
  [theme.breakpoints.up(374)]: {
    minHeight: itemMobileSize$1,
    minWidth: itemMobileSize$1
  },
  [theme.breakpoints.up('lg')]: {
    minHeight: itemDesktopSize$1,
    minWidth: itemDesktopSize$1
  },
  [`&.${classes$q.root}`]: {
    backgroundColor: theme.palette.common.white
  },
  [`& .${classes$q.figure}`]: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    margin: 0,
    minHeight: 200,
    position: 'relative',
    transition: theme.transitions.create(['transform'], {
      duration: '0.2s'
    })
  },
  [`& .${classes$q.image}`]: {
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    width: '100%'
  },
  [`& .${classes$q.content}`]: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  [`&.${classes$q.exclusiveBorder}`]: {
    border: `1px solid ${GOLDEN_COLOR}`
  },
  [`& .${classes$q.exclusiveTag}`]: {
    background: theme.palette.common.white,
    borderRadius: 2,
    boxShadow: '2px 4px 12px 0px rgba(22, 24, 25, 0.12)',
    color: GOLDEN_COLOR,
    position: 'absolute',
    padding: theme.spacing(0, 0.5),
    right: theme.spacing(1.5),
    top: theme.spacing(1.5)
  },
  [`& .${classes$q.name}`]: {
    maxHeight: theme.spacing(7.5),
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  },
  '@media (hover: hover)': {
    [`&.${classes$q.root}:hover`]: {
      transition: theme.transitions.create(['all'], {
        duration: '0.2s'
      }),
      transform: 'translateY(-10px)',
      [`& .${classes$q.image}`]: {
        transition: theme.transitions.create(['transform'], {
          duration: '0.2s'
        }),
        transform: 'scale(1.03)'
      }
    }
  }
}));
const DetailedInfos = styled$1(Stack)(({
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.grey[400],
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(1.5),
  [`& .${classes$q.croppedText}`]: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  [`& .${classes$q.icon}`]: {
    height: theme.spacing(2.25),
    width: theme.spacing(2.25)
  }
}));
const PricingInfos = styled$1(Stack)(({
  theme
}) => ({
  marginTop: theme.spacing(4),
  [`& .${classes$q.price}`]: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'flex-end'
  },
  [`& .${classes$q.rentalPrice}`]: {
    color: theme.palette.grey[300]
  }
}));

const UsedMachineCard = props => {
  const {
    components = {},
    component = StyledLink,
    data,
    exclusive
  } = props;
  const {
    availableFrom,
    category,
    image,
    location,
    manufactured,
    name,
    operatingData,
    price,
    priceText,
    rentalPrice,
    rentalPriceText,
    rentalPriceUnit,
    url
  } = data;
  const {
    t
  } = useComponentsConfig();
  const Root = components.Root || component;
  const Image = components.Image || 'img';
  const shownPriceText = priceText || 'Net price';
  const hasOnlyRentalPrice = !price && rentalPrice;
  return jsxs(Root, Object.assign({
    href: url,
    className: classNames(classes$q.root, {
      [classes$q.exclusiveBorder]: exclusive
    })
  }, {
    children: [jsxs("figure", Object.assign({
      className: classes$q.figure
    }, {
      children: [jsx(Image, {
        alt: "used-machine",
        className: classes$q.image,
        showPlaceholder: true,
        src: image,
        layout: "fill",
        objectFit: "cover",
        objectPosition: "50% 50%"
      }), exclusive && jsx(Box, Object.assign({
        className: classes$q.exclusiveTag
      }, {
        children: jsx(Typography, Object.assign({
          variant: "overline"
        }, {
          children: t('myGRIMME_exclusive', 'exclusiv').toUpperCase()
        }))
      }))]
    })), jsxs(Stack, Object.assign({
      className: classes$q.content
    }, {
      children: [jsxs(Stack, {
        children: [jsx(Typography, Object.assign({
          color: exclusive ? GOLDEN_COLOR : theme.palette.primary.main,
          mb: 1,
          variant: "overline"
        }, {
          children: category
        })), jsx(Typography, Object.assign({
          className: classes$q.name,
          variant: "h4",
          mb: 2.5
        }, {
          children: name
        })), jsxs(DetailedInfos, {
          children: [jsxs(Stack, Object.assign({
            direction: "row",
            gap: 1,
            alignItems: "center",
            width: "100%"
          }, {
            children: [jsx(FontAwesomeIcon, {
              className: classes$q.icon,
              icon: faLocationDot
            }), jsx(Typography, Object.assign({
              className: classes$q.croppedText,
              variant: "caption"
            }, {
              children: location
            }))]
          })), jsxs(Stack, Object.assign({
            alignItems: "center",
            direction: "row",
            display: "flex",
            gap: 1,
            width: "100%"
          }, {
            children: [operatingData && jsxs(Box, Object.assign({
              alignItems: "center",
              display: "flex",
              mr: 4
            }, {
              children: [jsx(FontAwesomeIcon, {
                className: classes$q.icon,
                icon: faGaugeSimple
              }), jsx(Typography, Object.assign({
                variant: "caption",
                pl: 1
              }, {
                children: operatingData
              }))]
            })), manufactured && jsxs(Box, Object.assign({
              alignItems: "center",
              display: "flex"
            }, {
              children: [jsx(FontAwesomeIcon, {
                className: classes$q.icon,
                icon: faCalendar
              }), jsx(Typography, Object.assign({
                className: classes$q.croppedText,
                pl: 1,
                variant: "caption"
              }, {
                children: manufactured
              }))]
            }))]
          })), availableFrom && jsxs(Stack, Object.assign({
            alignItems: "center",
            direction: 'row',
            gap: 1
          }, {
            children: [jsx(FontAwesomeIcon, {
              className: classes$q.icon,
              color: availableFrom.iconColor,
              icon: availableFrom.icon
            }), jsxs(Typography, Object.assign({
              color: "#BFA05D",
              variant: "caption"
            }, {
              children: [availableFrom.text, " ", availableFrom.date]
            }))]
          }))]
        })]
      }), jsxs(PricingInfos, {
        children: [price && jsxs(Stack, Object.assign({
          className: classes$q.price
        }, {
          children: [jsx(Typography, Object.assign({
            component: "span",
            variant: "caption"
          }, {
            children: shownPriceText
          })), jsx(Typography, Object.assign({
            variant: "h4"
          }, {
            children: price
          }))]
        })), rentalPrice && jsxs(Stack, Object.assign({
          className: classNames(classes$q.price, {
            [classes$q.rentalPrice]: !hasOnlyRentalPrice
          })
        }, {
          children: [jsx(Typography, Object.assign({
            component: "span",
            variant: "caption"
          }, {
            children: rentalPriceText
          })), jsx(Typography, Object.assign({
            variant: hasOnlyRentalPrice ? 'h4' : 'subtitle2'
          }, {
            children: rentalPrice
          })), jsxs(Typography, Object.assign({
            variant: "caption"
          }, {
            children: ["/ ", rentalPriceUnit]
          }))]
        }))]
      })]
    }))]
  }));
};

const PREFIX$8 = 'GC-Loader';
const classes$p = {
  root: `${PREFIX$8}-root`,
  default: `${PREFIX$8}-default`,
  plain: `${PREFIX$8}-plain`,
  animation: `${PREFIX$8}-animation`
};
const StyledBackdrop$1 = styled$1(Backdrop)(({
  theme
}) => ({
  [`&.${classes$p.root}`]: {
    zIndex: 99999
  },
  [`&.${classes$p.default}`]: {
    background: alpha(theme.palette.grey[500], 0.8),
    backdropFilter: 'blur(10px)'
  },
  [`&.${classes$p.plain}`]: {
    background: theme.palette.common.white
  },
  [`& .${classes$p.animation}`]: {
    height: 200,
    width: 200
  }
}));
var LoaderVariants;
(function (LoaderVariants) {
  LoaderVariants["default"] = "default";
  LoaderVariants["plain"] = "plain";
})(LoaderVariants || (LoaderVariants = {}));
const Loader = props => {
  const {
      className,
      variant = LoaderVariants.default
    } = props,
    rest = __rest(props, ["className", "variant"]);
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      const options = {
        path: '/lottie/loader.json',
        autoplay: true,
        container: ref.current,
        loop: true,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
      const animation = lottie.loadAnimation(options);
      return () => animation.destroy();
    }
  }, []);
  return jsx(StyledBackdrop$1, Object.assign({
    "data-testid": "loader"
  }, rest, {
    className: classNames(classes$p.root, classes$p[variant], className),
    open: true
  }, {
    children: jsx("div", {
      ref: ref,
      className: classes$p.animation
    })
  }));
};

const classes$o = generateUtilityClasses('ProductsSkeletonLoader', ['card', 'category', 'grid', 'skeletonItemWrapper', 'subtitle', 'title']);
const showAnimation$1 = keyframes({
  from: {
    opacity: 0,
    transform: 'translateY(-5px)'
  },
  to: {
    opacity: 1,
    transform: 'translateY(0)'
  }
});
const StyledContainer = styled(Container$1)(({
  theme
}) => ({
  [`& .${classes$o.card}`]: {
    backgroundColor: theme.palette.grey[200],
    height: 244,
    width: '100%',
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      height: 158
    }
  },
  [`& .${classes$o.category}`]: {
    backgroundColor: theme.palette.grey[200],
    maxWidth: 50
  },
  [`& .${classes$o.grid}`]: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(14.46)
  },
  [`& .${classes$o.skeletonItemWrapper}`]: {
    animation: `${showAnimation$1} 0.3s linear`,
    backgroundColor: theme.palette.common.white,
    boxShadow: `0px 0px ${theme.spacing(1.25)} #00000033`,
    borderRadius: theme.spacing(0.375)
  },
  [`& .${classes$o.subtitle}`]: {
    backgroundColor: theme.palette.grey[200],
    height: 14,
    marginBottom: theme.spacing(0.125)
  },
  [`& .${classes$o.title}`]: {
    backgroundColor: theme.palette.grey[200],
    maxWidth: 100,
    height: 40
  }
}));
const LoadingIndicator = props => {
  const {
    numberOfItems = 3,
    disableGutters = false
  } = props;
  return jsx(StyledContainer, Object.assign({
    role: "status",
    disableGutters: disableGutters
  }, {
    children: jsx(Grid$1, Object.assign({
      className: classes$o.grid,
      container: true,
      spacing: 2
    }, {
      children: Array.from(Array(numberOfItems).keys()).map((_, index) => jsx(Grid$1, Object.assign({
        item: true,
        xs: 12,
        md: 6,
        lg: 4,
        role: "skeleton-item"
      }, {
        children: jsxs(Box, Object.assign({
          className: classes$o.skeletonItemWrapper
        }, {
          children: [jsx(Skeleton, {
            className: classes$o.card,
            variant: "rectangular"
          }), jsxs(Box, Object.assign({
            padding: 2
          }, {
            children: [jsx(Skeleton, {
              className: classes$o.category,
              variant: "text"
            }), jsx(Skeleton, {
              variant: "text",
              className: classes$o.title
            }), jsx(Skeleton, {
              variant: "text",
              className: classes$o.subtitle
            })]
          }))]
        }))
      }), index))
    }))
  }));
};

const PREFIX$7 = 'GC-MyGrimmeLogo';
const classes$n = {
  my: `${PREFIX$7}-my`,
  grimme: `${PREFIX$7}-grimme`,
  bright: `${PREFIX$7}-bright`,
  dark: `${PREFIX$7}-dark`,
  noisy: `${PREFIX$7}-noisy`
};
const StyledSvgIcon = styled$1(SvgIcon)(({
  theme
}) => ({
  [`& .${classes$n.my}`]: {
    [`&.${classes$n.bright}, &.${classes$n.noisy}`]: {
      color: theme.palette.grey['400']
    },
    [`&.${classes$n.dark}`]: {
      color: alpha$1(theme.palette.common.white, 0.6)
    }
  },
  [`& .${classes$n.grimme}`]: {
    [`&.${classes$n.bright}, &.${classes$n.noisy}`]: {
      color: theme.palette.primary.main
    },
    [`&.${classes$n.dark}`]: {
      color: theme.palette.common.white
    }
  }
}));
const MyGrimmeLogo = props => {
  const {
      modifier
    } = props,
    rest = __rest(props, ["modifier"]);
  return jsxs(StyledSvgIcon, Object.assign({
    viewBox: "0 0 360 60",
    "aria-labelledby": "myGrimme-logo"
  }, rest, {
    children: [jsx("title", Object.assign({
      id: "myGrimme-logo"
    }, {
      children: "myGRIMME"
    })), jsx("path", {
      className: classNames(classes$n.my, classes$n[modifier]),
      d: "M42.48 37.31L39 51.1h-8.84l3.16-12.51a3 3 0 000-2.21 2 2 0 00-1.91-1.14 4.09 4.09 0 00-2.77 1.07 6.62 6.62 0 00-1.82 3.46l-2.91 11.32h-8.83l3-12.09a6.94 6.94 0 00.32-2 1.86 1.86 0 00-.64-1.33 2.19 2.19 0 00-1.5-.51 4.12 4.12 0 00-2.77 1.1 6.89 6.89 0 00-1.89 3.6L8.83 51.09H0l5.55-22h8.22L13 32.34a16.32 16.32 0 014.32-2.86 11.74 11.74 0 014.58-.84 7.32 7.32 0 014.12.93 4.89 4.89 0 011.92 2.77 18.94 18.94 0 014.52-2.93 11.62 11.62 0 014.41-.77 6.09 6.09 0 015.23 2.09c.99 1.4 1.13 3.6.38 6.58zm22-8.17l-7.67 14.62-1.51-14.62h-9l4.1 22a7.3 7.3 0 01-2.25 2.44 5.17 5.17 0 01-2.69.69 13.67 13.67 0 01-3.46-.46l-1.46 5.69h.05a32.71 32.71 0 005.76.5c6.57 0 10-3 13.62-8.67 3.76-5.87 13.15-22.21 13.15-22.21z"
    }), jsx("path", {
      className: classNames(classes$n.grimme, classes$n[modifier]),
      d: "M161.65 8.78a8.92 8.92 0 0117.84 0 8.86 8.86 0 01-8.92 8.79 8.86 8.86 0 01-8.92-8.79zm19.92-5.15a11.12 11.12 0 010 10.08h135.88l2.44-9.65.11-.43zm-22 0H83.25v.12l-2.4 9.78v.18h78.77a11.34 11.34 0 010-10.08zm14.94 16.48h-13.06l-8.14 31h13.3l7.92-31zm85.62 0l-9.33 16.11-.11-.11-.75-16h-17.32v.11l-8 30.88h12.95l4.21-15.64.08.07 1.59 15.57h7.36l9.06-14.1.7-.87v.11l-3.51 13.57-.35 1.34h13.13l8.36-31zm-51.6 0l-9.33 16.11-.12-.11-.76-16H181v.11l-8 30.88h13l4.21-15.64.08.07 1.59 15.57h7.36l9.01-14.1.7-.87v.11l-3.51 13.57-.34 1.34h13.12l8.37-31zm67.92 31h31.39s1.92-7.91 1.93-7.9h-18l.85-3.23h17.92l1.7-6.25.13-.44h-18v-.18c.22-1 .52-1.95.76-2.92h17.85c1-3.27 1.77-6.55 2.7-9.89v-.19h-31.21c-.07.07-8 31-8 31zM153.86 27.28a17.82 17.82 0 01-1.62 6.36 8.57 8.57 0 01-7.13 4.7l-3.26.25c2.7 4.22 5.77 8.29 8.5 12.51h-15.18c-2.22-3.42-4.25-6.84-6.51-10.25-.58 2.11-2.87 10.25-2.87 10.25h-13.38l8-31h26.25c2.62.11 5.39.83 6.54 3.46a8.19 8.19 0 01.66 3.05zm-14.41 1.78a16.07 16.07 0 00-4.21-.37c-1.18 0-2.4.08-3.51.08-.63 2.14-1.29 4.29-1.7 6.44 1.7 0 3.48.1 5.21.07 1.07 0 4.79-.15 5.14-3.53.11-1.07 0-2.15-.93-2.69zM93.91 30a92.12 92.12 0 0118.26.44l2.43-8.29.16-.56h-.08c-2.51-.54-5.1-1-7.65-1.31-7.65-.61-16.52-1.45-23.35 1.36-5.14 2.11-6.87 7.42-8.2 12-.89 4.73-3.18 11.38 1.14 15.2 3.07 2.32 7.06 2.48 11 2.7a92.62 92.62 0 0019-1.64l.3-.09 4.36-15.43H95.72l-1.62 6h4.07c-.29 1.09-.64 2.44-1 3.49 0 0-6.8.88-8.76-.73-2-2.4-.4-5.74.23-8.33A7 7 0 0193.9 30z"
    })]
  }));
};

const classes$m = generateUtilityClasses('LoginWithMyGRIMME', ['root']);
const StyledCard$2 = styled$1(Card)(({
  theme
}) => ({
  [`&.${classes$m.root}`]: {
    display: 'inline-flex',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[0],
    cursor: 'pointer',
    outline: `2px solid ${theme.palette.common.transparent}`,
    padding: theme.spacing(1),
    transition: theme.transitions.create(['border', 'box-shadow', 'outline']),
    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow: theme.shadows[1],
      borderWidth: 1,
      outline: `2px solid ${theme.palette.primary.main}`
    },
    '& > div, & > div:last-child': {
      alignItems: 'center',
      display: 'flex',
      padding: theme.spacing(2),
      '& > svg': {
        width: theme.spacing(12)
      }
    }
  }
}));
const LoginWithMyGRIMME = props => {
  const {
      className,
      fullWidth,
      loginHandler,
      title
    } = props,
    rest = __rest(props, ["className", "fullWidth", "loginHandler", "title"]);
  return jsx(StyledCard$2, Object.assign({
    className: classNames(className, classes$m.root),
    onClick: loginHandler,
    sx: fullWidth ? {
      width: 1
    } : null
  }, rest, {
    children: jsxs(CardContent, {
      children: [jsx(MyGrimmeLogo, {
        modifier: "bright"
      }), jsx(Typography, Object.assign({
        variant: "body1"
      }, {
        children: title
      }))]
    })
  }));
};

const PREFIX$6 = 'GC-BentoIcon';
const classes$l = generateUtilityClasses(PREFIX$6, ['root', 'bentoMenu', 'bentoDot', 'firstDotInteraction', 'secondDotInteraction', 'thirdDotInteraction', 'fourthDotInteraction', 'fifthDotInteraction', 'sixthDotInteraction', 'seventhDotInteraction', 'eighthDotInteraction', 'ninethDotInteraction']);
const StyledRoot = styled('div')(({
  theme
}) => ({
  [`& .${classes$l.bentoMenu}`]: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(3, 1fr)',
    gridColumnGap: '2px',
    gridRowGap: '2px',
    height: '24px',
    width: '24px',
    border: `1px solid ${theme.palette.common.transparent}`
  },
  [`& .${classes$l.firstDotInteraction}`]: getStyles({
    translation: {
      x: 4,
      y: 4
    },
    rotation: 45,
    borderRadius: {
      topLeft: 0,
      topRight: 0,
      bottomLeft: 0,
      bottomRight: 0
    }
  }),
  [`& .${classes$l.secondDotInteraction}`]: getStyles({
    translation: {
      x: -8,
      y: 0
    },
    rotation: -45,
    borderRadius: {
      topLeft: 25,
      topRight: 25,
      bottomLeft: 0,
      bottomRight: 0
    }
  }),
  [`& .${classes$l.thirdDotInteraction}`]: getStyles({
    translation: {
      x: -4,
      y: 4
    },
    rotation: -45,
    borderRadius: {
      topLeft: 0,
      topRight: 0,
      bottomLeft: 0,
      bottomRight: 0
    }
  }),
  [`& .${classes$l.fourthDotInteraction}`]: getStyles({
    translation: {
      x: 0,
      y: 8
    },
    rotation: 45,
    borderRadius: {
      topLeft: 0,
      topRight: 0,
      bottomLeft: 25,
      bottomRight: 25
    }
  }),
  [`& .${classes$l.fifthDotInteraction}`]: getStyles({
    translation: {
      x: 0,
      y: 0
    },
    rotation: -45,
    borderRadius: {
      topLeft: 0,
      topRight: 0,
      bottomLeft: 0,
      bottomRight: 0
    }
  }),
  [`& .${classes$l.sixthDotInteraction}`]: getStyles({
    translation: {
      x: 0,
      y: -8
    },
    rotation: 45,
    borderRadius: {
      topLeft: 25,
      topRight: 25,
      bottomLeft: 0,
      bottomRight: 0
    }
  }),
  [`& .${classes$l.seventhDotInteraction}`]: getStyles({
    translation: {
      x: 4,
      y: -4
    },
    rotation: 45,
    borderRadius: {
      topLeft: 0,
      topRight: 0,
      bottomLeft: 0,
      bottomRight: 0
    }
  }),
  [`& .${classes$l.eighthDotInteraction}`]: getStyles({
    translation: {
      x: 8,
      y: 0
    },
    rotation: -45,
    borderRadius: {
      topLeft: 0,
      topRight: 0,
      bottomLeft: 25,
      bottomRight: 25
    }
  }),
  [`& .${classes$l.ninethDotInteraction}`]: getStyles({
    translation: {
      x: -4,
      y: -4
    },
    rotation: -45,
    borderRadius: {
      topLeft: 0,
      topRight: 0,
      bottomLeft: 0,
      bottomRight: 0
    }
  })
}));
const StyledBento = styled('div')(({
  theme
}) => ({
  width: '6px',
  height: '6px',
  borderRadius: '25px',
  transition: theme.transitions.create(['border-radius', 'transform'], {
    duration: '0.2s'
  }),
  backgroundColor: theme.palette.common.white
}));
const getStyles = ({
  translation,
  rotation,
  borderRadius
}) => {
  return {
    transform: `translate(${translation.x}px,${translation.y}px) rotate(${rotation}deg)`,
    borderRadius: `${borderRadius.topLeft}px ${borderRadius.topRight}px ${borderRadius.bottomRight}px ${borderRadius.bottomLeft}px`
  };
};
const BentoIcon = props => {
  const {
    open
  } = props;
  return jsx(StyledRoot, {
    children: jsxs(Box, Object.assign({
      className: classes$l.bentoMenu,
      "data-testid": "bento"
    }, {
      children: [jsx(StyledBento, {
        className: classNames({
          [classes$l.firstDotInteraction]: open
        })
      }), jsx(StyledBento, {
        className: classNames({
          [classes$l.secondDotInteraction]: open
        })
      }), jsx(StyledBento, {
        className: classNames({
          [classes$l.thirdDotInteraction]: open
        })
      }), jsx(StyledBento, {
        className: classNames({
          [classes$l.fourthDotInteraction]: open
        })
      }), jsx(StyledBento, {
        className: classNames({
          [classes$l.fifthDotInteraction]: open
        })
      }), jsx(StyledBento, {
        className: classNames({
          [classes$l.sixthDotInteraction]: open
        })
      }), jsx(StyledBento, {
        className: classNames({
          [classes$l.seventhDotInteraction]: open
        })
      }), jsx(StyledBento, {
        className: classNames({
          [classes$l.eighthDotInteraction]: open
        })
      }), jsx(StyledBento, {
        className: classNames({
          [classes$l.ninethDotInteraction]: open
        })
      })]
    }))
  });
};

const PREFIX$5 = 'GC-Navbar-ContactLink';
const classes$k = generateUtilityClasses(PREFIX$5, ['root', 'iconWrapper', 'informationWrapper', 'title']);
const StyledBox$6 = styled(Box)(({
  theme
}) => ({
  [`&.${classes$k.root}`]: {
    cursor: 'pointer',
    display: 'flex',
    marginTop: theme.spacing(2)
  },
  [`& .${classes$k.iconWrapper}`]: {
    marginRight: theme.spacing(2)
  },
  [`& .${classes$k.informationWrapper}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '100%'
  },
  [`& .${classes$k.title}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  }
}));
const ContactLink = props => {
  const {
    icon,
    onClick,
    title
  } = props;
  return jsxs(StyledBox$6, Object.assign({
    className: classes$k.root,
    onClick: onClick
  }, {
    children: [jsx("div", Object.assign({
      className: classes$k.iconWrapper
    }, {
      children: icon
    })), jsx("div", Object.assign({
      className: classes$k.informationWrapper
    }, {
      children: jsx("div", Object.assign({
        className: classes$k.title
      }, {
        children: jsx(Typography, Object.assign({
          variant: "body1"
        }, {
          children: title
        }))
      }))
    }))]
  }));
};

const classes$j = generateUtilityClasses('GC-Navbar-Menus', ['icon', 'link', 'selected']);
const Root$6 = styled(Grid$1)(({
  theme
}) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    display: 'none'
  }
}));
const Accordion = styled(Accordion$1)(({
  theme
}) => ({
  backgroundColor: theme.palette.common.transparent,
  color: theme.palette.common.white,
  border: 'none',
  opacity: 0.5,
  '&::before': {
    display: 'none'
  },
  '&.Mui-expanded': {
    opacity: 1
  }
}));
const AccordionSummary = styled(AccordionSummary$1)(({
  theme
}) => ({
  padding: 0,
  [`& .${classes$j.icon}`]: {
    marginRight: theme.spacing(1.5),
    alignSelf: 'center'
  },
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(3)
  }
}));
const StyledFontAwesomeIcon$1 = styled(FontAwesomeIcon)(({
  theme
}) => ({
  color: theme.palette.common.white
}));
const AccordionDetails = styled(AccordionDetails$1)(({
  theme
}) => ({
  padding: 0
}));
const Sublinks = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  [`& .${classes$j.link}`]: {
    padding: theme.spacing(1.5, 0, 1.5, 3.5),
    color: 'inherit',
    cursor: 'pointer',
    textDecoration: 'none',
    opacity: 0.5,
    '&:hover': {
      opacity: 1
    }
  }
}));
const Links = styled(Box)(({
  theme
}) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(3),
  margin: theme.spacing(1.5, 0),
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(3)
  },
  [`& .${classes$j.link}`]: {
    display: 'flex',
    color: 'inherit',
    cursor: 'pointer',
    textDecoration: 'none',
    opacity: 0.5,
    '&:hover': {
      opacity: 1
    },
    [`& .${classes$j.icon}`]: {
      marginRight: theme.spacing(1.5),
      alignSelf: 'center'
    }
  }
}));
const Section = styled(Grid$1)(({
  theme
}) => ({
  flex: 1,
  display: 'none',
  flexDirection: 'row',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));
const MegaLinks = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(10)
  }
}));
const MegaLink = styled(Box)(({
  theme
}) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'row',
  [`& .${classes$j.link}`]: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    color: 'inherit',
    cursor: 'pointer',
    textDecoration: 'none',
    opacity: 0.5,
    width: '100%',
    height: '35px',
    '&:hover': {
      opacity: 1
    },
    [`&.${classes$j.selected}`]: {
      opacity: 1
    }
  }
}));
const MegaSublinks = styled(Box)(({
  theme
}) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  marginRight: theme.spacing(3),
  [`& .${classes$j.link}`]: {
    display: 'flex',
    alignItems: 'center',
    color: 'inherit',
    cursor: 'pointer',
    textDecoration: 'none',
    width: '100%',
    height: '35px',
    '&:hover': {
      color: theme.palette.primary.light
    },
    [`&.${classes$j.selected}`]: {
      opacity: 1
    }
  }
}));
function AccordionMenu(props) {
  const {
    isAuthenticated = false,
    LinkComponent = Link,
    links,
    onSelect,
    selected
  } = props;
  const visibilityFilter = useCallback(l => l.visibility === Visibility.BOTH || l.visibility === (isAuthenticated ? Visibility.AUTH : Visibility.UNAUTH), [isAuthenticated]);
  return jsx(Root$6, Object.assign({
    as: "section",
    item: true,
    md: 9
  }, {
    children: links.filter(visibilityFilter).map(link => {
      var _a, _b, _c;
      return ((_a = link.subitems) === null || _a === void 0 ? void 0 : _a.length) > 0 ? jsxs(Accordion, Object.assign({
        disableGutters: true,
        elevation: 0,
        expanded: selected === link
      }, {
        children: [jsxs(AccordionSummary, Object.assign({
          expandIcon: jsx(StyledFontAwesomeIcon$1, {
            icon: faAngleDown
          }),
          onClick: onSelect(link)
        }, {
          children: [link.icon && /*#__PURE__*/cloneElement(link.icon, {
            className: classNames(classes$j.icon, link.icon.props.className)
          }), jsx(Typography, Object.assign({
            variant: "h4"
          }, {
            children: link.label
          }))]
        })), jsx(AccordionDetails, {
          children: link.subitems.length > 0 && jsx(Sublinks, {
            children: (_c = (_b = link.subitems) === null || _b === void 0 ? void 0 : _b.filter(visibilityFilter)) === null || _c === void 0 ? void 0 : _c.map(sublink => jsx(LinkComponent, Object.assign({
              className: classes$j.link,
              href: sublink.url
            }, {
              children: jsx(Typography, Object.assign({
                variant: "h4"
              }, {
                children: sublink.label
              }))
            }), sublink.label))
          })
        })]
      }), `${link.label}-accordion`) : jsx(Links, {
        children: jsxs(LinkComponent, Object.assign({
          href: link.url,
          className: classes$j.link
        }, {
          children: [link.icon && /*#__PURE__*/cloneElement(link.icon, {
            className: classNames(classes$j.icon, link.icon.props.className)
          }), jsx(Typography, Object.assign({
            variant: "h4"
          }, {
            children: link.label
          }))]
        }))
      }, `${link.label}-link`);
    })
  }));
}
function MegaMenu(props) {
  var _a, _b;
  const {
    isAuthenticated,
    LinkComponent = Link,
    links,
    onSelect,
    selected
  } = props;
  const visibilityFilter = useCallback(l => l.visibility === Visibility.BOTH || l.visibility === (isAuthenticated ? Visibility.AUTH : Visibility.UNAUTH), [isAuthenticated]);
  return jsxs(Section, Object.assign({
    as: "section",
    item: true,
    md: 9
  }, {
    children: [jsx(MegaLinks, {
      children: links.filter(visibilityFilter).map(link => jsx(MegaLink, Object.assign({
        onClick: onSelect(link)
      }, {
        children: jsxs(LinkComponent, Object.assign({
          href: (!link.subitems || link.subitems.length === 0) && link.url,
          className: classNames(classes$j.link, {
            [classes$j.selected]: selected === link
          })
        }, {
          children: [link.icon && /*#__PURE__*/cloneElement(link.icon, {
            className: classNames(classes$j.icon, link.icon.props.className)
          }), jsx(Typography, Object.assign({
            variant: "h4",
            sx: {
              flex: 1
            }
          }, {
            children: link.label
          })), (link === null || link === void 0 ? void 0 : link.subitems) && jsx(StyledFontAwesomeIcon$1, {
            icon: faAngleRight
          })]
        }))
      }), link.label))
    }), jsx(MegaSublinks, {
      children: (_b = (_a = selected === null || selected === void 0 ? void 0 : selected.subitems) === null || _a === void 0 ? void 0 : _a.filter(visibilityFilter)) === null || _b === void 0 ? void 0 : _b.map(sublink => jsx(LinkComponent, Object.assign({
        className: classNames(classes$j.link, {
          [classes$j.selected]: selected === sublink
        }),
        href: sublink.url
      }, {
        children: jsx(Typography, Object.assign({
          variant: "h4",
          sx: {
            flex: 1
          }
        }, {
          children: sublink.label
        }))
      }), `${selected.label}-${sublink.label}`))
    })]
  }));
}

const classes$i = generateUtilityClasses('GC-Navbar-Drawer', ['paper', 'nav', 'aside', 'topLinksContainer', 'topLinksTitle', 'topLinks', 'link', 'sideLinks', 'socialLinks', 'socialLink', 'additionalLinks']);
const Drawer = styled(Drawer$1)(({
  theme
}) => ({
  backdropFilter: 'blur(0px)',
  [`.Mui-expanded + &`]: {
    backdropFilter: theme.mixins.blur.element
  },
  [`& .${classes$i.paper}`]: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(7, 2, 3),
    backgroundColor: theme.palette.common.transparent,
    backgroundImage: `linear-gradient(297deg, ${alpha(theme.palette.primary.main, 0.9)}, ${alpha(theme.palette.primary.dark, 0.9)})`,
    color: theme.palette.common.white,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(7, 3, 3)
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(15, 9, 3)
    }
  },
  [`& .${classes$i.nav}`]: {
    flex: 1,
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row'
    }
  },
  [`& .${classes$i.aside}`]: {
    flex: 0,
    paddingTop: theme.spacing(3),
    borderTop: `1px solid ${theme.palette.common.white}`,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      padding: theme.spacing(2, 3),
      borderLeft: `1px solid ${theme.palette.common.white}`,
      borderTop: 'none'
    }
  },
  [`& .${classes$i.topLinksContainer}`]: {
    display: 'flex',
    flexDirection: 'column'
  },
  [`& .${classes$i.topLinksTitle}`]: {
    marginBottom: theme.spacing(2),
    color: theme.palette.common.white,
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(3)
    }
  },
  [`& .${classes$i.topLinks}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(0)
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      marginBottom: theme.spacing(4)
    }
  },
  [`& .${classes$i.link}`]: {
    color: theme.palette.common.white,
    textDecoration: 'none',
    [`&:hover`]: {
      color: theme.palette.primary.light
    }
  },
  [`& .${classes$i.sideLinks}`]: {
    flex: 0,
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'flex-end'
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start'
    }
  },
  [`& .${classes$i.additionalLinks}`]: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      marginTop: theme.spacing(2)
    }
  },
  [`& .${classes$i.socialLinks}`]: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end'
  },
  [`& .${classes$i.socialLink}`]: {
    color: theme.palette.common.white
  }
}));
function NavbarDrawer(props) {
  const {
    additionalLinks,
    isAuthenticated,
    links,
    onBackdropClick,
    open,
    socialLinks,
    topLinks,
    topLinksLabel = 'Top Links',
    LinkComponent = Link
  } = props;
  const [selected, setSelected] = useState(null);
  const menuProps = {
    isAuthenticated,
    links,
    LinkComponent,
    selected,
    onSelect: link => () => selected === link ? setSelected(null) : setSelected(link)
  };
  return jsx(Drawer, Object.assign({
    anchor: "top",
    "data-testid": "links-data-drawer",
    onBackdropClick: onBackdropClick,
    open: open,
    PaperProps: {
      className: classes$i.paper
    },
    ModalProps: {
      disablePortal: true
    }
  }, {
    children: jsxs(Grid$1, Object.assign({
      className: classes$i.nav,
      component: "nav",
      container: true,
      maxWidth: "lg"
    }, {
      children: [jsx(AccordionMenu, Object.assign({}, menuProps)), jsx(MegaMenu, Object.assign({}, menuProps)), jsxs(Grid$1, Object.assign({
        className: classes$i.aside,
        component: "aside",
        item: true,
        md: 3
      }, {
        children: [jsxs(Grid$1, Object.assign({
          className: classes$i.topLinksContainer,
          item: true
        }, {
          children: [jsx(Typography, Object.assign({
            className: classes$i.topLinksTitle,
            variant: "overline"
          }, {
            children: topLinksLabel
          })), jsx(Grid$1, Object.assign({
            className: classes$i.topLinks,
            item: true
          }, {
            children: topLinks === null || topLinks === void 0 ? void 0 : topLinks.map(link => jsx(LinkComponent, Object.assign({
              className: classes$i.link,
              href: link.url
            }, {
              children: link.label
            }), `tl-${link.label}-${link.url}`))
          }))]
        })), jsxs(Grid$1, Object.assign({
          className: classes$i.sideLinks,
          container: true,
          item: true
        }, {
          children: [jsx(Grid$1, Object.assign({
            className: classes$i.additionalLinks,
            item: true
          }, {
            children: additionalLinks === null || additionalLinks === void 0 ? void 0 : additionalLinks.map(link => jsx(LinkComponent, Object.assign({
              className: classes$i.link,
              href: link.url
            }, {
              children: link.label
            }), `al-${link.label}-${link.url}`))
          })), jsx(Grid$1, Object.assign({
            className: classes$i.socialLinks,
            item: true
          }, {
            children: socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.map((link, i) => jsx(IconButton, Object.assign({
              className: classes$i.socialLink,
              LinkComponent: "a",
              href: link.url
            }, {
              children: link.icon
            }), `sl-${link.url}`))
          }))]
        }))]
      }))]
    }))
  }));
}

const classes$h = generateUtilityClasses('GC-Navbar', ['expanded', 'logo']);
const Background = styled(Box)(({
  theme
}) => ({
  backdropFilter: theme.mixins.blur.element,
  backgroundColor: alpha(theme.palette.grey[500], 0.4),
  color: theme.palette.common.white,
  height: theme.spacing(7),
  position: 'fixed',
  left: 0,
  transition: theme.transitions.create(['background-color', 'backdrop-filter']),
  top: 0,
  width: '100%',
  zIndex: theme.zIndex.drawer - 1,
  [`&.${classes$h.expanded}`]: {
    backdropFilter: 'blur(0px)',
    backgroundColor: theme.palette.common.transparent
  }
}));
const LogoContainer = styled(Container$1)(({
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.common.white,
  display: 'flex',
  height: theme.spacing(7),
  left: 0,
  position: 'fixed',
  right: 0,
  top: 0,
  width: '100%',
  zIndex: theme.zIndex.drawer + 1,
  [theme.breakpoints.up('md')]: {
    justifyContent: 'center'
  },
  [`& .${classes$h.logo}`]: {
    height: theme.spacing(3),
    width: 'auto',
    cursor: 'pointer'
  }
}));
const Actions = styled(Box)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row-reverse',
  height: theme.spacing(7),
  paddingRight: theme.spacing(0.5),
  position: 'fixed',
  right: 0,
  top: 0,
  zIndex: theme.zIndex.drawer + 1,
  [theme.breakpoints.up('sm')]: {
    paddingRight: theme.spacing(1)
  }
}));
const Navbar = props => {
  const {
    additionalLinks,
    children,
    isAuthenticated,
    logoProps,
    links,
    onLogoClick,
    socialLinks,
    topLinks,
    topLinksLabel
  } = props;
  const [open, setOpen] = useState(false);
  return jsxs(Fragment, {
    children: [jsx(Background, {
      className: classNames({
        [classes$h.expanded]: open
      })
    }), jsx(NavbarDrawer, {
      additionalLinks: additionalLinks,
      isAuthenticated: isAuthenticated,
      links: links,
      onBackdropClick: () => setOpen(false),
      open: open,
      socialLinks: socialLinks,
      topLinks: topLinks,
      topLinksLabel: topLinksLabel
    }), jsx(LogoContainer, {
      children: jsx(GrimmeLogo, Object.assign({
        modifier: "dark",
        onClick: onLogoClick
      }, logoProps, {
        className: classNames(classes$h.logo, logoProps === null || logoProps === void 0 ? void 0 : logoProps.className)
      }))
    }), jsxs(Actions, {
      children: [jsx(IconButton, Object.assign({
        color: "inherit",
        "data-testid": "burger-menu-icon",
        onClick: () => setOpen(value => !value),
        size: "large"
      }, {
        children: jsx(BentoIcon, {
          open: open
        })
      })), children]
    })]
  });
};
Navbar.ContactLink = ContactLink;

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='180' height='130' viewBox='0 0 180 130'%3e %3cdefs%3e %3clinearGradient id='linear-gradient' x1='0.804' y1='0.927' x2='0.16' y2='-0.039' gradientUnits='objectBoundingBox'%3e %3cstop offset='0' stop-color='%23c31924'/%3e %3cstop offset='1' stop-color='%23620d12'/%3e %3c/linearGradient%3e %3c/defs%3e %3cg id='Group_8405' data-name='Group 8405' transform='translate(-1567.827 -3938.651)'%3e %3ccircle id='Ellipse_897' data-name='Ellipse 897' cx='10.202' cy='10.202' r='10.202' transform='translate(1618.455 3990.917)' fill='%23efefef'/%3e %3cpath id='Path_23250' data-name='Path 23250' d='M363.48%2c287.388h70.289v3.8H372.453A27.3%2c27.3%2c0%2c0%2c0%2c345%2c318.346v43.215h-7.691a1.275%2c1.275%2c0%2c0%2c1-1.282-1.268V314.542a27.3%2c27.3%2c0%2c0%2c1%2c27.453-27.154Z' transform='translate(1235.42 3678.953)' fill='%23efefef'/%3e %3cpath id='Path_23251' data-name='Path 23251' d='M460.527%2c541.571V514.75H477.64v26.821a1.483%2c1.483%2c0%2c0%2c1-1.481%2c1.481H462.008A1.483%2c1.483%2c0%2c0%2c1%2c460.527%2c541.571Z' transform='translate(1150.473 3525.598)' fill='%23232323'/%3e %3cpath id='Path_23252' data-name='Path 23252' d='M325.027%2c356.271v-47.5a28.554%2c28.554%2c0%2c0%2c1%2c28.521-28.521H426.06v77.667H326.673A1.647%2c1.647%2c0%2c0%2c1%2c325.027%2c356.271ZM425.4%2c280.908H353.548a27.9%2c27.9%2c0%2c0%2c0-27.863%2c27.863v47.5a.988.988%2c0%2c0%2c0%2c.987.987H425.4Z' transform='translate(1242.8 3683.353)' fill='%233f3d56'/%3e %3cpath id='Path_23253' data-name='Path 23253' d='M450.62%2c271.373a5.93%2c5.93%2c0%2c0%2c1-5.924-5.924V223a.988.988%2c0%2c0%2c0-.987-.987H420.673a1.647%2c1.647%2c0%2c0%2c1-1.646-1.646V204.9a1.647%2c1.647%2c0%2c0%2c1%2c1.646-1.645H454.9a1.647%2c1.647%2c0%2c0%2c1%2c1.645%2c1.645v60.554a5.931%2c5.931%2c0%2c0%2c1-5.924%2c5.924Z' transform='translate(1178.615 3735.401)' fill='%23c31924'/%3e %3cpath id='Path_23254' data-name='Path 23254' d='M601.786%2c278.25h0a18.72%2c18.72%2c0%2c0%2c1%2c18.759%2c18.68V351H657.4A5.583%2c5.583%2c0%2c0%2c1%2c663%2c356.575H583.027V296.93A18.719%2c18.719%2c0%2c0%2c1%2c601.786%2c278.25Z' transform='translate(1064.352 3684.699)' fill='%23232323'/%3e %3cpath id='Path_23255' data-name='Path 23255' d='M626.28%2c285.813l3.885%2c16.046%2c75.982-18.394-3.884-16.046a1.2%2c1.2%2c0%2c0%2c0-.776-.854%2c1.183%2c1.183%2c0%2c0%2c0-.439-.066l-43.921-22.741a1.212%2c1.212%2c0%2c0%2c0-1.532.368l-21.168%2c29.518-7.98%2c11.131a.169.169%2c0%2c0%2c0-.029.138%2c1.2%2c1.2%2c0%2c0%2c0-.137.9Z' transform='translate(1035.356 3708.313)' fill='white'/%3e %3cpath id='Path_23256' data-name='Path 23256' d='M626.758%2c284.913a.161.161%2c0%2c0%2c0%2c.067.1.185.185%2c0%2c0%2c0%2c.143.028.178.178%2c0%2c0%2c0%2c.1-.068l.027-.038.416-.581%2c7.546-10.519%2c21.161-29.511a.862.862%2c0%2c0%2c1%2c1.093-.262L700.89%2c266.63l.391.2a.447.447%2c0%2c0%2c0%2c.049.017.527.527%2c0%2c0%2c1%2c.089-.009.169.169%2c0%2c0%2c0%2c.1-.081.172.172%2c0%2c0%2c0-.072-.233l-.054-.029-43.921-22.741a1.212%2c1.212%2c0%2c0%2c0-1.532.368l-21.168%2c29.518-7.98%2c11.131A.169.169%2c0%2c0%2c0%2c626.758%2c284.913Z' transform='translate(1035.016 3708.313)' fill='%233f3d56'/%3e %3cpath id='Path_23257' data-name='Path 23257' d='M693.45%2c273.551l1.691.188%2c12.553%2c1.391%2c8.321.921.492.055%2c10.384-8.111.4-.311%2c2.453-1.915%2c8.725-6.814.052-.479%2c3.1-28.011a1.466%2c1.466%2c0%2c0%2c0-1.293-1.616L698.91%2c224.26a1.466%2c1.466%2c0%2c0%2c0-1.616%2c1.293l-2.189%2c19.758-1.214%2c10.954-1.086%2c9.8-.5%2c4.551-.147%2c1.318a1.467%2c1.467%2c0%2c0%2c0%2c1.295%2c1.616Z' transform='translate(991.144 3721.312)' fill='%23b7b7b7'/%3e %3cpath id='Path_23258' data-name='Path 23258' d='M726.786%2c290.695l17.941%2c1.987%2c6.363.7a2.152%2c2.152%2c0%2c0%2c0%2c.474-4.278l-7.914-.876-16.389-1.817a2.153%2c2.153%2c0%2c0%2c0-.475%2c4.28Z' transform='translate(969.189 3679.435)' fill='white'/%3e %3cpath id='Path_23259' data-name='Path 23259' d='M723.968%2c314.857c.046.008.093.017.14.021l20.827%2c2.307%2c3.477.386a2.153%2c2.153%2c0%2c0%2c0%2c.474-4.28l-5.028-.556-16.5-1.828-2.776-.308a2.152%2c2.152%2c0%2c0%2c0-.615%2c4.258Z' transform='translate(970.986 3663.156)' fill='white'/%3e %3cpath id='Path_23260' data-name='Path 23260' d='M719.795%2c338.293a2.152%2c2.152%2c0%2c0%2c0%2c1.606%2c1.029l8.536.945%2c15.2%2c1.684h0l.486.054%2c2.453-1.915a2.124%2c2.124%2c0%2c0%2c0%2c0-.438%2c2.157%2c2.157%2c0%2c0%2c0-1.9-1.917l-2.112-.235-8.378-.927-6.028-.669-7.786-.863a2.152%2c2.152%2c0%2c0%2c0-2.08%2c3.251Z' transform='translate(972.802 3646.705)' fill='white'/%3e %3cpath id='Path_23261' data-name='Path 23261' d='M752.955%2c261.22l4.464.494%2c1.972.219%2c2.979.33a2.153%2c2.153%2c0%2c0%2c0%2c.473-4.28l-9.412-1.042a2.152%2c2.152%2c0%2c0%2c0-.475%2c4.279Z' transform='translate(952.613 3699.389)' fill='white'/%3e %3cpath id='Path_23262' data-name='Path 23262' d='M645.86%2c282.509%2c651.3%2c304.99l9.084%2c1.727%2c8.4%2c1.6%2c9.015%2c1.715%2c2.881.548a1.209%2c1.209%2c0%2c0%2c0%2c.967-.234l2.311-1.8%2c1.463-1.143%2c10.384-8.111-6.6-27.273a1.467%2c1.467%2c0%2c0%2c0-1.767-1.078l-40.5%2c9.8A1.465%2c1.465%2c0%2c0%2c0%2c645.86%2c282.509Z' transform='translate(1023.404 3689.817)' fill='%23c31924'/%3e %3cpath id='Path_23263' data-name='Path 23263' d='M683.741%2c343.379a2.154%2c2.154%2c0%2c0%2c0%2c2.6%2c1.586l23.766-5.753a2.156%2c2.156%2c0%2c0%2c0%2c1.585-2.6.657.657%2c0%2c0%2c0-.023-.081%2c2.152%2c2.152%2c0%2c0%2c0-2.575-1.5l-23.766%2c5.753A2.155%2c2.155%2c0%2c0%2c0%2c683.741%2c343.379Z' transform='translate(998.16 3646.739)' fill='white'/%3e %3cpath id='Path_23264' data-name='Path 23264' d='M690.082%2c365.567l8.4%2c1.6%2c17.8-4.309a2.152%2c2.152%2c0%2c1%2c0-1.013-4.184l-23.765%2c5.753a2.137%2c2.137%2c0%2c0%2c0-1.233.827A2.161%2c2.161%2c0%2c0%2c0%2c690.082%2c365.567Z' transform='translate(993.799 3630.826)' fill='white'/%3e %3cpath id='Path_23265' data-name='Path 23265' d='M743.008%2c386.778l2.881.548a1.209%2c1.209%2c0%2c0%2c0%2c.967-.234l2.311-1.8Z' transform='translate(958.265 3612.893)' fill='white'/%3e %3cpath id='Path_23266' data-name='Path 23266' d='M698.291%2c313.934a2.154%2c2.154%2c0%2c0%2c0%2c2.6%2c1.586l9.205-2.228a2.156%2c2.156%2c0%2c0%2c0%2c1.586-2.6%2c2.126%2c2.126%2c0%2c0%2c0-.4-.818%2c2.154%2c2.154%2c0%2c0%2c0-2.2-.767l-9.2%2c2.228A2.153%2c2.153%2c0%2c0%2c0%2c698.291%2c313.934Z' transform='translate(988.59 3664.192)' fill='white'/%3e %3cpath id='Path_23267' data-name='Path 23267' d='M655.656%2c336.65l9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm26.933-9.392.088.363.4-.311Zm-26.933%2c9.392%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm0%2c0%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm-29.376-4.208%2c10.174%2c42.029a1.207%2c1.207%2c0%2c0%2c0%2c1.455.888l73.639-17.827a1.207%2c1.207%2c0%2c0%2c0%2c.888-1.455l-10.174-42.029a1.2%2c1.2%2c0%2c0%2c0-.776-.854%2c1.182%2c1.182%2c0%2c0%2c0-.439-.066%2c1.138%2c1.138%2c0%2c0%2c0-.5.131%2c1.049%2c1.049%2c0%2c0%2c0-.2.124l-6.044%2c4.719-8.777%2c6.856-2.941%2c2.3v0h0L671.8%2c335.676l-1.783%2c1.4-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.016-1.716-9.025-1.716-19.766-3.762a1.182%2c1.182%2c0%2c0%2c0-.509.011%2c1.209%2c1.209%2c0%2c0%2c0-.588.341%2c1.348%2c1.348%2c0%2c0%2c0-.162.214A1.2%2c1.2%2c0%2c0%2c0%2c626.28%2c332.442Zm29.376%2c4.208%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm0%2c0%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm0%2c0%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Z' transform='translate(1035.356 3661.253)' fill='white'/%3e %3cpath id='Path_23268' data-name='Path 23268' d='M655.656%2c336.65l9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm26.933-9.392.088.363.4-.311Zm-26.933%2c9.392%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm0%2c0%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm-28.9-5.082.045.034a.467.467%2c0%2c0%2c1%2c.03-.036.87.87%2c0%2c0%2c1%2c.785-.253l19.642%2c3.737%2c8.4%2c1.6%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716-9.024-1.716-19.766-3.762a1.182%2c1.182%2c0%2c0%2c0-.509.011Zm-.473.874%2c10.174%2c42.029a1.207%2c1.207%2c0%2c0%2c0%2c1.455.888l73.639-17.827a1.207%2c1.207%2c0%2c0%2c0%2c.888-1.455l-10.174-42.029a1.2%2c1.2%2c0%2c0%2c0-.776-.854%2c1.182%2c1.182%2c0%2c0%2c0-.439-.066%2c1.138%2c1.138%2c0%2c0%2c0-.5.131%2c1.049%2c1.049%2c0%2c0%2c0-.2.124l-6.044%2c4.719-8.777%2c6.856-2.941%2c2.3v0h0L671.8%2c335.676l-1.783%2c1.4-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.016-1.716-9.025-1.716-19.766-3.762a1.182%2c1.182%2c0%2c0%2c0-.509.011%2c1.209%2c1.209%2c0%2c0%2c0-.588.341%2c1.348%2c1.348%2c0%2c0%2c0-.162.214A1.2%2c1.2%2c0%2c0%2c0%2c626.28%2c332.442Zm.336-.081a.855.855%2c0%2c0%2c1%2c.152-.721.111.111%2c0%2c0%2c1%2c.03-.039c.007-.012.021-.023.03-.036a.87.87%2c0%2c0%2c1%2c.785-.253l19.642%2c3.737%2c8.4%2c1.6%2c9.017%2c1.716%2c2.88.548a1.215%2c1.215%2c0%2c0%2c0%2c.967-.234l2.313-1.805%2c1.462-1.143%2c10.382-8.112.4-.311%2c2.451-1.915%2c8.727-6.815%2c6.309-4.927a.856.856%2c0%2c0%2c1%2c.325-.157.663.663%2c0%2c0%2c1%2c.1-.017.529.529%2c0%2c0%2c1%2c.089-.009.881.881%2c0%2c0%2c1%2c.3.048.864.864%2c0%2c0%2c1%2c.555.61L712.1%2c356.158a.862.862%2c0%2c0%2c1-.636%2c1.042l-73.639%2c17.826a.862.862%2c0%2c0%2c1-1.039-.636Zm29.041%2c4.289%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm0%2c0%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Zm0%2c0%2c9.017%2c1.716%2c2.88.548a1.214%2c1.214%2c0%2c0%2c0%2c.967-.234l2.313-1.805-.812.2-1.713%2c1.336a.867.867%2c0%2c0%2c1-.691.167l-2.132-.406-9.017-1.716Z' transform='translate(1035.356 3661.253)' fill='%233f3d56'/%3e %3ccircle id='Ellipse_898' data-name='Ellipse 898' cx='2.304' cy='2.304' r='2.304' transform='translate(1626.268 3998.159)' fill='white'/%3e %3cpath id='Path_18596' data-name='Path 18596' d='M6.664%2c3.526a30.655%2c30.655%2c0%2c0%2c1%2c6.13.148L13.613.847l.053-.19H13.64C12.794.468%2c11.933.322%2c11.069.21%2c8.5%2c0%2c5.523-.285%2c3.227.668%2c1.5%2c1.389.918%2c3.2.472%2c4.764.175%2c6.377-.6%2c8.647.851%2c9.949a6.433%2c6.433%2c0%2c0%2c0%2c3.71.918%2c30.4%2c30.4%2c0%2c0%2c0%2c6.367-.557l.1-.03%2c1.464-5.263H7.265s-.548%2c2.059-.544%2c2.059l1.367.011c-.1.379-.214.832-.337%2c1.193%2c0%2c0-2.285.3-2.941-.248-.658-.819-.137-1.96.074-2.844a2.349%2c2.349%2c0%2c0%2c1%2c1.78-1.661Z' transform='translate(1728.637 4008.665) rotate(-13.5)' fill='url(%23linear-gradient)'/%3e %3c/g%3e%3c/svg%3e";

const EMAIL_REGEX =
// eslint-disable-next-line no-useless-escape
/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const classes$g = generateUtilityClasses('BlogNewsletterSection', ['button', 'container', 'formWrapper', 'image', 'infoWrapper', 'successMessageWrapper', 'svgWrapper', 'textField']);
const Root$5 = styled$1('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.background.paper,
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(8)
  },
  [`& .${classes$g.container}`]: {
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  [`& .${classes$g.svgWrapper}`]: {
    height: 111,
    margin: '0 auto',
    marginBottom: theme.spacing(3),
    position: 'relative',
    width: 111,
    [theme.breakpoints.up('md')]: {
      height: 180,
      marginBottom: 0,
      marginRight: theme.spacing(12),
      width: 180
    }
  },
  [`& .${classes$g.infoWrapper}`]: {
    flex: 1,
    h4: {
      marginBottom: theme.spacing(2)
    },
    p: {
      marginBottom: theme.spacing(3)
    }
  },
  [`& .${classes$g.formWrapper}`]: {
    display: 'flex',
    maxWidth: 552,
    [`& .${classes$g.textField}`]: {
      flex: 1,
      marginRight: theme.spacing(2)
    },
    [`& .${classes$g.button}`]: {
      gap: theme.spacing(1),
      height: 40,
      minWidth: 40,
      padding: theme.spacing(2)
    },
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gap: theme.spacing(2),
      [`& .${classes$g.textField}`]: {
        marginRight: 0
      }
    }
  },
  [`& .${classes$g.successMessageWrapper}`]: {
    flex: 1,
    h4: {
      marginBottom: theme.spacing(2)
    }
  }
}));

var FormStatus;
(function (FormStatus) {
  FormStatus["IDLE"] = "idle";
  FormStatus["SUCCESS"] = "success";
  FormStatus["ERROR"] = "error";
  FormStatus["SENDING"] = "sending";
})(FormStatus || (FormStatus = {}));
function Newsletter(props) {
  const {
    onSubscribe
  } = props;
  const [formStatus, setFormStatus] = useState(FormStatus.IDLE);
  const [email, setEmail] = useState('');
  const {
    t
  } = useComponentsConfig();
  const subscribeButtonLabel = t('myGRIMME_website_blog_newsletter_button_subscribe', 'Newsletter erhalten');
  const emailLabel = t('myGRIMME_website_blog_newsletter_email_label', 'Deine Email Adresse');
  const errorText = t('myGRIMME_gnc_global_validation_email', 'Bitte geben Sie eine gültige E-Mailadresse ein');
  const subtitle = t('myGRIMME_website_blog_newsletter_subtitle', 'Melde Dich für unseren Newsletter an und bekomme die Neuigkeiten von GRIMME aus erster Hand.');
  const successSubtitle = t('myGRIMME_website_blog_newsletter_success_subtitle', 'Wir werden Dir unsere Neuigkeiten zusenden.');
  const successTitle = t('myGRIMME_website_blog_newsletter_success_title', 'Danke, dass Du Dich zu unserem Newsletter angemeldet hast.');
  const title = t('myGRIMME_website_blog_newsletter_title', 'Du möchtest keine Neuigkeiten mehr verpassen? Bleibe immer mit uns in Verbindung.');
  const handleSubmit = () => __awaiter(this, void 0, void 0, function* () {
    if (!EMAIL_REGEX.test(email)) {
      setFormStatus(FormStatus.ERROR);
      return;
    }
    setFormStatus(FormStatus.SENDING);
    if (onSubscribe) {
      yield onSubscribe(email);
      setFormStatus(FormStatus.SUCCESS);
      return;
    }
    setFormStatus(FormStatus.ERROR);
  });
  return jsx(Root$5, {
    children: jsxs(Container$1, Object.assign({
      className: classes$g.container
    }, {
      children: [jsx("figure", Object.assign({
        className: classes$g.svgWrapper
      }, {
        children: jsx(Image, {
          alt: "Newsletter",
          className: classes$g.image,
          src: img,
          layout: "fill"
        })
      })), [FormStatus.IDLE, FormStatus.SENDING, FormStatus.ERROR].includes(formStatus) && jsxs(Box, Object.assign({
        className: classes$g.infoWrapper,
        role: "form-section"
      }, {
        children: [jsx(Typography, Object.assign({
          variant: "h4"
        }, {
          children: title
        })), jsx(Typography, Object.assign({
          variant: "body1"
        }, {
          children: subtitle
        })), jsxs("form", Object.assign({
          className: classes$g.formWrapper
        }, {
          children: [jsx(TextField, {
            className: classes$g.textField,
            label: emailLabel,
            helperText: formStatus === FormStatus.ERROR && errorText,
            value: email,
            onChange: e => setEmail(e.target.value)
          }), jsxs(Button, Object.assign({
            loading: formStatus === FormStatus.SENDING,
            "data-testid": "submit-button",
            className: classes$g.button,
            variant: "primary",
            onClick: handleSubmit
          }, {
            children: [subscribeButtonLabel, jsx(FontAwesomeIcon, {
              icon: faPaperPlane
            })]
          }))]
        }))]
      })), formStatus === FormStatus.SUCCESS && jsxs(Box, Object.assign({
        className: classes$g.successMessageWrapper,
        role: "success-message"
      }, {
        children: [jsx(Typography, Object.assign({
          variant: "h4"
        }, {
          children: successTitle
        })), jsx(Typography, Object.assign({
          variant: "body1"
        }, {
          children: successSubtitle
        }))]
      }))]
    }))
  });
}

const classes$f = generateUtilityClasses('GC-NotificationIcon', ['success', 'error', 'warning', 'info']);
const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({
  theme
}) => ({
  fontSize: theme.spacing(3),
  padding: theme.spacing(0.5, 1, 0.5, 0),
  [`&.${classes$f.success}`]: {
    color: theme.palette.success.main
  },
  [`&.${classes$f.error}`]: {
    color: theme.palette.error.main
  },
  [`&.${classes$f.warning}`]: {
    color: theme.palette.warning.main
  },
  [`&.${classes$f.info}`]: {
    color: theme.palette.info.main
  }
}));
const NotificationIcon = props => {
  switch (props.variant) {
    case 'success':
      return jsx(StyledFontAwesomeIcon, {
        className: classes$f.success,
        "data-testid": 'success-icon',
        icon: faCircleCheck
      });
    case 'error':
      return jsx(StyledFontAwesomeIcon, {
        className: classes$f.error,
        "data-testid": 'error-icon',
        icon: faCircleXmark
      });
    case 'warning':
      return jsx(StyledFontAwesomeIcon, {
        className: classes$f.warning,
        "data-testid": 'warning-icon',
        icon: faCircleExclamation
      });
    case 'info':
      return jsx(StyledFontAwesomeIcon, {
        className: classes$f.info,
        "data-testid": 'info-icon',
        icon: faCircleInfo
      });
    default:
      return null;
  }
};

const classes$e = generateUtilityClasses('GC-NotificationContent', ['icon', 'iconClose', 'iconClear', 'message']);
const Root$4 = styled(Stack)(({
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.ourShadows.dialog,
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  padding: theme.spacing(2, 2, 2.375),
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    marginRight: theme.spacing(2),
    width: 343
  },
  [`& .${classes$e.message}`]: {
    color: theme.palette.grey[400],
    padding: theme.spacing(0.25, 3.5, 0, 1),
    wordBreak: 'break-word'
  },
  [`& .${classes$e.icon}`]: {
    height: theme.spacing(3),
    marginRight: theme.spacing(-1),
    marginTop: theme.spacing(-1),
    padding: 0,
    width: theme.spacing(3)
  }
}));
const NotificationContent = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    message,
    variant
  } = props;
  const {
    closeSnackbar
  } = useSnackbar();
  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);
  return jsxs(Root$4, Object.assign({
    ref: ref
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: "row"
    }, {
      children: [jsx(NotificationIcon, {
        variant: variant
      }), jsx(Typography, Object.assign({
        className: classes$e.message,
        variant: "body2"
      }, {
        children: message
      }))]
    })), jsx(IconButton, Object.assign({
      "aria-label": "Dismiss",
      className: classes$e.icon,
      edge: "end",
      onClick: handleDismiss,
      size: "small"
    }, {
      children: jsx(FontAwesomeIcon, {
        icon: faXmark
      })
    }))]
  }));
});

const notistackRef = /*#__PURE__*/React__default.createRef();
/**
 * An object mapping translation keys to their default values.
 */
const DEFAULT_NOTIFICATION_MESSAGE = {
  myGRIMME_core_machine_add_success: 'Die Maschine wurde erfolgreich hinzugefügt.',
  myGRIMME_core_machine_add_failure: 'Die Maschine konnte nicht hinzugefügt werden. Bitte versuche es später erneut.',
  myGRIMME_core_login_success: 'Sie wurden erfolgreich eingeloggt.',
  myGRIMME_core_login_failure: 'Etwas ging schief. Bitte versuchen Sie es noch einmal.',
  myGRIMME_core_account_form_success: 'Deine Daten wurden erfolgreich aktualisiert.',
  myGRIMME_core_account_form_failure: 'Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.',
  myGRIMME_core_machine_rename_success: 'Die Maschine würde erfolgreich umbenannt.',
  myGRIMME_core_machine_rename_failure: 'Es ist ein Fehler aufgetreten. Die Maschine konnte nicht umbenannt werden.',
  myGRIMME_core_machine_delete_success: 'Die Maschine würde erfolgreich gelöscht.',
  myGRIMME_core_machine_delete_failure: 'Es ist ein Fehler aufgetreten. Die Maschine konnte nicht gelöscht werden.',
  myGRIMME_marketplace_appointment_failure: 'Der Termin konnte nicht hinzugefügt werden. Bitte versuchen Sie es später erneut.',
  myGRIMME_marketplace_offer_failure: 'Das Angebot konnte nicht hinzugefügt werden. Bitte versuchen Sie es später erneut.',
  myGRIMME_marketplace_rental_failure: 'Das Mietangebot konnte nicht hinzugefügt werden. Bitte versuchen Sie es später erneut.',
  myGRIMME_products_cms_failure: 'Leider konnte der Inhalt der Website nicht geladen werden. Bitte versuchen Sie es später erneut.',
  myGRIMME_products_configurator_failure: 'Es ist ein Fehler aufgetreten. Die Maschine konnte nicht konfiguriert werden.',
  myGRIMME_products_offer_failure: 'Das Angebot konnte nicht hinzugefügt werden. Bitte versuchen Sie es später erneut.',
  myGRIMME_products_categories_failure: 'Kategorien konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
  myGRIMME_products_contact_form_success: 'Ihre Nachricht wurde erfolgreich versendet. Wir melden uns bald.',
  myGRIMME_products_contact_form_failure: 'Ihre Nachricht konnte leider nicht versendet werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt wieder.',
  myGRIMME_products_fetch_failure: 'Die Produkts konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
  myGRIMME_products_exchange_dialog_success: 'Ihre Anfrage wird nun verarbeitet. Wir melden uns bald.',
  myGRIMME_products_exchange_dialog_failure: 'Ihre Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es später erneut.',
  myGRIMME_marketplace_download_pdf_start: 'Das Laden des PDF-Downloads kann bis zu 12 Sekunden dauern. Bitte aktualisieren oder schließen Sie den Tab nicht',
  myGRIMME_marketplace_download_pdf_complete: 'Download erfolgreich abgeschlossen',
  myGRIMME_marketplace_download_pdf_error: 'Beim Herunterladen der PDF-Datei ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut'
};
var notificationType;
(function (notificationType) {
  notificationType[notificationType["DEFAULT"] = 1] = "DEFAULT";
  notificationType[notificationType["FAV_DEALER_DIALOG"] = 2] = "FAV_DEALER_DIALOG";
  notificationType[notificationType["CHANGE_FAV_DEALER_DIALOG"] = 3] = "CHANGE_FAV_DEALER_DIALOG";
})(notificationType || (notificationType = {}));
/**
 * Generator function for pseudo-random id generation
 */
const generateNotificationId = (max = 1000) => Math.floor(Math.random() * Math.floor(max));

const NOTIFICATIONS_FEATURE_KEY = 'notifications';
const buildNotification = (variant, message, code = notificationType.DEFAULT) => ({
  code,
  id: generateNotificationId(),
  message,
  variant
});
const notificationsAdapter = createEntityAdapter({
  selectId: entity => entity.id
});
/**
 * Notification slice
 */
const notificationSlice = createSlice({
  name: NOTIFICATIONS_FEATURE_KEY,
  initialState: notificationsAdapter.getInitialState(),
  reducers: {
    addNotification: (state, action) => {
      notificationsAdapter.addOne(state, buildNotification('default', action.payload.message, action.payload.code));
    },
    addErrorNotification: (state, action) => {
      notificationsAdapter.addOne(state, buildNotification('error', action.payload.message, action.payload.code));
    },
    addInfoNotification: (state, action) => {
      notificationsAdapter.addOne(state, buildNotification('info', action.payload.message, action.payload.code));
    },
    addSuccessNotification: (state, action) => {
      notificationsAdapter.addOne(state, buildNotification('success', action.payload.message, action.payload.code));
    },
    addWarningNotification: (state, action) => {
      notificationsAdapter.addOne(state, buildNotification('warning', action.payload.message, action.payload.code));
    },
    removeNotification: notificationsAdapter.removeOne
  }
});
const notificationsActions = notificationSlice.actions;
const notificationsReducer = notificationSlice.reducer;
/**
 * Selector for whole notifications state
 */
const selectNotificationsState = rootState => rootState[NOTIFICATIONS_FEATURE_KEY];
const {
  selectAll
} = notificationsAdapter.getSelectors();
/**
 * Selector for all notifications
 */
const selectNotifications = createSelector(selectNotificationsState, selectAll);
/**
 * HOC for adding notifications reducer
 */
function withNotificationsReducer(reducer) {
  return Object.assign(Object.assign({}, reducer), {
    [NOTIFICATIONS_FEATURE_KEY]: notificationsReducer
  });
}

// eslint-disable-next-line @typescript-eslint/ban-types
const NotificationsRenderer = props => {
  const {
    children
  } = props;
  const dispatch = useDispatch();
  const notifications = useSelector(selectNotifications);
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    t
  } = useComponentsConfig();
  React__default.useEffect(() => {
    notifications === null || notifications === void 0 ? void 0 : notifications.forEach(notification => {
      const {
        code,
        id,
        variant,
        message
      } = notification;
      if (code === notificationType.DEFAULT) {
        enqueueSnackbar({
          message: t(message, DEFAULT_NOTIFICATION_MESSAGE[message]),
          variant: variant
        },
        //TODO: fix this workaround; the first argument is a string in notistack v2 and v3.
        {
          key: message
        });
        dispatch(notificationsActions.removeNotification(id));
      }
    });
  }, [dispatch, enqueueSnackbar, notifications, t]);
  return jsx(Fragment, {
    children: children
  });
};

const NotificationsProvider = props => {
  return jsx(SnackbarProvider, Object.assign({
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    autoHideDuration: 6000,
    dense: true,
    //TODO: terrible workaround to fix the issue with notifications; once it is working, this has to be fixed.
    content: (key, notification) => jsx(NotificationContent, Object.assign({
      id: key
    }, notification)),
    maxSnack: 5,
    ref: notistackRef,
    preventDuplicate: true
  }, {
    children: jsx(NotificationsRenderer, {
      children: props.children
    })
  }));
};

const GrimmeComponentsProvider = (
// eslint-disable-next-line @typescript-eslint/ban-types
props) => {
  const {
    children
  } = props;
  return jsx(NotificationsProvider, {
    children: children
  });
};

const StyledMenuItem = styled(MenuItem)(({
  theme
}) => ({
  color: theme.palette.grey[400],
  fontStyle: 'italic'
}));

const convertJsxToString = element => {
  if (typeof element === 'string') {
    return element;
  } else if (Array.isArray(element)) {
    return element.map(convertJsxToString).join('');
  } else if ( /*#__PURE__*/isValidElement(element)) {
    const {
      children
    } = element.props;
    if (children) {
      return convertJsxToString(children);
    }
  }
  return '';
};

function Select(props) {
  const {
    fullWidth,
    label,
    modifier = 'light',
    multiple,
    noValueOption,
    options,
    size = 'small',
    value
  } = props;
  const customIcon = ({
    className
  }) => jsx(FontAwesomeIcon, {
    className: className,
    icon: faCaretDown,
    style: {
      position: 'relative',
      right: theme.spacing(2),
      top: 0
    }
  });
  const renderSelectedLabels = selectedValues => {
    if (!Array.isArray(selectedValues)) {
      const selectedOption = options.find(option => option.value === selectedValues);
      return selectedOption ? convertJsxToString(selectedOption.label) : '';
    } else {
      return selectedValues.map(selectedValue => {
        const selectedOption = options.find(option => option.value === selectedValue);
        return selectedOption ? convertJsxToString(selectedOption.label) : '';
      }).join(', ');
    }
  };
  return jsxs(FormControl, Object.assign({
    className: `MuiFormControl-root--${modifier}-modifier`,
    fullWidth: fullWidth,
    size: size
  }, {
    children: [jsx(InputLabel, {
      children: label
    }), jsxs(Select$1, Object.assign({}, props, {
      IconComponent: customIcon,
      id: "grimme-select",
      name: "grimme-select",
      renderValue: selected => renderSelectedLabels(selected),
      inputProps: {
        name: 'grimme-select',
        id: 'grimme-select'
      }
    }, {
      children: [noValueOption && jsx(StyledMenuItem, Object.assign({
        value: noValueOption.value
      }, {
        children: noValueOption.label
      }), noValueOption.value), options.map(option => jsxs(MenuItem, Object.assign({
        value: option.value,
        sx: {
          paddingLeft: multiple ? 0.5 : 2
        }
      }, {
        children: [multiple && jsx(Checkbox, {
          checked: value.includes(option.value)
        }), option.label]
      }), option.value))]
    }))]
  }));
}

const classes$d = generateUtilityClasses('GC-SelectionCard', ['root', 'disabled', 'selected']);
const StyledCard$1 = styled$1(Card)(({
  theme
}) => ({
  [`&.${classes$d.root}`]: {
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    cursor: 'pointer',
    border: `solid ${theme.spacing(0.25)} ${theme.palette.grey[200]}`,
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create(['border-color', 'box-shadow', 'color']),
    [`&.${classes$d.selected}`]: {
      borderColor: `${theme.palette.primary.main}`,
      boxShadow: `0 0 0 0px ${theme.palette.common.white}, 0 0 0 4px ${alpha(theme.palette.primary.main, 0.75)}, 0 0 rgba(0,0,0,0)`
    },
    '@media (hover: hover)': {
      '&:hover': {
        borderColor: `${theme.palette.grey[200]}`,
        boxShadow: `0 0 0 0px ${theme.palette.common.white}, 0 0 0 4px ${alpha(theme.palette.primary.main, 0.75)}, 0 0 rgba(0,0,0,0)`
      }
    },
    [`&.${classes$d.disabled}`]: {
      opacity: 0.5,
      '@media (hover: hover)': {
        '&:hover': {
          boxShadow: theme.shadows[0]
        }
      },
      [`&.${classes$d.selected}`]: {
        opacity: 1,
        borderColor: `${theme.palette.grey[300]}`,
        boxShadow: `0 0 0 0px ${theme.palette.common.white}, 0 0 0 4px ${alpha(theme.palette.grey[300], 0.75)}, 0 0 rgba(0,0,0,0)`
      }
    }
  }
}));
var SelectionCardDirection;
(function (SelectionCardDirection) {
  SelectionCardDirection["COLUMN"] = "column";
  SelectionCardDirection["ROW"] = "row";
})(SelectionCardDirection || (SelectionCardDirection = {}));
const SelectionCard = props => {
  const {
      children,
      className,
      direction,
      disabled,
      onClick,
      selected
    } = props,
    rest = __rest(props, ["children", "className", "direction", "disabled", "onClick", "selected"]);
  return jsx(StyledCard$1, Object.assign({}, rest, {
    "aria-disabled": disabled,
    className: classNames(classes$d.root, {
      [classes$d.disabled]: disabled
    }, {
      [classes$d.selected]: selected
    }, className),
    elevation: 0,
    onClick: !disabled ? onClick : undefined
  }, {
    children: children
  }));
};

function SeoSection(props) {
  const {
      title,
      subtitle,
      titleProps,
      subtitleProps
    } = props,
    rest = __rest(props, ["title", "subtitle", "titleProps", "subtitleProps"]);
  return jsxs(Container$1, Object.assign({}, rest, {
    children: [jsx(Typography, Object.assign({
      variant: "h2",
      align: "center"
    }, titleProps, {
      children: title
    })), jsx(Typography, Object.assign({
      variant: "subtitle1",
      align: "center",
      mt: "16px"
    }, subtitleProps, {
      children: subtitle
    })), jsx(TitleDivider, {
      variant: "center"
    })]
  }));
}

const itemMobileSize = '326px';
const itemDesktopSize = '364px';
const classes$c = generateUtilityClasses('GC-SlideCustom', ['root', 'figure', 'type', 'name', 'features']);
const Root$3 = styled$1('a')(({
  theme
}) => ({
  [`&.${classes$c.root}`]: {
    backgroundColor: theme.palette.common.white,
    minWidth: '85vw',
    maxWidth: itemMobileSize,
    maxHeight: itemMobileSize,
    borderRadius: theme.shape.card.borderRadius,
    boxShadow: theme.ourShadows.card,
    scrollSnapAlign: 'start',
    scrollSnapStop: 'always',
    textDecoration: 'none',
    transition: theme.transitions.create(['all'], {
      duration: '0.2s'
    }),
    //TODO: use theme.breakpoints.values here
    [theme.breakpoints.up(374)]: {
      minWidth: itemMobileSize
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
      minWidth: itemDesktopSize
    }
  },
  [`& .${classes$c.figure}`]: {
    margin: 0,
    transition: theme.transitions.create(['all'], {
      duration: '0.3s'
    }),
    img: {
      width: '100%'
    }
  },
  '@media (hover: hover)': {
    [`&.${classes$c.root}:hover`]: {
      transform: 'translateY(-10px)',
      [`& .${classes$c.figure}`]: {
        transform: 'scale(1.03)'
      }
    }
  }
}));

const SlideCustom = props => {
  const {
    children,
    className,
    href
  } = props;
  return jsx(Root$3, Object.assign({
    className: classNames(classes$c.root, className),
    href: href
  }, {
    children: children
  }));
};

const Slide = props => {
  switch (props.type) {
    case 'feature':
      return jsx(FeatureCard, Object.assign({}, props));
    case 'product':
      return jsx(ProductCard, Object.assign({}, props));
    case 'blog':
      return jsx(BlogCard, Object.assign({}, props));
    case 'custom':
      return jsx(SlideCustom, Object.assign({}, props));
    case 'used-machine':
      return jsx(UsedMachineCard, Object.assign({}, props));
    default:
      return jsx("p", {
        children: "Please set a valid type!"
      });
  }
};

const classes$b = generateUtilityClasses('GC-Slider', ['active', 'centered', 'navigationalButton', 'navigationalButtonRight', 'wrapper', 'wrapperItemsList', 'wrapperDark', 'wrapperShowPrev', 'wrapperShowNext', 'wrapperFooter', 'wrapperFooterDark']);
const Root$2 = styled$1('section')(({
  theme
}) => ({
  [`&.${classes$b.wrapper}`]: {
    position: 'relative',
    margin: '0 auto',
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1.5),
    width: '100%',
    '@media (hover: none) and (pointer: coarse)': {
      width: '100vw',
      left: `-${theme.spacing(2)}`,
      paddingLeft: 0,
      paddingRight: 0,
      [theme.breakpoints.up(600)]: {
        left: `-${theme.spacing(3)}`
      }
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      left: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  [`& .${classes$b['wrapperItemsList']}`]: {
    overflow: 'hidden',
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.up('lg')]: {
      left: `-${theme.spacing(0.5)}`
    },
    '@media (hover: none) and (pointer: coarse)': {
      left: 0
    },
    '& > div': {
      display: 'flex',
      overflowX: 'scroll',
      scrollSnapType: 'x mandatory',
      padding: theme.spacing(2, 0.5),
      scrollPadding: theme.spacing(0.5),
      gap: theme.spacing(2),
      scrollBehavior: 'smooth',
      scrollbarWidth: 'none',
      '@media (hover: none) and (pointer: coarse)': {
        padding: theme.spacing(2),
        scrollPadding: theme.spacing(2)
      },
      [theme.breakpoints.up(600)]: {
        '@media (hover: none) and (pointer: coarse)': {
          padding: theme.spacing(3),
          scrollPadding: theme.spacing(3)
        }
      },
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(3, 1),
        gap: theme.spacing(3),
        '@media (hover: none) and (pointer: coarse)': {
          scrollPadding: theme.spacing(1)
        }
      },
      '&::-webkit-scrollbar': {
        width: 0,
        height: 0
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'transparent'
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent'
      }
    }
  },
  [`& .${classes$b.navigationalButton}`]: {
    position: 'absolute',
    color: theme.palette.common.black,
    border: 0,
    height: '32px',
    minWidth: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    outline: 'none',
    opacity: 0,
    cursor: 'default',
    left: -24,
    top: '50%',
    transform: 'translateY(-50%)',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
    '@media (hover: none) and (pointer: coarse)': {
      display: 'none'
    },
    [theme.breakpoints.up('lg')]: {
      left: -36
    }
  },
  [`& .${classes$b.navigationalButtonRight}`]: {
    left: 'calc(100% - 9px)',
    '&::before': {
      borderRight: 0,
      borderLeft: `8px solid ${theme.palette.common.black}`
    },
    [theme.breakpoints.up('lg')]: {
      left: 'calc(100% - 2px)'
    }
  },
  [`& .${classes$b.wrapperFooter}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
    zIndex: 2,
    '& > button': {
      display: 'inline-block',
      height: 4,
      width: 16,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey[300],
      border: 0,
      outline: 'none',
      cursor: 'pointer'
    },
    [`& > button.${classes$b.active}`]: {
      backgroundColor: theme.palette.common.black
    }
  },
  [`& .${classes$b.wrapperFooterDark}`]: {
    [`& > button.${classes$b.active}`]: {
      backgroundColor: theme.palette.common.white
    }
  },
  // VARIATIONS
  [`& .${classes$b.centered}`]: {
    display: 'flex',
    justifyContent: 'center'
  },
  [`&.${classes$b['wrapperShowPrev']}`]: {
    [`& .${classes$b.navigationalButton}:first-of-type`]: {
      opacity: 1,
      cursor: 'pointer'
    }
  },
  [`&.${classes$b['wrapperShowNext']}`]: {
    [`& .${classes$b.navigationalButton}:last-of-type`]: {
      opacity: 1,
      cursor: 'pointer'
    }
  },
  [`&.${classes$b['wrapperDark']}`]: {
    [`& .${classes$b.navigationalButton}:first-of-type::before`]: {
      borderRightColor: theme.palette.common.white
    },
    [`& .${classes$b.navigationalButton}:last-of-type::before`]: {
      borderLeftColor: theme.palette.common.white
    }
  }
}));

const getNavigationButtonState = state => {
  const {
    reference,
    scroll,
    padding
  } = state;
  const {
    scrollWidth,
    offsetWidth
  } = reference.current || {};
  const showPrev = scroll > padding;
  const showIndicators = scrollWidth > offsetWidth;
  const showNext = showIndicators && (scroll === 0 || scroll < scrollWidth - offsetWidth - padding);
  return {
    showPrev,
    showNext,
    showIndicators
  };
};

const DEFAULT_ITEM_WIDTH = 326;
const Slider = props => {
  const {
    centered,
    children,
    dots = true,
    modifier = 'light',
    moveTo,
    sliderClassName,
    trackClassName
  } = props;
  const itemsContainerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(DEFAULT_ITEM_WIDTH);
  const [currentScrollPosition, setCurrentScrollPosition] = useState(0);
  const [itemWidth, setItemWidth] = useState(DEFAULT_ITEM_WIDTH);
  const {
    spacing
  } = useTheme();
  const navigationData = {
    reference: itemsContainerRef,
    scroll: currentScrollPosition,
    padding: parseInt(spacing(4), 10)
  };
  const {
    showPrev,
    showNext,
    showIndicators
  } = getNavigationButtonState(navigationData);
  const showDots = dots && showIndicators;
  const buttonClasses = classNames(classes$b.navigationalButton, classes$b.navigationalButtonRight);
  const footerClasses = classNames(classes$b.wrapperFooter, {
    [classes$b.wrapperFooterDark]: modifier === 'dark'
  });
  const rootClasses = classNames(classes$b.wrapper, {
    [classes$b.wrapperDark]: modifier === 'dark',
    [classes$b.wrapperShowPrev]: showPrev,
    [classes$b.wrapperShowNext]: showNext
  }, sliderClassName);
  const handleOnClickNavigation = direction => {
    const scrollPositionToReplace = direction === 'next' ? itemsContainerRef.current.scrollLeft + itemWidth : itemsContainerRef.current.scrollLeft - itemWidth;
    itemsContainerRef.current.scroll({
      top: 0,
      left: scrollPositionToReplace
    });
  };
  const handleListeningScroll = event => {
    setCurrentScrollPosition(event.target.scrollLeft);
    if (itemsContainerRef.current.offsetWidth !== containerWidth) {
      setContainerWidth(itemsContainerRef.current.offsetWidth);
    }
    if (itemsContainerRef.current.children[0].offsetWidth !== itemWidth) {
      setItemWidth(itemsContainerRef.current.children[0].offsetWidth);
    }
  };
  const handleOnClickIndicator = useCallback(index => {
    var _a;
    (_a = itemsContainerRef === null || itemsContainerRef === void 0 ? void 0 : itemsContainerRef.current) === null || _a === void 0 ? void 0 : _a.scroll({
      top: 0,
      left: index * itemWidth
    });
  }, [itemWidth]);
  useEffect(() => {
    //If prop moveTo is defined/passed we should run the carousel;
    moveTo !== undefined && handleOnClickIndicator(moveTo);
  }, [moveTo, handleOnClickIndicator]);
  useEffect(() => {
    if (itemsContainerRef.current) {
      setContainerWidth(itemsContainerRef.current.offsetWidth);
      setItemWidth(itemsContainerRef.current.children[0] ? itemsContainerRef.current.children[0].offsetWidth : DEFAULT_ITEM_WIDTH);
    }
  }, [itemsContainerRef]);
  return jsxs(Root$2, Object.assign({
    "data-testid": "slider-wrapper",
    className: rootClasses
  }, {
    children: [jsx(IconButton, Object.assign({
      className: classes$b.navigationalButton,
      disabled: !showPrev,
      onClick: () => handleOnClickNavigation('prev')
    }, {
      children: jsx(FontAwesomeIcon, {
        icon: faCaretLeft
      })
    })), jsx("section", Object.assign({
      className: classNames(classes$b.wrapperItemsList, {
        [classes$b.centered]: centered
      })
    }, {
      children: jsx("div", Object.assign({
        className: trackClassName,
        "data-testid": "slider-track",
        ref: itemsContainerRef,
        onScroll: handleListeningScroll
      }, {
        children: Children.map(children, child => /*#__PURE__*/cloneElement(child, {
          modifier
        }))
      }))
    })), jsx(IconButton, Object.assign({
      className: buttonClasses,
      disabled: !showNext,
      onClick: () => handleOnClickNavigation('next'),
      type: "button"
    }, {
      children: jsx(FontAwesomeIcon, {
        icon: faCaretRight
      })
    })), showDots && jsx("footer", Object.assign({
      className: footerClasses
    }, {
      children: Children.map(children, (_, index) => jsx("button", {
        className: classNames({
          [classes$b.active]: index * itemWidth + 100 >= currentScrollPosition && (index + 1) * itemWidth <= currentScrollPosition + containerWidth
        }),
        onClick: () => handleOnClickIndicator(index),
        type: "button"
      }, `mark-${index}`))
    }))]
  }));
};
Slider.Slide = Slide;

const classes$a = generateUtilityClasses('GC-SpacedSection', ['small', 'medium', 'large']);
const StyledGrid = styled(Grid$1)(({
  theme
}) => ({
  [`&.${classes$a.small}`]: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  [`&.${classes$a.medium}`]: {
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(5)
  },
  [`&.${classes$a.large}`]: {
    paddingBottom: theme.spacing(7),
    paddingTop: theme.spacing(7)
  }
}));
const SpacedSection = props => {
  const {
      children,
      className,
      px = 'medium'
    } = props,
    rest = __rest(props, ["children", "className", "px"]);
  return jsx(StyledGrid, Object.assign({
    className: classNames({
      [classes$a[px]]: px
    }, className),
    "data-testid": "spaced-section"
  }, rest, {
    children: children
  }));
};

const PREFIX$4 = 'GC-Spinner';
const classes$9 = {
  root: `${PREFIX$4}-root`,
  default: `${PREFIX$4}-default`,
  plain: `${PREFIX$4}-plain`,
  transparent: `${PREFIX$4}-transparent`,
  large: `${PREFIX$4}-large`,
  small: `${PREFIX$4}-small`
};
const StyledBackdrop = styled$1(Backdrop)(({
  theme
}) => ({
  [`&.${classes$9.root}`]: {
    zIndex: 99999
  },
  [`&.${classes$9.default}`]: {
    background: alpha(theme.palette.grey[500], 0.8),
    backdropFilter: 'blur(10px)'
  },
  [`& .${classes$9.large}`]: {
    height: 100,
    width: 100
  },
  [`&.${classes$9.plain}`]: {
    background: theme.palette.common.white
  },
  [`& .${classes$9.small}`]: {
    height: 50,
    width: 50
  },
  [`&.${classes$9.transparent}`]: {
    background: '#00000000'
  }
}));
var SpinnerVariants;
(function (SpinnerVariants) {
  SpinnerVariants["default"] = "default";
  SpinnerVariants["plain"] = "plain";
  SpinnerVariants["transparent"] = "transparent";
})(SpinnerVariants || (SpinnerVariants = {}));
const Spinner = props => {
  const {
      className,
      variant = SpinnerVariants.default,
      size
    } = props,
    rest = __rest(props, ["className", "variant", "size"]);
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      const options = {
        path: '/lottie/spinner.json',
        autoplay: true,
        container: ref.current,
        loop: true,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
      const animation = lottie.loadAnimation(options);
      return () => animation.destroy();
    }
  }, []);
  return jsx(StyledBackdrop, Object.assign({
    "data-testid": "spinner"
  }, rest, {
    className: classNames(classes$9.root, classes$9[variant], className),
    open: true
  }, {
    children: jsx("div", {
      "data-testid": "icon",
      ref: ref,
      className: classes$9[size]
    })
  }));
};

const classes$8 = generateUtilityClasses('GC-Switch', ['root', 'button', 'card', 'leftButton', 'rightButton', 'selected']);
const StyledCard = styled$1(Card)(({
  theme
}) => ({
  [`&.${classes$8.root}`]: {
    boxShadow: theme.shadows[0],
    height: theme.spacing(5.5125),
    marginTop: theme.spacing(0.5),
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      height: theme.spacing(5.875)
    }
  },
  [`& .${classes$8.button}`]: {
    width: theme.spacing(5.5),
    height: '100%'
  },
  [`& .${classes$8.card}`]: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.main,
    height: '100%',
    position: 'absolute',
    top: 0,
    transition: theme.transitions.create(['transform']),
    width: theme.spacing(5.5)
  },
  [`& .${classes$8.leftButton}`]: {
    color: theme.palette.primary.contrastText
  },
  [`& .${classes$8.rightButton}`]: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    borderTopRightRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: 'unset',
    borderTopLeftRadius: 'unset',
    color: theme.palette.grey[300]
  },
  [`&.${classes$8.selected}`]: {
    [`& .${classes$8.card}`]: {
      transform: 'translateX(100%)'
    },
    [`& .${classes$8.leftButton}`]: {
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      borderLeft: `1px solid ${theme.palette.grey[300]}`,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: theme.shape.borderRadius,
      borderBottomRightRadius: 'unset',
      borderTopRightRadius: 'unset',
      color: theme.palette.grey[300]
    },
    [`& .${classes$8.rightButton}`]: {
      border: 'none',
      color: theme.palette.primary.contrastText
    }
  }
}));
const Switch = _a => {
  var {
      left,
      right,
      value = false
    } = _a,
    rest = __rest(_a, ["left", "right", "value"]);
  return jsxs(StyledCard, Object.assign({
    className: classNames(classes$8.root, {
      [classes$8.selected]: value
    })
  }, rest, {
    children: [jsx(Card, {
      className: classes$8.card
    }), jsx(IconButton, Object.assign({
      className: classNames(classes$8.button, classes$8.leftButton)
    }, {
      children: jsx(Typography, Object.assign({
        variant: "body1",
        sx: {
          fontWeight: 600
        }
      }, {
        children: left
      }))
    })), jsx(IconButton, Object.assign({
      className: classNames(classes$8.button, classes$8.rightButton)
    }, {
      children: jsx(Typography, Object.assign({
        variant: "body1",
        sx: {
          fontWeight: 600
        }
      }, {
        children: right
      }))
    }))]
  }));
};

const classes$7 = generateUtilityClasses('teaser', ['root', 'card', 'cardOverlay', 'cardTitle', 'cardCollapse', 'cardDescription', 'cardIconContainer', 'cardIcon']);
const StyledBox$5 = styled$1(Box)(({
  theme
}) => ({
  [`&.${classes$7.root}`]: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      height: '70vh',
      flexDirection: 'row'
    }
  },
  [`& .${classes$7.card}`]: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    color: theme.palette.common.white,
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out'
  },
  [`& .${classes$7['cardOverlay']}`]: {
    position: 'relative',
    display: 'flex',
    padding: theme.spacing(3),
    inset: 'auto 0 0 0',
    backdropFilter: 'blur(4px)',
    background: alpha(theme.palette.grey[500], 0.6)
  },
  [`& .${classes$7['cardTitle']}`]: {
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: '2',
    transition: 'all 0.3s ease-in-out'
  },
  [`& .${classes$7['cardCollapse']}`]: {
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out'
  },
  [`& .${classes$7['cardDescription']}`]: {
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: '3',
    transition: 'all 0.3s ease-in-out',
    marginTop: theme.spacing(3)
  },
  [`& .${classes$7['cardIconContainer']}`]: {
    color: theme.palette.common.white,
    alignSelf: 'end',
    inset: 'auto 0 0 auto',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40px',
    minHeight: '40px',
    border: `1px solid ${theme.palette.common.white}`
  },
  [`& .${classes$7['cardIcon']}`]: {
    verticalAlign: 'center',
    textAlign: 'center',
    width: '20px',
    height: '20px'
  }
}));

function Teaser({
  children
}) {
  return jsx(StyledBox$5, Object.assign({
    className: classes$7.root
  }, {
    children: children
  }));
}

function TeaserCard({
  button_label,
  button_link,
  description,
  expanded,
  image,
  onClick,
  title
}) {
  return jsxs(Box, Object.assign({
    className: classes$7.card,
    flex: expanded ? 3 : 1,
    flexGrow: expanded ? 3 : 1,
    minHeight: {
      xs: expanded ? '400px' : '200px',
      md: undefined
    },
    onClick: () => onClick(expanded)
  }, {
    children: [image, jsx(Box, Object.assign({
      className: classes$7.cardOverlay
    }, {
      children: jsxs(Stack, Object.assign({
        direction: "row",
        justifyContent: "space-between",
        width: "100%"
      }, {
        children: [jsxs(Stack, Object.assign({
          direction: "column",
          minHeight: "60px"
        }, {
          children: [jsx(Typography, Object.assign({
            className: classes$7.cardTitle,
            component: "p",
            variant: expanded ? 'h3' : 'h4'
          }, {
            children: title
          })), jsxs(Box, Object.assign({
            className: classes$7.cardCollapse,
            maxHeight: {
              xs: expanded ? '400px' : 0
            }
          }, {
            children: [jsx(Typography, Object.assign({
              className: classes$7.cardDescription,
              variant: "body1"
            }, {
              children: description
            })), jsx(Button, Object.assign({
              endIcon: jsx(FontAwesomeIcon, {
                icon: faAngleRight
              }),
              href: button_link,
              modifier: "dark",
              onClick: e => e.stopPropagation(),
              sx: {
                mt: 3
              },
              variant: "secondary"
            }, {
              children: button_label
            }))]
          }))]
        })), jsx(Box, Object.assign({
          className: classes$7.cardIconContainer,
          mb: expanded ? 3 : undefined,
          ml: expanded ? undefined : 3,
          mr: expanded ? 3 : undefined,
          position: expanded ? 'absolute' : undefined
        }, {
          children: jsx(FontAwesomeIcon, {
            className: classes$7.cardIcon,
            icon: expanded ? faXmark : faInfo
          })
        }))]
      }))
    }))]
  }));
}

const classes$6 = generateUtilityClasses('GC-ToggleButtonGroup', ['button', 'dark', 'label', 'light', 'selected', 'stretch']);
const StyledTabs = styled(Tabs)(({
  theme
}) => ({
  minHeight: 'unset',
  [`&.${classes$6.stretch}`]: {
    width: '100%'
  },
  [`& .${classes$6.button}`]: {
    backgroundColor: theme.palette.common.transparent,
    border: `1px solid ${theme.palette.grey[300]}`,
    color: theme.palette.grey[300],
    height: 40,
    minWidth: 52,
    minHeight: 'unset',
    padding: theme.spacing(1.5, 2),
    svg: {
      marginRight: 0
    },
    '&:last-of-type': {
      borderTopRightRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius
    },
    '&:first-of-type': {
      borderTopLeftRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: theme.shape.borderRadius
    },
    [`&.${classes$6.dark}`]: {
      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          backgroundColor: alpha(theme.palette.common.white, 0.1),
          color: theme.palette.common.white
        }
      }
    },
    [`&.${classes$6.light}`]: {
      '@media (hover: hover) and (pointer: fine)': {
        '&:hover': {
          backgroundColor: alpha(theme.palette.grey[500], 0.1),
          color: theme.palette.grey[500]
        }
      }
    },
    [`&.${classes$6.selected}`]: {
      '& + button': {
        borderLeftColor: theme.palette.common.transparent
      },
      [`&.${classes$6.dark}`]: {
        borderColor: theme.palette.common.white,
        color: theme.palette.common.white
      },
      [`&.${classes$6.light}`]: {
        borderColor: theme.palette.grey[500],
        color: theme.palette.grey[500]
      }
    },
    [`&:not(.${classes$6.selected})`]: {
      '&:not(:last-of-type)': {
        borderRightColor: theme.palette.common.transparent
      }
    },
    [`&.${classes$6.stretch}`]: {
      flexGrow: 1
    }
  },
  [`& .${classes$6.label}`]: {
    whiteSpace: 'nowrap'
  }
}));
//To fix the scroll arrow buttons position. There is an unneeded extra space from MUI TabScrollButton.
const StyledTabScrollButton = styled(TabScrollButton)(({
  theme
}) => ({
  overflow: 'hidden',
  transition: theme.transitions.create('width', {
    duration: '0.3s'
  }),
  width: 28,
  '&.Mui-disabled': {
    width: 0
  }
}));

const ToggleButtonLabel = props => {
  const {
    allowCollapsedLabelUpMobile,
    hasIcon,
    isSelected,
    label,
    smallFont
  } = props;
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), {
    noSsr: true
  });
  const hasIconAndLabel = hasIcon && label;
  const allowedCollapsedLabelUpMobile = !isMobile && allowCollapsedLabelUpMobile;
  const hasLabelAnimation = hasIconAndLabel && (isMobile || allowedCollapsedLabelUpMobile);
  const labelComponent = jsx(Typography, Object.assign({
    className: classes$6.label,
    variant: smallFont ? 'button2' : 'button1',
    ml: hasIcon && label && 1
  }, {
    children: label
  }));
  return hasLabelAnimation ? jsx(Collapse, Object.assign({
    in: isSelected,
    orientation: "horizontal",
    unmountOnExit: true
  }, {
    children: labelComponent
  })) : labelComponent;
};

const ToggleButtonGroup = props => {
  var _a;
  const {
      allowCollapsedLabelUpMobile = false,
      buttonsData,
      fullWidth = false,
      modifier = 'light',
      onClick,
      selected,
      smallFont = false
    } = props,
    rest = __rest(props, ["allowCollapsedLabelUpMobile", "buttonsData", "fullWidth", "modifier", "onClick", "selected", "smallFont"]);
  return jsx(StyledTabs, Object.assign({
    className: classNames({
      [classes$6.stretch]: fullWidth
    }),
    onChange: onClick,
    scrollButtons: "auto",
    ScrollButtonComponent: StyledTabScrollButton,
    TabIndicatorProps: {
      style: {
        backgroundColor: 'unset'
      }
    },
    value: selected,
    variant: "scrollable"
  }, rest, {
    children: (_a = buttonsData || []) === null || _a === void 0 ? void 0 : _a.map(({
      icon,
      label,
      value
    }) => {
      const isSelected = (value === null || value === void 0 ? void 0 : value.toLowerCase()) === (selected === null || selected === void 0 ? void 0 : selected.toLowerCase());
      const buttonLabelProps = {
        allowCollapsedLabelUpMobile,
        hasIcon: Boolean(icon),
        isSelected,
        label,
        smallFont
      };
      return jsx(Tab, {
        className: classNames(classes$6.button, {
          [classes$6.selected]: isSelected,
          [classes$6[modifier]]: modifier,
          [classes$6.stretch]: fullWidth
        }),
        icon: icon,
        iconPosition: "start",
        label: jsx(ToggleButtonLabel, Object.assign({}, buttonLabelProps)),
        role: "button",
        value: value
      }, value);
    })
  }));
};

const classes$5 = generateUtilityClasses('ProductsSkeletonLoader', ['category', 'skeletonItemWrapper', 'title']);
const showAnimation = keyframes({
  from: {
    opacity: 0,
    transform: 'translateY(-5px)'
  },
  to: {
    opacity: 1,
    transform: 'translateY(0)'
  }
});
const StyledBox$4 = styled(Box)(({
  theme
}) => ({
  [`& .${classes$5.category}`]: {
    backgroundColor: theme.palette.grey[200],
    height: 30,
    maxWidth: 350
  },
  [`& .${classes$5.skeletonItemWrapper}`]: {
    animation: `${showAnimation} 0.3s linear`,
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0.5)
  },
  [`& .${classes$5.title}`]: {
    backgroundColor: theme.palette.grey[200],
    height: 40,
    maxWidth: 150
  }
}));

const LoadingMenu = () => {
  return jsx(StyledBox$4, Object.assign({
    role: "status"
  }, {
    children: jsxs(Box, Object.assign({
      className: classes$5.skeletonItemWrapper
    }, {
      children: [jsx(Skeleton, {
        className: classes$5.title,
        variant: "text",
        role: "skeleton"
      }), jsx(Skeleton, {
        className: classes$5.category,
        variant: "text",
        role: "skeleton"
      }), jsx(Skeleton, {
        className: classes$5.category,
        variant: "text",
        role: "skeleton"
      }), jsx(Skeleton, {
        className: classes$5.category,
        variant: "text",
        role: "skeleton"
      })]
    }))
  }));
};

const StyledBox$3 = styled(Box)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  cursor: 'pointer',
  '&:hover': {
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      color: theme.palette.primary.main,
      transition: 'color 0.2s ease-in-out',
      svg: {
        color: theme.palette.primary.main,
        transition: 'color 0.2s ease-in-out'
      }
    }
  },
  marginTop: theme.spacing(2)
}));

const LoggedInMenu = props => {
  const {
    company,
    image,
    menuItems,
    name
  } = props;
  return jsxs(Box, Object.assign({
    sx: {
      svg: {
        maxHeight: '16px',
        maxWidth: '16px',
        minHeight: '16px',
        minWidth: '16px'
      }
    }
  }, {
    children: [jsx(Box, Object.assign({
      mt: 3,
      display: "flex"
    }, {
      children: jsxs(Fragment, {
        children: [image && image, jsxs(Box, Object.assign({
          ml: 2
        }, {
          children: [jsx(Typography, Object.assign({
            variant: "h4"
          }, {
            children: name
          })), jsx(Typography, Object.assign({
            color: "grey.400",
            variant: "caption"
          }, {
            children: company
          }))]
        }))]
      })
    })), jsx(Box, Object.assign({
      pt: 1
    }, {
      children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(({
        text,
        icon,
        link
      }, index) => jsx(Link$1, Object.assign({
        href: link !== null && link !== void 0 ? link : ''
      }, {
        children: jsxs(StyledBox$3, {
          children: [icon, jsx(Typography, Object.assign({
            ml: 2,
            variant: "body1"
          }, {
            children: text
          }))]
        })
      }), index))
    }))]
  }));
};

const LoggedOutMenu = props => {
  const {
    title,
    subtitle,
    menuItems
  } = props;
  return jsxs(Box, Object.assign({
    mt: 1,
    mb: 3,
    sx: {
      svg: {
        maxHeight: '16px',
        maxWidth: '16px',
        minHeight: '16px',
        minWidth: '16px'
      }
    }
  }, {
    children: [jsx(Typography, Object.assign({
      variant: "h4"
    }, {
      children: title
    })), jsx(Typography, Object.assign({
      variant: "body2",
      mt: 2
    }, {
      children: subtitle
    })), jsx(Box, Object.assign({
      display: "flex",
      flexDirection: "column",
      mt: 0.5
    }, {
      children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(({
        text,
        icon
      }, index) => jsxs(Box, Object.assign({
        alignItems: "start",
        display: "flex",
        mt: 1.5
      }, {
        children: [icon, jsx(Typography, Object.assign({
          variant: "body2",
          ml: 2
        }, {
          children: text
        }))]
      }), index))
    }))]
  }));
};

const classes$4 = generateUtilityClasses('GC-FloatingCard', ['divider', 'stack', 'visibilityIcon']);
const Root$1 = styled('div')(({
  theme
}) => ({
  svg: {
    maxHeight: '16px',
    maxWidth: '16px',
    minHeight: '16px',
    minWidth: '16px'
  },
  [`& .${classes$4.divider}`]: {
    backgroundColor: theme.palette.grey[300],
    borderRadius: 3,
    height: 1,
    marginTop: theme.spacing(3),
    width: '100%'
  },
  [`& .${classes$4.stack}`]: {
    cursor: 'pointer'
  },
  [`& .${classes$4.visibilityIcon}`]: {
    margin: theme.spacing('auto', 0)
  }
}));

const FloatingCard = props => {
  const {
    assistantName,
    contactLinks,
    onHideFromNavBarClick
  } = props;
  const {
    t
  } = useComponentsConfig();
  const title = t('myGRIMME_contact_assistant', 'Kontakt-Assistent');
  return jsxs(Root$1, Object.assign({
    "data-testid": "floating-card"
  }, {
    children: [jsx(Box, {
      className: classes$4.divider
    }), jsx(Box, Object.assign({
      mb: 2,
      mt: 3
    }, {
      children: jsx(Typography, Object.assign({
        color: "grey.300",
        variant: "overline"
      }, {
        children: title
      }))
    })), jsxs(Stack, Object.assign({
      className: classes$4.stack,
      "data-testid": "visibility-icon",
      direction: 'row',
      justifyContent: 'space-between',
      onClick: e => {
        e.stopPropagation();
        onHideFromNavBarClick(e);
      }
    }, {
      children: [jsx(Typography, Object.assign({
        variant: "h5",
        textAlign: 'center'
      }, {
        children: assistantName
      })), jsx(FontAwesomeIcon, {
        className: classes$4.visibilityIcon,
        icon: faEye
      })]
    })), contactLinks]
  }));
};

const PREFIX$3 = 'GC-AuthButtons';
const classes$3 = generateUtilityClasses(PREFIX$3, ['divider', 'logoutWrapper', 'logoutButton', 'loginRegisterWrapper', 'loginButton', 'registerButton']);
const StyledBox$2 = styled$2(Box)(() => ({
  [`& .${classes$3.divider}`]: {
    backgroundColor: theme.palette.grey[300],
    borderRadius: 3,
    height: 1,
    marginTop: theme.spacing(3),
    width: '100%'
  },
  [`& .${classes$3.logoutWrapper}`]: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  [`& .${classes$3.logoutButton}`]: {
    marginTop: theme.spacing(1),
    width: '100%'
  },
  [`& .${classes$3.loginRegisterWrapper}`]: {
    marginTop: theme.spacing(3),
    width: '100%'
  },
  [`& .${classes$3.loginButton}`]: {
    width: '100%'
  },
  [`& .${classes$3.registerButton}`]: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

const AuthButtons = props => {
  const {
    isLoading,
    isSessionValid,
    onLogin,
    onLogout,
    onRegister
  } = props;
  const {
    t
  } = useComponentsConfig();
  return jsxs(StyledBox$2, Object.assign({
    "data-testid": "auth-buttons"
  }, {
    children: [isSessionValid || isLoading ? jsx(Box, Object.assign({
      className: classes$3.logoutWrapper
    }, {
      children: jsx(Button, Object.assign({
        className: classes$3.logoutButton,
        loading: isLoading,
        onClick: onLogout,
        variant: "secondary"
      }, {
        children: t('myGRIMME_logout', 'Abmelden')
      }))
    })) : jsxs(Box, Object.assign({
      className: classes$3.loginRegisterWrapper
    }, {
      children: [jsx(Button, Object.assign({
        className: classes$3.loginButton,
        onClick: onLogin,
        variant: "primary"
      }, {
        children: t('myGRIMME_login', 'Anmelden')
      })), jsx(Button, Object.assign({
        className: classes$3.registerButton,
        onClick: onRegister,
        variant: "secondary"
      }, {
        children: t('myGRIMME_new_registration', 'Neue Registrieren')
      }))]
    })), jsx(Box, {
      className: classes$3.divider
    })]
  }));
};

const PREFIX$2 = 'GC-GeolocationBox';
const classes$2 = generateUtilityClasses(PREFIX$2, ['root', 'flagIcon']);
const StyledBox$1 = styled$1(Box)(({
  theme
}) => ({
  [`&.${classes$2.root}`]: {
    marginTop: theme.spacing(2)
  },
  [`& .${classes$2.flagIcon}`]: {
    height: theme.spacing(3.5),
    width: theme.spacing(3.5),
    marginRight: -theme.spacing(0.6),
    borderRadius: theme.shape.borderRadius
  }
}));
const GeolocationBox = props => {
  const {
    geolocation
  } = props;
  const {
    t
  } = useComponentsConfig();
  return jsx(StyledBox$1, Object.assign({
    className: classes$2.root
  }, {
    children: jsx(TextField, {
      label: t('myGRIMME_usersettings_region', 'Region'),
      fullWidth: true,
      disabled: true,
      value: geolocation === null || geolocation === void 0 ? void 0 : geolocation.countryName,
      InputProps: {
        endAdornment: jsx(Avatar, {
          className: classes$2.flagIcon,
          variant: "square",
          src: geolocation === null || geolocation === void 0 ? void 0 : geolocation.countryFlag,
          alt: t('myGRIMME_usersettings_flag', 'Region Flag')
        })
      }
    })
  }));
};

const PREFIX$1 = 'GC-SupportedLanguageBox';
const classes$1 = generateUtilityClasses(PREFIX$1, ['root', 'flagIcon']);
const StyledBox = styled$1(Box)(({
  theme
}) => ({
  [`&.${classes$1.root}`]: {
    marginTop: theme.spacing(2)
  }
}));
const SupportedLanguagesBox = props => {
  const {
    onLanguageChange,
    supportedLanguages
  } = props;
  const {
    t,
    language
  } = useComponentsConfig();
  const languageLabel = t('myGRIMME_usersettings_language', 'Sprache');
  const languageOptions = supportedLanguages.map(language => {
    return {
      value: language.value,
      label: language.name
    };
  });
  return jsx(StyledBox, Object.assign({
    className: classes$1.root,
    "data-testid": "language-container"
  }, {
    children: jsx(Select, {
      "data-testid": "language-select",
      fullWidth: true,
      label: languageLabel,
      onChange: e => onLanguageChange(e.target.value),
      options: languageOptions,
      value: language
    })
  }));
};

const classes = generateUtilityClasses('GC-UserSettingsContent', ['closeIcon', 'iconsWrapper', 'logo']);
const Root = styled$1(Box)(({
  theme
}) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(1)
  },
  [`& .${classes.iconsWrapper}`]: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      justifyContent: 'end'
    }
  },
  [`& .${classes.logo}`]: {
    cursor: 'pointer',
    height: theme.spacing(3),
    width: 'auto'
  },
  [`& .${classes.closeIcon}`]: {
    width: 48,
    height: 48,
    [theme.breakpoints.up(theme.breakpoints.values.sm)]: {
      display: 'none'
    }
  }
}));

const UserSettingsContent = props => {
  const {
    MenuComponent,
    contactLinks,
    contactName,
    geolocation,
    isLoading,
    isSessionValid,
    isShowingContact,
    onClose,
    onHideContact,
    onLanguageChange,
    onLogin,
    onLogoClick,
    onLogout,
    onRegister,
    supportedLanguages
  } = props;
  const {
    t
  } = useComponentsConfig();
  const Logo = MyGrimmeLogo;
  return jsxs(Root, {
    children: [jsxs(Box, Object.assign({
      className: classes.iconsWrapper
    }, {
      children: [jsx(Logo, {
        className: classes.logo,
        modifier: "bright",
        onClick: onLogoClick
      }), jsx(IconButton, Object.assign({
        className: classes.closeIcon,
        onClick: onClose
      }, {
        children: jsx(FontAwesomeIcon, {
          color: "black",
          icon: faXmark
        })
      }))]
    })), MenuComponent, jsx(AuthButtons, {
      isLoading: isLoading,
      isSessionValid: isSessionValid,
      onLogin: onLogin,
      onLogout: onLogout,
      onRegister: onRegister
    }), jsx(Grid$1, {
      children: jsxs(Box, Object.assign({
        mt: 2,
        flexDirection: "column"
      }, {
        children: [jsx(Typography, Object.assign({
          color: "grey.400",
          mb: 2,
          variant: "overline"
        }, {
          children: t('myGRIMME_usersettings_change_language', 'Sprache wechseln')
        })), supportedLanguages && jsx(SupportedLanguagesBox, {
          supportedLanguages: supportedLanguages,
          onLanguageChange: onLanguageChange
        }), geolocation && jsx(GeolocationBox, {
          geolocation: geolocation
        })]
      }))
    }), isShowingContact && jsx(FloatingCard, {
      assistantName: contactName,
      contactLinks: contactLinks,
      onHideFromNavBarClick: onHideContact
    })]
  });
};

const PREFIX = 'UserSettingsMenu';
const popoverClasses = generateUtilityClasses(PREFIX, ['root', 'paper']);
const drawerClasses = generateUtilityClasses(PREFIX, ['drawerPaper', 'modal']);
const StyledPopover = styled(Popover)(({
  theme
}) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  },
  [`& .${popoverClasses.root}`]: {
    padding: theme.spacing(2),
    width: theme.spacing(30)
  },
  [`& .${popoverClasses.paper}`]: {
    borderRadius: 8,
    width: 400
  }
}));
const StyledDrawer = styled(Drawer$1)(({
  theme
}) => ({
  zIndex: 1202,
  [theme.breakpoints.up('sm')]: {
    display: 'none'
  },
  [`& .${drawerClasses.drawerPaper}`]: {
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      width: 0,
      height: 0
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    }
  }
}));

const UserSettingsMenu = props => {
  var _a;
  const {
      open,
      children
    } = props,
    rest = __rest(props, ["open", "children"]);
  return jsxs(Fragment, {
    children: [jsx(StyledDrawer, Object.assign({
      anchor: "top",
      "data-testid": "user-settings-drawer",
      open: open,
      PaperProps: {
        className: drawerClasses.drawerPaper
      }
    }, {
      children: children
    })), jsx(StyledPopover, Object.assign({
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      "data-testid": "user-settings-popover",
      disableScrollLock: true,
      open: open,
      PaperProps: {
        className: classNames(popoverClasses.paper, (_a = props.PaperProps) === null || _a === void 0 ? void 0 : _a.className)
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    }, rest, {
      children: children
    }))]
  });
};

export { BlogCard, Breadcrumb, Breadcrumbs, Button, ButtonGroup, Chip, ComponentsConfigProvider, ContactAssistant, CtasSection, DEFAULT_NOTIFICATION_MESSAGE, DatePicker, Dialog, Dropdown, ErrorPage, FeatureCard, FeaturedSection, Footer, GallerySlider, GrimmeComponentsProvider, GrimmeLogo, Hero, LightBox, Loader, LoaderVariants, LoadingIndicator, LoadingMenu, LocalizationProvider, LoggedInMenu, LoggedOutMenu, LoginWithMyGRIMME, MyGrimmeLogo, Navbar, Newsletter, PageTitle, ProductCard, Select, SelectionCard, SeoSection, Slide, Slider, SpacedSection, Spinner, SpinnerVariants, Switch, Teaser, TeaserCard, TextField, TitleDivider, ToggleButtonGroup, UsedMachineCard, UserSettingsContent, UserSettingsMenu, classes$M as breadcrumbsClasses, notificationType, notificationsActions, selectNotifications, selectNotificationsState, withNotificationsReducer };
